"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const axios_1 = tslib_1.__importDefault(require("axios"));
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_2 = require("typeorm");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const look_up_service_1 = require("../../../../org-service/src/app/look-up/look-up.service");
const constants_2 = require("../../../../service-lib/src/lib/constants");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const response_util_1 = require("../../../../service-lib/src/lib/response.util");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const meeting_service_1 = require("../meeting/meeting.service");
const task_service_1 = require("../task/task.service");
const employee_service_1 = require("../../../../org-service/src/app/employee/employee.service");
const create_broking_slip_version_dto_1 = require("./dto/create-broking-slip-version.dto");
const create_data_validation_dto_1 = require("./dto/create-data-validation.dto");
const create_final_negotiation_activity_dto_1 = require("./dto/create-final-negotiation-activity.dto");
const create_hand_over_meet_dto_1 = require("./dto/create-hand-over-meet.dto");
const create_held_cover_note_dto_1 = require("./dto/create-held-cover-note.dto");
const create_kdm_meeting_dto_1 = require("./dto/create-kdm-meeting.dto");
const create_mandate_details_dto_1 = require("./dto/create-mandate-details.dto");
const create_opportunity_lost_dto_1 = require("./dto/create-opportunity-lost.dto");
const create_placement_slip_dto_1 = require("./dto/create-placement-slip.dto");
const create_policy_confirmation_dto_1 = require("./dto/create-policy-confirmation.dto");
const create_policy_docket_dto_1 = require("./dto/create-policy-docket.dto");
const create_policy_hard_copy_dto_1 = require("./dto/create-policy-hard-copy.dto");
const create_premium_calculation_dto_1 = require("./dto/create-premium-calculation.dto");
const update_premium_calculation_dto_1 = require("./dto/update-premium-calculation.dto");
const create_quote_comparison_report_dto_1 = require("./dto/create-quote-comparison-report.dto");
const create_quote_entry_dto_1 = require("./dto/create-quote-entry.dto");
const create_rfp_cover_detail_dto_1 = require("./dto/create-rfp-cover-detail.dto");
const update_rfp_cover_detail_dto_1 = require("./dto/update-rfp-cover-detail.dto");
const opportunity_rfp_details_entry_dto_1 = require("./dto/opportunity-rfp-details-entry.dto");
const update_final_negotiation_activity_dto_1 = require("./dto/update-final-negotiation-activity.dto");
const update_held_cover_note_dto_1 = require("./dto/update-held-cover-note.dto");
const update_policy_confirmation_dto_1 = require("./dto/update-policy-confirmation.dto");
const update_policy_docket_1 = require("./dto/update-policy-docket");
const update_policy_hard_copy_dto_1 = require("./dto/update-policy-hard-copy.dto");
const update_quote_comparison_report_dto_1 = require("./dto/update-quote-comparison-report.dto");
const opportunity_repository_1 = require("./opportunity.repository");
const environment_1 = require("../../../../service-lib/src/lib/environment");
const notification_utils_1 = require("../../../../service-lib/src/lib/utils/notification.utils");
let OpportunityService = class OpportunityService {
    constructor(dataSource, opportunityRepository, LookUpService, lookUpValidation, taskService, employeeService, meetingService, notificationUtils, lookUpRepository, opportunityActivityMapRepository, opportunityRepo, meetingRepo, opportunityFinalNegotiationRepo, dataValidationRepo, kdmMeetingRepo, opportunityHandOverMeetRepo) {
        this.dataSource = dataSource;
        this.opportunityRepository = opportunityRepository;
        this.LookUpService = LookUpService;
        this.lookUpValidation = lookUpValidation;
        this.taskService = taskService;
        this.employeeService = employeeService;
        this.meetingService = meetingService;
        this.notificationUtils = notificationUtils;
        this.lookUpRepository = lookUpRepository;
        this.opportunityActivityMapRepository = opportunityActivityMapRepository;
        this.opportunityRepo = opportunityRepo;
        this.meetingRepo = meetingRepo;
        this.opportunityFinalNegotiationRepo = opportunityFinalNegotiationRepo;
        this.dataValidationRepo = dataValidationRepo;
        this.kdmMeetingRepo = kdmMeetingRepo;
        this.opportunityHandOverMeetRepo = opportunityHandOverMeetRepo;
    }
    // Retrieves a list of opportunities by delegating the repository.
    async getAllOpportunityList(page, limit, search, sort, searchBy, userId, field, fromDate, toDate, period) {
        try {
            if (search) {
                const ownedByMatch = search.match(constants_1.EMPLOYEE_ID_FOR_HIERARCHY_TREE_REGEX);
                const ownedById = ownedByMatch ? ownedByMatch[1] : null;
                const cleanedString = search.replace(constants_1.SEARCH_STRING_FOR_OPPORTUNITIES_FETCH_REGEX, "");
                search = cleanedString.trim();
                if (ownedById) {
                    userId = parseInt(ownedById);
                }
            }
            const searchParams = (0, helper_utils_1.mapSearchParams)(search);
            let sortParams = (0, helper_utils_1.mapSortParams)(sort);
            if (sortParams) {
                const companySortOrderSearch = sortParams.find((item) => item.field === constants_2.sortRealtionsMapping.PARENT_COMPANY_INDUSTRY_SORT_KEY);
                if (companySortOrderSearch) {
                    companySortOrderSearch.field =
                        constants_2.sortRealtionsMapping.PARENT_COMPANY_INDUSTRY_SORT;
                }
                const prioritySortOrderSearch = sortParams.find((item) => item.field === constants_2.sortRealtionsMapping.PARENT_PRIORITY_SORT_KEY);
                if (prioritySortOrderSearch) {
                    prioritySortOrderSearch.field =
                        constants_2.sortRealtionsMapping.PARENT_PRIORITY_SORT;
                }
                sortParams = sortParams.filter((item) => item.field !== constants_2.sortRealtionsMapping.PARENT_BRANCH_SORT_KEY);
            }
            const opportunities = await this.opportunityRepository.getAllOpportunities(page, limit, searchParams, sortParams, searchBy, userId, field, fromDate, toDate, period);
            return opportunities;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error; // Re-throw NotFoundException to be handled by the controller
            }
            throw new common_1.BadRequestException(`${messages_1.errorMessages.opportunityListRetrievalFailed} ${error instanceof Error ? error.message : ""}`);
        }
    }
    // Creates a new opportunity by delegating the repository.
    async createOpportunity(createOpportunityDto, riskLocations, claimExperiences, documents, previousPlacementDetails, opportunityPreviousMediatorDetails, contacts, userId) {
        const response = await this.dataSource.transaction(async (entityManager) => {
            try {
                // Create the opportunity and get its ID
                const opportunityData = createOpportunityDto;
                await this.lookUpValidation.validateDynamicLookupValues(createOpportunityDto, constants_1.LOOK_UP_DATA);
                const opportunity = await this.opportunityRepository.createOpportunity(entityManager, opportunityData);
                // Keeping the priority true for testing purpose
                const isPriorityOpportunity = opportunity.sumInsured >= constants_2.OPTY_SUM_INSURED_NOTIFICATION_THRESHOLD;
                const url = `${environment_1.ENV.CLIENT_SERVER_URL}opportunities/${opportunity.opportunityId}`;
                if (isPriorityOpportunity) {
                    await this.sendNotification(constants_2.NOTIFICATION_EVENT_TYPES.High_Value_Opportunity_Creation, url, userId, true, true);
                }
                else {
                    await this.sendNotification(constants_2.NOTIFICATION_EVENT_TYPES.OPPORTUNITY_CREATION, url, userId, false, true);
                }
                // Create risk locations
                if (riskLocations && riskLocations.length > 0) {
                    for (const riskLocation of riskLocations) {
                        await this.opportunityRepository.createRiskLocation(entityManager, {
                            opportunityId: opportunity.opportunityId,
                            addressId: riskLocation.addressId,
                        });
                    }
                }
                // Create claim experiences
                if (claimExperiences && claimExperiences.length > 0) {
                    for (const claimExperience of claimExperiences) {
                        await this.opportunityRepository.createClaimExperience(entityManager, {
                            ...claimExperience,
                            opportunityId: opportunity.opportunityId,
                        });
                    }
                }
                // Create documents
                if (documents && documents.length > 0) {
                    for (const document of documents) {
                        await this.opportunityRepository.createOppDocument(entityManager, {
                            ...document,
                            opportunityId: opportunity.opportunityId,
                        });
                    }
                }
                // Create previous placement details
                if (previousPlacementDetails && previousPlacementDetails.length > 0) {
                    for (const previousPlacementDetail of previousPlacementDetails) {
                        await this.opportunityRepository.createPreviousPlacementDetails(entityManager, {
                            ...previousPlacementDetail,
                            opportunityId: opportunity.opportunityId,
                        });
                    }
                }
                // Create previous mediator details
                if (opportunityPreviousMediatorDetails &&
                    opportunityPreviousMediatorDetails.length > 0) {
                    for (const previousMediatorDetail of opportunityPreviousMediatorDetails) {
                        await this.opportunityRepository.createPreviousMediatorDetails(entityManager, {
                            ...previousMediatorDetail,
                            opportunityId: opportunity.opportunityId,
                        });
                    }
                }
                if (contacts && contacts.length > 0) {
                    for (const contact of contacts) {
                        await this.opportunityRepository.createContactMap(entityManager, {
                            ...contact,
                            opportunityId: opportunity.opportunityId,
                            companyId: opportunityData.companyId,
                        });
                    }
                }
                delete opportunity?.createdBy;
                delete opportunity?.updatedBy;
                delete opportunity?.createdAt;
                delete opportunity?.updatedAt;
                delete opportunity?.deletedAt;
                if (opportunity) {
                    await this.opportunityRepository.createStageActivityMap(entityManager, opportunity.opportunityId, opportunity.policyTypeLid, createOpportunityDto.createdBy);
                    await this.opportunityRepository.storeCovers(entityManager, opportunity.opportunityId, opportunity.policyTypeLid);
                }
                return opportunity;
            }
            catch (error) {
                throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.opportunityCreationFailed));
            }
        });
        if (response.opportunityId !== undefined &&
            response.opportunityId !== null) {
            const data = await this.opportunityRepository.getOpportunityById(response.opportunityId);
            return data;
        }
    }
    // Retrieves an opportunity by its ID by delegating the repository.
    async getOpportunityById(opportunityId, userId) {
        try {
            const opportunity = await this.opportunityRepository.getOpportunityById(opportunityId, userId);
            if (!opportunity) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotFound);
            }
            return opportunity;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.opportunityDetailsRetrievalFailed);
        }
    }
    // Updates an existing opportunity by its ID by delegating the repository.
    async updateOpportunityById(opportunityId, updateOpportunityDto, updateRiskLocations, updateClaimExperiences, updateDocuments, updatePreviousPlacementDetails, updateOpportunityPreviousMediatorDetails, updateContacts, userId) {
        const response = await this.dataSource.transaction(async (entityManager) => {
            try {
                const { riskLocations, claimExperiences, documents, previousPlacementDetails, opportunityPreviousMediatorDetails, contacts, ...opportunityData } = updateOpportunityDto;
                await this.lookUpValidation.validateDynamicLookupValues(updateOpportunityDto, constants_1.LOOK_UP_DATA);
                // Update the opportunity by its ID
                const opportunity = await this.opportunityRepository.updateOpportunity(entityManager, opportunityId, opportunityData, userId);
                // Update risk locations
                if (updateRiskLocations && updateRiskLocations.length > 0) {
                    await this.opportunityRepository.updateRiskLocations(entityManager, opportunityId, updateRiskLocations);
                }
                // Update claim experiences
                if (updateClaimExperiences && updateClaimExperiences.length > 0) {
                    for (const claimExperience of updateClaimExperiences) {
                        if (claimExperience.id) {
                            // Check if the claim experience exists in OpportunityClaimExperiences table
                            const existingClaimExperience = await this.opportunityRepository.getClaimExperienceByIdAndOpportunityId(claimExperience.id, opportunityId);
                            // Update the existing claim experience
                            if (existingClaimExperience) {
                                await this.opportunityRepository.updateClaimExperience(entityManager, {
                                    ...claimExperience,
                                    opportunityId,
                                });
                            }
                        }
                        else {
                            // Create a new claim experience
                            await this.opportunityRepository.createClaimExperience(entityManager, {
                                ...claimExperience,
                                opportunityId,
                            });
                        }
                    }
                }
                // Update documents
                if (updateDocuments && updateDocuments.length > 0) {
                    for (const document of updateDocuments) {
                        // Check if the document exists in OpportunityDocuments table
                        const existingDocument = await this.opportunityRepository.getDocumentByIdAndOpportunityId(document.documentId, opportunityId);
                        // If the document exists, do nothing
                        if (!existingDocument) {
                            await this.opportunityRepository.createOppDocument(entityManager, {
                                ...document,
                                opportunityId,
                            });
                        }
                    }
                }
                // Update previous placement details
                if (updatePreviousPlacementDetails &&
                    updatePreviousPlacementDetails.length > 0) {
                    for (const previousPlacementDetail of updatePreviousPlacementDetails) {
                        if (previousPlacementDetail.id) {
                            const existingPreviousPlacementDetail = await this.opportunityRepository.getPreviousPlacementDetailsByIdAndOpportunityId(previousPlacementDetail.id, opportunityId);
                            if (existingPreviousPlacementDetail) {
                                await this.opportunityRepository.updatePreviousPlacementDetails(entityManager, {
                                    ...previousPlacementDetail,
                                    opportunityId,
                                });
                            }
                        }
                        else {
                            await this.opportunityRepository.createPreviousPlacementDetails(entityManager, {
                                ...previousPlacementDetail,
                                opportunityId,
                            });
                        }
                    }
                }
                // Update previous mediator details
                if (updateOpportunityPreviousMediatorDetails &&
                    updateOpportunityPreviousMediatorDetails.length > 0) {
                    for (const previousMediatorDetail of updateOpportunityPreviousMediatorDetails) {
                        if (previousMediatorDetail.id) {
                            // Check if the previous mediator detail exists in OpportunityPreviousMediatorDetails table
                            const existingPreviousMediatorDetail = await this.opportunityRepository.getPreviousMediatorDetailsByIdAndOpportunityId(previousMediatorDetail.id, opportunityId);
                            // Update the existing previous mediator detail
                            if (existingPreviousMediatorDetail) {
                                await this.opportunityRepository.updatePreviousMediatorDetails(entityManager, {
                                    ...previousMediatorDetail,
                                    opportunityId,
                                });
                            }
                        }
                        else {
                            // Create a new previous mediator detail
                            await this.opportunityRepository.createPreviousMediatorDetails(entityManager, {
                                ...previousMediatorDetail,
                                opportunityId,
                            });
                        }
                    }
                }
                // Update contacts
                if (updateContacts && updateContacts.length > 0) {
                    await this.opportunityRepository.updateContactMap(entityManager, opportunityId, updateContacts);
                }
                return { id: opportunityId };
            }
            catch (error) {
                throw error instanceof common_1.NotFoundException
                    ? error
                    : new common_1.BadRequestException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error
                        ? error.message
                        : messages_1.errorMessages.opportunityUpdateFailed));
            }
        });
        if (response.id !== undefined && response.id !== null) {
            const data = await this.opportunityRepository.getOpportunityById(response.id);
            return data;
        }
    }
    // Deletes an opportunity by its ID by delegating the repository.
    async deleteOpportunityById(opportunityId) {
        try {
            return this.opportunityRepository.deleteOpportunityById(opportunityId);
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.InternalServerErrorException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.opportunityDeletionFailed);
        }
    }
    // Creates a final negotiation meeting.
    // async createFinalNegotiationMeeting(
    //   createFinalNegotiationDto: CreateFinalNegotiationDto,
    //   userId: number
    // ) {
    //   await this.lookUpValidation.validateDynamicLookupValues(
    //     createFinalNegotiationDto,
    //     LOOK_UP_DATA
    //   );
    //   const { policyPlacedTypeLid, leadInsurerId } = createFinalNegotiationDto;
    //   const policyPlacedLookUp = await this.lookUpRepository.findOne({
    //     where: { id: policyPlacedTypeLid },
    //   });
    //   const policyPlacedLookUpKey = policyPlacedLookUp?.lookUpKey;
    //   return await this.dataSource.transaction(async (manager) => {
    //     try {
    //       // Separate final meeting data (excluding insurerShares)
    //       let { insurerShares, participants, ...finalMeetingData } =
    //         createFinalNegotiationDto;
    //       if (policyPlacedLookUpKey === POLICY_PLACED_TYPE.MULTIPLE_INSURER) {
    //         if (!insurerShares?.length) {
    //           throw new Error(
    //             "Insurer shares are required when policyPlacedType is Multiple Insurers"
    //           );
    //         }
    //         if (!leadInsurerId) {
    //           throw new Error(
    //             "Lead insurer ID is required when policyPlacedType is Multiple Insurers."
    //           );
    //         }
    //       } else if (
    //         policyPlacedLookUpKey === POLICY_PLACED_TYPE.SINGLE_INSURER
    //       ) {
    //         insurerShares = insurerShares ?? [];
    //         finalMeetingData.leadInsurerId =
    //           finalMeetingData.leadInsurerId ?? null;
    //       }
    //       // 1. Create main final negotiation meeting
    //       const meeting =
    //         await this.opportunityRepository.createFinalMeetingRecord(
    //           finalMeetingData,
    //           userId,
    //           manager
    //         );
    //       if (!meeting || !meeting.id) {
    //         throw new Error("Failed to create final negotiation meeting.");
    //       }
    //       // 2. Create insurer participants if any
    //       if (insurerShares?.length) {
    //         await this.opportunityRepository.createInsurerParticipants(
    //           insurerShares,
    //           meeting.id, // Ensure meeting.id is passed correctly
    //           manager
    //         );
    //       }
    //       if (participants.length > 0) {
    //         await this.opportunityRepository.createFinalNegotiationParticipants(
    //           participants,
    //           meeting.id, // Ensure meeting.id is passed correctly
    //           manager
    //         );
    //       }
    //       return meeting;
    //     } catch (error) {
    //       throw new Error(
    //         `Error creating final negotiation meeting: ${
    //           error instanceof Error ? error.message : "Unknown error"
    //         }`
    //       );
    //     }
    //   });
    // }
    async updateOpportunityActivity(updateOpportunityActivityData) {
        try {
            // Validate due dates against expiry date
            const validationErrors = await this.validateDueDatesAgainstExpiryDate(updateOpportunityActivityData);
            if (validationErrors.length > 0) {
                throw new common_1.BadRequestException({
                    error: "Validation Failed",
                    message: validationErrors,
                });
            }
            await this.dataSource.transaction(async (entityManager) => {
                if (updateOpportunityActivityData.opportunityActivities.length > 0) {
                    for (const activity of updateOpportunityActivityData.opportunityActivities) {
                        await this.opportunityRepository.updateActivityDueDate(entityManager, activity.opportunityActivityId, new Date(activity.dueDate), updateOpportunityActivityData.updatedBy);
                        if (activity.ownerId) {
                            await this.opportunityRepository.updateOpportunityActivityOwner(entityManager, activity.opportunityActivityId, activity.ownerId);
                        }
                        for (const activityParticipant of activity.participants) {
                            await this.opportunityRepository.addParticipantsToOpportunityActivity(entityManager, activity.opportunityActivityId, activityParticipant, updateOpportunityActivityData.updatedBy);
                            const opportunity = await this.getOpportunityIdByOpportunityActivityId(activity.opportunityActivityId);
                            const url = `${environment_1.ENV.CLIENT_SERVER_URL}opportunities/${opportunity.opportunityId}`;
                            await this.sendNotification(constants_2.OPPORTUNITY_PARTICIPANT_INVITE, url, activityParticipant, true, true);
                        }
                    }
                }
            });
            return {
                success: true,
                message: messages_1.successMessage.opportunityActivityUpdatedSuccessfully,
                data: updateOpportunityActivityData,
            };
        }
        catch (error) {
            console.log(error);
            if (error instanceof common_1.BadRequestException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityUpdateFailed);
        }
    }
    async validateDueDatesAgainstExpiryDate(updateOpportunityActivityData) {
        const validationErrors = [];
        const invalidActivityIds = [];
        try {
            // Fetch the opportunityId using the first opportunityActivityId from the payload
            const firstActivity = updateOpportunityActivityData.opportunityActivities[0];
            const activityMap = await this.opportunityActivityMapRepository.findOne({
                where: { id: firstActivity.opportunityActivityId },
                select: ["opportunityId"],
            });
            if (!activityMap || !activityMap.opportunityId) {
                throw new common_1.NotFoundException(`Opportunity ID not found for activity ID ${firstActivity.opportunityActivityId}.`);
            }
            const opportunityId = activityMap.opportunityId;
            // Fetch the opportunity expiry date using the opportunityId
            const opportunity = await this.opportunityRepo.findOne({
                where: { opportunityId },
                select: ["soExpireDate"],
            });
            if (!opportunity || !opportunity.soExpireDate) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityId} not found or expiry date is missing.`);
            }
            const opportunityExpiryDate = new Date(opportunity.soExpireDate);
            // Collect all invalid activity IDs
            for (const activity of updateOpportunityActivityData.opportunityActivities) {
                const activityDueDate = new Date(activity.dueDate);
                if (activityDueDate > opportunityExpiryDate) {
                    invalidActivityIds.push(activity.opportunityActivityId);
                }
            }
            // If there are invalid activity IDs, fetch their names
            if (invalidActivityIds.length > 0) {
                const activityMaps = await this.opportunityActivityMapRepository.findBy({
                    id: (0, typeorm_2.In)(invalidActivityIds),
                });
                // Create validation errors for each invalid activity
                for (const activityMap of activityMaps) {
                    const activityName = activityMap.activityName || "Unknown Activity";
                    validationErrors.push(`Due date for activity "${activityName}" exceeds the opportunity expiry date ${opportunityExpiryDate.toISOString()}.`);
                }
            }
            return validationErrors; // Return validation errors or an empty array
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? "Error validating due dates against expiry date."
                    : error);
        }
    }
    async getOpportunityActivityById(opportynityId) {
        try {
            return await this.opportunityRepository.getOpportunityActivitiesByOpportunityId(opportynityId);
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving opportunity activity");
        }
    }
    async getOpportunityActivityMeta(opportunityId, activityId) {
        const activityMeta = await this.opportunityRepository.getOpportunityActivityMeta(opportunityId, activityId);
        if (!activityMeta) {
            throw new common_1.NotFoundException(messages_1.errorMessages.opportunityActivityMetaNotFound);
        }
        return activityMeta;
    }
    async getOpportunityAndActivityIdsByOpportunityActivityId(opportunityActivityId) {
        const result = await this.opportunityActivityMapRepository.findOne({
            where: { id: opportunityActivityId },
            select: ["opportunityId", "refActivityId", "dueDate", "opportunityTable"],
        });
        if (!result) {
            return null;
        }
        return {
            opportunityId: result.opportunityId,
            activityId: result.refActivityId,
            plannedDate: result.dueDate,
        };
    }
    async createDataValidation(dataValidationDetails, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(dataValidationDetails, constants_1.LOOK_UP_DATA);
            // Fetch opportunityId and activityId
            const { opportunityId, activityId, leadDays } = await this.opportunityRepository.getOpportunityActivityById(dataValidationDetails.opportunityActivityId);
            if (!opportunityId || !activityId) {
                throw new common_1.NotFoundException(`Opportunity or activity not found for opportunityId: ${opportunityId} and activityId: ${activityId}`);
            }
            // Create the data validation record
            return await this.dataSource.transaction(async (entityManager) => {
                const createTaskObject = await this.opportunityRepository.createTaskObject(dataValidationDetails.statusLid, opportunityId, dataValidationDetails.opportunityActivityId, constants_2.DATA_VALIDATION_TASK_NAME, leadDays, userId);
                if (!createTaskObject) {
                    throw new common_1.BadRequestException("Failed to create task object for data validation.");
                }
                // Call the createTask function in TaskService
                const task = await this.taskService.createTask(createTaskObject, entityManager);
                const dataValidationRecord = await this.opportunityRepository.createDataValidation(entityManager, {
                    opportunityId,
                    activityId,
                    opportunityActivityId: dataValidationDetails.opportunityActivityId,
                    description: dataValidationDetails.remarks.description,
                    statusLid: dataValidationDetails.statusLid,
                    taskId: task.id,
                }, userId);
                // Create the data validation documents
                if (dataValidationDetails.documents &&
                    dataValidationDetails.documents.length > 0) {
                    await this.opportunityRepository.saveDataValidationDocuments(entityManager, dataValidationRecord.id, task.id, dataValidationDetails.documents);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: dataValidationDetails.opportunityActivityId }, {
                    statusLid: dataValidationDetails.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(dataValidationRecord.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.KDM_MEETING, dataValidationRecord.statusLid, entityManager);
                return {
                    id: dataValidationRecord.id,
                    message: "Data validation activity created successfully.",
                };
            });
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to create data validation.");
        }
    }
    async getDataValidationByOpportunityActivityId(opportunityActivityId) {
        try {
            const { opportunityId, activityId } = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityId || !activityId) {
                throw new common_1.NotFoundException(`Opportunity or activity not found for opportunityId: ${opportunityId} and activityId: ${activityId}`);
            }
            const dataValidation = await this.opportunityRepository.getDataValidationByOpportunityActivityId(opportunityId, activityId);
            if (!dataValidation) {
                throw new common_1.NotFoundException(`Data validation not found for opportunity activity ID ${opportunityActivityId}`);
            }
            return dataValidation;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving data validation");
        }
    }
    async updateDataValidation(opportunityActivityId, updateDataValidationDetails, userId) {
        try {
            return await this.dataSource.transaction(async (entityManager) => {
                const dataValidation = await this.dataValidationRepo.findOne({
                    where: { opportunityActivityId },
                });
                if (!dataValidation) {
                    throw new common_1.NotFoundException(`Data validation with opportunity activity ID ${opportunityActivityId} not found.`);
                }
                const dataValidationStatus = await this.lookUpRepository.findOne({
                    where: { id: dataValidation.statusLid },
                });
                if (!dataValidationStatus) {
                    throw new common_1.NotFoundException(`Data validation status with ID ${dataValidation.statusLid} not found.`);
                }
                if (dataValidationStatus.lookUpKey ===
                    constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                    dataValidationStatus.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                    throw new common_1.BadRequestException(`Data validation with opportunity activity ID ${opportunityActivityId} cannot be updated as it is already submitted.`);
                }
                const updateTaskObject = await this.opportunityRepository.updateTaskObject(entityManager, dataValidation.taskId, updateDataValidationDetails?.statusLid, userId);
                // Update the task details
                await this.taskService.updateTask(dataValidation.taskId, updateTaskObject, entityManager, true);
                // Step 2: Update the data validation record based on taskId
                const updatedDataValidation = await this.opportunityRepository.updateDataValidation(entityManager, dataValidation, updateDataValidationDetails, userId);
                // Step 3: Update the associated documents if provided
                if (updateDataValidationDetails.documents &&
                    updateDataValidationDetails.documents.length > 0) {
                    // Remove existing documents and add the new ones
                    await this.opportunityRepository.saveDataValidationDocuments(entityManager, dataValidation.id, dataValidation.taskId, updateDataValidationDetails.documents);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: updatedDataValidation?.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.KDM_MEETING, updatedDataValidation?.statusLid, entityManager);
                return {
                    id: dataValidation.id,
                    message: "Data validation activity updated successfully.",
                };
            });
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to update data validation.");
        }
    }
    async createKDMMeeting(createKDMMeetingData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(createKDMMeetingData, constants_1.LOOK_UP_DATA);
            const { opportunityActivityId: activityId, statusLid, ...kdmMeetingData } = createKDMMeetingData;
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivityById(activityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity activity with ID ${activityId} not found.`);
            }
            const opportunity = await this.opportunityRepo.findOne({
                where: { opportunityId: opportunityActivity.opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityActivity.opportunityId} not found.`);
            }
            const existingMeetingId = kdmMeetingData.kdmMeetingFormFields.selectMeeting;
            return await this.dataSource.transaction(async (entityManager) => {
                let meeting;
                const companyParticipantsData = kdmMeetingData.participants
                    .companyContactPerson
                    ? {
                        companyId: opportunity.companyId,
                        companyContactPerson: kdmMeetingData.participants.companyContactPerson,
                    }
                    : undefined;
                const employeeParticipantsData = kdmMeetingData.participants.employees
                    ? {
                        employees: kdmMeetingData.participants.employees,
                    }
                    : undefined;
                const status = await this.lookUpRepository.findOne({
                    where: { id: statusLid },
                });
                if (!status) {
                    throw new common_1.NotFoundException(`Status with ID ${statusLid} not found`);
                }
                let kdmMeetingStatusLid;
                if (status.lookUpKey) {
                    if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                        status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                        const meetingStatus = await this.lookUpRepository.findOne({
                            where: { lookUpKey: constants_1.DEFAULT_MEETING_STATUS_COMPLETED },
                        });
                        if (!meetingStatus) {
                            throw new common_1.NotFoundException(`Meeting status with key ${constants_1.DEFAULT_MEETING_STATUS_COMPLETED} not found.`);
                        }
                        kdmMeetingStatusLid = meetingStatus.id;
                    }
                }
                await this.verifyMeetingType(createKDMMeetingData.kdmMeetingFormFields.meetingTypeLid, constants_1.MEETING_TYPE_KEY.KDM, constants_1.MEETING_NAME.KDM);
                if (existingMeetingId) {
                    const existingMeeting = await this.meetingRepo.findOne({
                        where: { id: existingMeetingId },
                    });
                    if (!existingMeeting) {
                        throw new common_1.NotFoundException(`Meeting with ID ${existingMeetingId} not found.`);
                    }
                    const meetingStatus = await this.LookUpService.getLookUpsByKey(constants_1.DEFAULT_MEETING_STATUS);
                    if (existingMeeting.meetingStatusLid === meetingStatus[0].id) {
                        // Update the existing meeting
                        meeting = await this.meetingService.updateMeeting(existingMeetingId, {
                            opportunityId: opportunityActivity.opportunityId,
                            activityId: activityId,
                            companyId: opportunity.companyId,
                            meetingTypeLid: createKDMMeetingData.kdmMeetingFormFields.meetingTypeLid,
                            meetingDate: createKDMMeetingData.kdmMeetingFormFields.meetingDate,
                            startTime: createKDMMeetingData.kdmMeetingFormFields.availableFrom,
                            endTime: createKDMMeetingData.kdmMeetingFormFields.availableTo,
                            meetingSubject: constants_2.DEFAULT_KDM_MEETING_PURPOSE,
                            meetingAgenda: constants_2.DEFAULT_KDM_MEETING_PURPOSE,
                            locationTypeLid: createKDMMeetingData.kdmMeetingFormFields.locationTypeLid,
                            updatedBy: userId,
                            companyParticipants: companyParticipantsData,
                            employeeParticipants: employeeParticipantsData,
                            documents: createKDMMeetingData?.documents ?? undefined,
                            meetingStatusLid: kdmMeetingStatusLid ?? existingMeeting.meetingStatusLid,
                        }, entityManager);
                    }
                }
                else {
                    // Create the meeting
                    meeting = await this.meetingService.createMeeting({
                        opportunityId: opportunityActivity.opportunityId,
                        activityId: activityId,
                        companyId: opportunity.companyId,
                        meetingSubject: constants_2.DEFAULT_KDM_MEETING_PURPOSE,
                        meetingAgenda: constants_2.DEFAULT_KDM_MEETING_PURPOSE,
                        meetingTypeLid: createKDMMeetingData.kdmMeetingFormFields.meetingTypeLid,
                        meetingDate: createKDMMeetingData.kdmMeetingFormFields.meetingDate,
                        startTime: createKDMMeetingData.kdmMeetingFormFields.availableFrom,
                        endTime: createKDMMeetingData.kdmMeetingFormFields.availableTo,
                        locationTypeLid: createKDMMeetingData.kdmMeetingFormFields.locationTypeLid,
                        createdBy: userId,
                        updatedBy: userId,
                        companyParticipants: companyParticipantsData,
                        employeeParticipants: employeeParticipantsData,
                        documents: createKDMMeetingData.documents,
                        meetingStatusLid: kdmMeetingStatusLid
                            ? kdmMeetingStatusLid
                            : null,
                    }, entityManager);
                }
                // Create the KDM meeting
                const kdmMeeting = await this.opportunityRepository.createKDMMeeting(entityManager, {
                    meetingId: meeting.id,
                    opportunityId: opportunityActivity.opportunityId,
                    activityId: opportunityActivity.activityId,
                    opportunityActivityId: activityId,
                    kdmMeetingTypeLid: createKDMMeetingData.kdmMeetingFormFields.kdmMeetingTypeLid,
                    selectMeeting: createKDMMeetingData.kdmMeetingFormFields.selectMeeting,
                    remarks: createKDMMeetingData?.remarksMomSection?.remarks,
                    mom: createKDMMeetingData?.remarksMomSection?.mom,
                    statusLid,
                    createdBy: userId,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateOpportunityStatus(entityManager, opportunityActivity.opportunityId, constants_2.OPPORTUNITY_STATUS_WORK_IN_PROGRESS);
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: activityId }, {
                    statusLid: kdmMeeting.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(kdmMeeting.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.MANDATE_DETAILS_ENTRY, kdmMeeting.statusLid, entityManager);
                return {
                    id: kdmMeeting.id,
                    message: "KDM meeting created successfully.",
                };
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to create KDM meeting");
        }
    }
    async updateKDMMeeting(opportunityActivityId, updateKDMMeetingData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updateKDMMeetingData, constants_1.LOOK_UP_DATA);
            const meeting = await this.kdmMeetingRepo.findOne({
                where: { opportunityActivityId },
            });
            if (!meeting) {
                throw new common_1.NotFoundException(`KDM Meeting with opportunity activity ID: ${opportunityActivityId} not found.`);
            }
            const kdmMeetingStatus = await this.lookUpRepository.findOne({
                where: { id: meeting.statusLid },
            });
            if (!kdmMeetingStatus) {
                throw new common_1.NotFoundException(`Meeting status with ID: ${meeting.statusLid} not found.`);
            }
            return await this.dataSource.transaction(async (entityManager) => {
                if (kdmMeetingStatus.lookUpKey ===
                    constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                    kdmMeetingStatus.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                    throw new common_1.BadRequestException(`KDM Meeting with opportunity activity ID: ${opportunityActivityId} cannot be updated as it is already completed.`);
                }
                const meetingDetails = await this.meetingRepo.findOne({
                    where: { id: meeting.meetingId },
                });
                if (!meetingDetails) {
                    throw new common_1.NotFoundException(`Meeting with ID ${meeting.meetingId} not found.`);
                }
                const meetingStatus = await this.LookUpService.getLookUpsByKey(constants_1.DEFAULT_MEETING_STATUS);
                if (meetingDetails.meetingStatusLid === meetingStatus[0].id) {
                    const companyParticipantsData = updateKDMMeetingData?.participants
                        ?.companyContactPerson
                        ? {
                            companyId: meetingDetails.companyId,
                            companyContactPerson: updateKDMMeetingData.participants.companyContactPerson,
                        }
                        : undefined;
                    const employeeParticipantsData = updateKDMMeetingData?.participants
                        ?.employees
                        ? {
                            employees: updateKDMMeetingData.participants.employees,
                        }
                        : undefined;
                    if (updateKDMMeetingData?.kdmMeetingFormFields?.meetingTypeLid) {
                        await this.verifyMeetingType(updateKDMMeetingData.kdmMeetingFormFields.meetingTypeLid, constants_1.MEETING_TYPE_KEY.KDM, constants_1.MEETING_NAME.KDM);
                    }
                    await this.meetingService.updateMeeting(meetingDetails.id, {
                        meetingTypeLid: updateKDMMeetingData?.kdmMeetingFormFields?.meetingTypeLid ??
                            meetingDetails.meetingTypeLid,
                        meetingDate: updateKDMMeetingData?.kdmMeetingFormFields?.meetingDate ??
                            meetingDetails.meetingDate,
                        startTime: updateKDMMeetingData?.kdmMeetingFormFields?.availableFrom ??
                            meetingDetails.startTime,
                        endTime: updateKDMMeetingData?.kdmMeetingFormFields?.availableTo ??
                            meetingDetails.endTime,
                        locationTypeLid: updateKDMMeetingData?.kdmMeetingFormFields?.locationTypeLid ??
                            meetingDetails.locationTypeLid,
                        updatedBy: userId,
                        companyParticipants: companyParticipantsData,
                        employeeParticipants: employeeParticipantsData,
                        documents: updateKDMMeetingData?.documents ?? undefined,
                    }, entityManager);
                }
                const updatedKdmMeeting = await this.opportunityRepository.updateKDMMeeting(entityManager, meetingDetails.id, {
                    remarks: updateKDMMeetingData?.remarksMomSection?.remarks ??
                        meeting.remarks,
                    mom: updateKDMMeetingData?.remarksMomSection?.mom ?? meeting.mom,
                    statusLid: updateKDMMeetingData.statusLid,
                    updatedBy: userId,
                });
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: updatedKdmMeeting?.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.MANDATE_DETAILS_ENTRY, updatedKdmMeeting?.statusLid, entityManager);
                return {
                    id: meeting.id,
                    message: "KDM meeting updated successfully.",
                };
            });
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            if (error instanceof common_1.BadRequestException)
                throw error;
            throw new Error("Failed to update KDM meeting.", error);
        }
    }
    async updateHandOverMeeting(opportunityActivityId, UpdateHandOverMeetDto, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(UpdateHandOverMeetDto, constants_1.LOOK_UP_DATA);
            const meeting = await this.opportunityHandOverMeetRepo.findOne({
                where: { opportunityActivityId },
            });
            if (!meeting) {
                throw new common_1.NotFoundException(`Hand Over Meeting with opportunity activity ID: ${opportunityActivityId} not found.`);
            }
            const handOverMeetingStatus = await this.lookUpRepository.findOne({
                where: { id: meeting.statusLid },
            });
            if (!handOverMeetingStatus) {
                throw new common_1.NotFoundException(`Meeting status with ID: ${meeting.statusLid} not found.`);
            }
            return await this.dataSource.transaction(async (entityManager) => {
                if (handOverMeetingStatus.lookUpKey ===
                    constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                    handOverMeetingStatus.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                    throw new common_1.BadRequestException(`Hand over Meeting with opportunity activity ID: ${opportunityActivityId} cannot be updated as it is completed or cancelled.`);
                }
                const meetingDetails = await this.meetingRepo.findOne({
                    where: { id: meeting.meetingId },
                });
                if (!meetingDetails) {
                    throw new common_1.NotFoundException(`Meeting with ID ${meeting.meetingId} not found.`);
                }
                const meetingStatus = await this.LookUpService.getLookUpsByKey(constants_1.DEFAULT_MEETING_STATUS);
                if (meetingDetails.meetingStatusLid === meetingStatus[0].id) {
                    const companyParticipantsData = UpdateHandOverMeetDto?.participants
                        ?.companyContactPerson
                        ? {
                            companyId: meetingDetails.companyId,
                            companyContactPerson: UpdateHandOverMeetDto.participants.companyContactPerson,
                        }
                        : undefined;
                    const employeeParticipantsData = UpdateHandOverMeetDto?.participants
                        ?.employees
                        ? {
                            employees: UpdateHandOverMeetDto.participants.employees,
                        }
                        : undefined;
                    if (UpdateHandOverMeetDto?.handOverMeetFields?.meetingTypeLid) {
                        await this.verifyMeetingType(UpdateHandOverMeetDto.handOverMeetFields.meetingTypeLid, constants_1.MEETING_TYPE_KEY.HANDOVER, constants_1.MEETING_NAME.HANDOVER);
                    }
                    await this.meetingService.updateMeeting(meetingDetails.id, {
                        meetingTypeLid: UpdateHandOverMeetDto?.handOverMeetFields?.meetingTypeLid ??
                            meetingDetails.meetingTypeLid,
                        meetingDate: UpdateHandOverMeetDto?.handOverMeetFields?.meetingDate ??
                            meetingDetails.meetingDate,
                        startTime: UpdateHandOverMeetDto?.handOverMeetFields?.availableFrom ??
                            meetingDetails.startTime,
                        endTime: UpdateHandOverMeetDto?.handOverMeetFields?.availableTo ??
                            meetingDetails.endTime,
                        locationTypeLid: UpdateHandOverMeetDto?.handOverMeetFields?.locationTypeLid ??
                            meetingDetails.locationTypeLid,
                        updatedBy: userId,
                        companyParticipants: companyParticipantsData,
                        employeeParticipants: employeeParticipantsData,
                        documents: UpdateHandOverMeetDto?.documents ?? undefined,
                    }, entityManager);
                }
                const updatedHandOverMeet = await this.opportunityRepository.updateHandOverMeeting(entityManager, meetingDetails.id, {
                    remarks: UpdateHandOverMeetDto?.remarksMomSection?.remarks ??
                        meeting.remarks,
                    mom: UpdateHandOverMeetDto?.remarksMomSection?.mom ?? meeting.mom,
                    statusLid: UpdateHandOverMeetDto.statusLid,
                    updatedBy: userId,
                });
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: updatedHandOverMeet?.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.LOST, updatedHandOverMeet?.statusLid, entityManager);
                return {
                    id: updatedHandOverMeet?.id,
                    message: "Hand over meeting updated successfully.",
                };
            });
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to update Hand Over meeting.");
        }
    }
    async createOpportunityMeta(userId, activityMetaData) {
        try {
            const activityDtoMap = {
                opportunity_premium_calculation: create_premium_calculation_dto_1.CreatePremiumCalculationDto,
                opportunity_data_validation: create_data_validation_dto_1.CreateDataValidationDto,
                opportunity_kdm_meeting: create_kdm_meeting_dto_1.CreateKDMMeetingDto,
                opportunity_mandate_details_entry: create_mandate_details_dto_1.CreateMandateDto,
                opportunity_rfp_cover_detail: create_rfp_cover_detail_dto_1.CreateOpportunityRfpCoverDetailDto,
                opportunity_held_cover_note: create_held_cover_note_dto_1.CreateOpportunityHeldCoverNoteDto,
                opportunity_policy_confirmation: create_policy_confirmation_dto_1.CreatePolicyConfirmationDto,
                opportunity_policy_hard_copy: create_policy_hard_copy_dto_1.CreatePolicyHardCopyDto,
                opportunity_quote_entry: create_quote_entry_dto_1.CreateQuoteDto,
                opportunity_policy_docket: create_policy_docket_dto_1.CreatePolicyDocketDto,
                opportunity_placement_slip_generation: create_placement_slip_dto_1.CreatePlacementSlipDto,
                opportunity_broking_slip_version_details: create_broking_slip_version_dto_1.CreateBrokingSlipVersionDto,
                opportunity_hand_over_meet: create_hand_over_meet_dto_1.CreateHandOverMeetDto,
                opportunity_rfp_details_entry: opportunity_rfp_details_entry_dto_1.CreateOpportunityRfpDetailsEntryDto,
                opportunity_final_negotiation: create_final_negotiation_activity_dto_1.CreateFinalNegotiationActivityDto,
                opportunity_lost: create_opportunity_lost_dto_1.CreateOpportunityLostDto,
                opportunity_quote_comparison_report: create_quote_comparison_report_dto_1.CreateQuoteComparisonReportDto,
            };
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(activityMetaData.opportunityActivityId);
            if (!opportunityActivityMapData) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${activityMetaData.opportunityActivityId}`);
            }
            else {
                const opportunityTable = opportunityActivityMapData.opportunityTable;
                if (opportunityTable === null) {
                    throw new common_1.NotFoundException("Opportunity activity Table not found");
                }
                const DtoClass = activityDtoMap[opportunityTable];
                if (!DtoClass) {
                    throw new common_1.BadRequestException(`Unsupported opportunity table: ${opportunityTable} not found in the activityDtoMap`);
                }
                const dtoInstance = (0, class_transformer_1.plainToInstance)(DtoClass, activityMetaData);
                // Add these options to validate nested objects
                const validationOptions = {
                    forbidUnknownValues: true,
                    whitelist: true,
                    forbidNonWhitelisted: true,
                    skipMissingProperties: false,
                };
                const errors = await (0, class_validator_1.validate)(dtoInstance, validationOptions);
                console.log("errors", errors);
                if (errors.length > 0) {
                    const flattenErrors = (validationErrors, parentProperty = "") => {
                        return validationErrors.flatMap((error) => {
                            // Format the property path
                            const propertyPath = parentProperty
                                ? `${parentProperty}${error.property.startsWith("[") ? "" : "."}${error.property}`
                                : error.property;
                            // Handle current level constraints
                            const currentErrors = error.constraints
                                ? Object.values(error.constraints).map((msg) => `${propertyPath}: ${msg}`)
                                : [];
                            // Handle children (nested objects or array items)
                            const childrenErrors = error.children
                                ? flattenErrors(error.children, propertyPath)
                                : [];
                            return [...currentErrors, ...childrenErrors];
                        });
                    };
                    console.log("errors", errors);
                    const flattenedErrors = flattenErrors(errors);
                    throw new common_1.BadRequestException({
                        status: common_1.HttpStatus.BAD_REQUEST,
                        error: "Bad Request",
                        message: flattenedErrors,
                    });
                }
                let result;
                switch (opportunityTable) {
                    case "opportunity_data_validation":
                        result = await this.createDataValidation(activityMetaData, userId);
                        break;
                    case "opportunity_kdm_meeting":
                        result = await this.createKDMMeeting(activityMetaData, userId);
                        break;
                    case "opportunity_mandate_details_entry":
                        result = await this.createMandate(activityMetaData, userId);
                        break;
                    case "opportunity_rfp_cover_detail":
                        result = await this.processRfpCoverDetails(activityMetaData, userId);
                        break;
                    case "opportunity_rfp_details_entry":
                        result = await this.createOpportunityRfpDetailsEntry(opportunityActivityMapData, activityMetaData, userId);
                        break;
                    case "opportunity_broking_slip_version_details":
                        result = await this.generateBrokingSlipVersion(activityMetaData, userId, opportunityActivityMapData.opportunityId);
                        break;
                    case "opportunity_quote_entry":
                        result = await this.createQuote(activityMetaData.opportunityActivityId, activityMetaData, userId);
                        break;
                    case "opportunity_quote_comparison_report":
                        result = await this.createQuotComparisonReportActivity(opportunityActivityMapData, activityMetaData, userId);
                        break;
                    case "opportunity_final_negotiation":
                        result = await this.createFinalNegotiationActivity(activityMetaData, userId);
                        break;
                    case "opportunity_placement_slip_generation":
                        result = await this.createPlacementSlip(activityMetaData, userId);
                        break;
                    case "opportunity_premium_calculation":
                        result = await this.createPremiumCalculationActivity(opportunityActivityMapData, activityMetaData, userId);
                        break;
                    case "opportunity_held_cover_note":
                        result = await this.createHeldCoverNoteActivity(opportunityActivityMapData, activityMetaData, userId);
                        break;
                    case "opportunity_policy_hard_copy":
                        result = await this.createPolicyHardCopyActivity(opportunityActivityMapData, activityMetaData, userId);
                        break;
                    case "opportunity_policy_docket":
                        result = await this.createPolicyDocketActivity(opportunityActivityMapData, activityMetaData, userId);
                        break;
                    case "opportunity_policy_confirmation":
                        result = await this.createPolicyConfirmationActivity(opportunityActivityMapData, activityMetaData, userId);
                        break;
                    case "opportunity_hand_over_meet":
                        result = await this.createHandOverMeet(activityMetaData, userId);
                        break;
                    case "opportunity_lost":
                        result = await this.createOpportunityLostActivity(activityMetaData, userId);
                        break;
                    default:
                        throw new common_1.BadRequestException(`Unsupported opportunity table: ${opportunityTable}`);
                }
                return result;
            }
        }
        catch (error) {
            console.error("Error in createOpportunityMeta:", error);
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.getResponse());
            }
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaUpdateFailed);
        }
    }
    async updateOpportunityMeta(opportunityActivityId, userId, activityMetaData) {
        try {
            const activityDtoMap = {
                opportunity_data_validation: create_data_validation_dto_1.UpdateDataValidationDto,
                opportunity_kdm_meeting: create_kdm_meeting_dto_1.UpdateKDMMeetingDto,
                opportunity_mandate_details_entry: create_mandate_details_dto_1.UpdateMandateDto,
                opportunity_rfp_cover_detail: update_rfp_cover_detail_dto_1.UpdateOpportunityRfpCoverDetailDto,
                opportunity_rfp_details_entry: opportunity_rfp_details_entry_dto_1.UpdateRfpDetailsEntryDto,
                opportunity_final_negotiation: update_final_negotiation_activity_dto_1.UpdateFinalNegotiationActivityDto,
                opportunity_hand_over_meet: create_hand_over_meet_dto_1.UpdateHandOverMeetDto,
                opportunity_premium_calculation: update_premium_calculation_dto_1.UpdatePremiumCalculationDto,
                opportunity_policy_docket: update_policy_docket_1.UpdatePolicyDocketDto,
                opportunity_held_cover_note: update_held_cover_note_dto_1.UpdateHeldCoverNoteDto,
                opportunity_policy_confirmation: update_policy_confirmation_dto_1.UpdatePolicyConfirmationDto,
                opportunity_lost: create_opportunity_lost_dto_1.UpdateOpportunityLostDto,
                opportunity_policy_hard_copy: update_policy_hard_copy_dto_1.UpdatePolicyHardCopyDto,
                opportunity_quote_comparison_report: update_quote_comparison_report_dto_1.UpdateQuoteComparisonReportDto,
                opportunity_quote_entry: create_quote_entry_dto_1.UpdateQuoteDto,
                // Add other activity mappings here as needed
            };
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivityMapData) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${opportunityActivityId}`);
            }
            const opportunityTable = opportunityActivityMapData.opportunityTable;
            if (!opportunityTable) {
                throw new common_1.NotFoundException("Opportunity activity table not found.");
            }
            const DtoClass = activityDtoMap[opportunityTable];
            if (!DtoClass) {
                throw new common_1.BadRequestException(`Unsupported opportunity table: ${opportunityTable}`);
            }
            const dtoInstance = (0, class_transformer_1.plainToInstance)(DtoClass, activityMetaData);
            const validationOptions = {
                forbidUnknownValues: true,
                whitelist: true,
                forbidNonWhitelisted: true,
                skipMissingProperties: false,
            };
            const errors = await (0, class_validator_1.validate)(dtoInstance, validationOptions);
            if (errors.length > 0) {
                const flattenErrors = (validationErrors, parentProperty = "") => {
                    return validationErrors.flatMap((error) => {
                        // Format the property path
                        const propertyPath = parentProperty
                            ? `${parentProperty}${error.property.startsWith("[") ? "" : "."}${error.property}`
                            : error.property;
                        // Handle current level constraints
                        const currentErrors = error.constraints
                            ? Object.values(error.constraints).map((msg) => `${propertyPath}: ${msg}`)
                            : [];
                        // Handle children (nested objects or array items)
                        const childrenErrors = error.children
                            ? flattenErrors(error.children, propertyPath)
                            : [];
                        return [...currentErrors, ...childrenErrors];
                    });
                };
                console.log("errors", errors);
                const flattenedErrors = flattenErrors(errors);
                throw new common_1.BadRequestException({
                    status: common_1.HttpStatus.BAD_REQUEST,
                    error: "Bad Request",
                    message: flattenedErrors,
                });
            }
            let result;
            switch (opportunityTable) {
                case "opportunity_data_validation":
                    result = await this.updateDataValidation(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_kdm_meeting":
                    result = await this.updateKDMMeeting(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_mandate_details_entry":
                    result = await this.updateMandate(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_rfp_cover_detail":
                    result = await this.updateRfpCoverDetails(activityMetaData, userId);
                    break;
                case "opportunity_rfp_details_entry":
                    result = await this.updateOpportunityRfpDetailsEntry(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_quote_entry":
                    result = await this.updateOpportunityQuoteByActivityId(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_quote_comparison_report":
                    result = await this.updateQuoteComparisonReportById(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_premium_calculation":
                    result = await this.updatePremiumCalculationActivity(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_final_negotiation":
                    result = await this.updateFinalNegotiationActivity(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_hand_over_meet":
                    result = await this.updateHandOverMeeting(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_policy_confirmation":
                    result = await this.updatePolicyConfirmationById(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_policy_hard_copy":
                    result = await this.updatePolicyHardCopyById(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_policy_docket":
                    result = await this.updatePolicyDocketByIdActivity(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_held_cover_note":
                    result = await this.updateHeldCoverNoteById(opportunityActivityId, activityMetaData, userId);
                    break;
                case "opportunity_lost":
                    result = await this.updateOpportunityLostActivity(opportunityActivityId, activityMetaData, userId);
                    break;
                // Add other cases for different activities here
                default:
                    throw new common_1.BadRequestException(`Unsupported opportunity table: ${opportunityTable}`);
            }
            return result;
        }
        catch (error) {
            console.error("Error in updateOpportunityMeta:", error);
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.getResponse());
            }
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update Opportunity Activity.");
        }
    }
    async getKdmMeeting(opportunityActivityId) {
        try {
            const { opportunityId, activityId } = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityId || !activityId) {
                throw new common_1.NotFoundException(`Opportunity or activity not found for opportunityId: ${opportunityId} and activityId: ${activityId}`);
            }
            const meeting = await this.opportunityRepository.getMeetingDetailsById(opportunityId, activityId);
            if (!meeting) {
                throw new common_1.NotFoundException(`Meeting with ID ${meetingId} not found.`);
            }
            return meeting;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving meeting details");
        }
    }
    async getHandOverMeetById(opportunityActivityId) {
        try {
            const { opportunityId, activityId } = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityId || !activityId) {
                throw new common_1.NotFoundException(`Opportunity or activity not found for opportunityId: ${opportunityId} and activityId: ${activityId}`);
            }
            const meeting = await this.opportunityRepository.gethandOverMeetDetailsById(opportunityId, activityId);
            if (!meeting) {
                throw new common_1.NotFoundException(`Meeting with ID ${meeting.meetingId} not found.`);
            }
            return meeting;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving meeting details");
        }
    }
    async getRfpDataByOpportunityId(opportunityActivityId) {
        try {
            const activityData = await this.opportunityRepository.getOpportunityAndActivityIdsByOpportunityActivityId(opportunityActivityId);
            if (!activityData) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityActivityMetaNotFound);
            }
            const rfpCoverData = await this.opportunityRepository.getRfpCoverDetailsByOpportunityId(activityData.opportunityId);
            const rfpActivityDetails = await this.opportunityRepository.getRfpActivityDetailsByOpportunityId(activityData.opportunityId);
            const rfpActivityDocuments = this.opportunityRepository.getRfpActivityDocumentsByOpportunityId(opportunityActivityId);
            const transformedResponse = {
                opportunityActivityId: opportunityActivityId,
                statusLid: rfpActivityDetails[0]?.statusLid || null,
                dataActivity: {
                    coversConfig: rfpCoverData.reduce((acc, cover) => {
                        acc[cover.coverMapId] = cover.coverResponse;
                        return acc;
                    }, {}),
                    remarksSection: {
                        remarks: rfpActivityDetails[0]?.remarks || null,
                    },
                    documents: rfpActivityDocuments.length > 0
                        ? rfpActivityDocuments.map((doc) => ({
                            documentTypeLid: doc.documentTypeLid,
                            documentId: doc.documentId,
                        }))
                        : [
                            {
                                documentTypeLid: null,
                                documentId: null,
                            },
                        ],
                },
            };
            return transformedResponse;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving RFP data by opportunity activity ID");
        }
    }
    async getRfpDetailsByOpportunityActivityId(opportunityActivityId) {
        try {
            const rfpDetailsEntryData = await this.opportunityRepository.getRfpDetailsEntryByOpportunityActivityId(opportunityActivityId);
            const preferredStatusId = await this.LookUpService.getLookUpsByKey(constants_1.PREFERENCE_STATUS_PREFERRED);
            const excludedStatusId = await this.LookUpService.getLookUpsByKey(constants_1.PREFERENCE_STATUS_EXCLUDED);
            // Map the entity fields to the required response format
            const response = {
                opportunityActivityId: rfpDetailsEntryData.opportunityActivityId,
                statusLid: rfpDetailsEntryData.statusLid || null,
                dataActivity: {
                    descriptionRequirements: {
                        description: rfpDetailsEntryData.description || null,
                        requirements: rfpDetailsEntryData.requirements || null,
                    },
                    preferredInsurers: rfpDetailsEntryData.insurerDetails
                        .filter((insurer) => insurer.preferenceTypeLid === preferredStatusId[0].id)
                        .map((insurer) => ({
                        insurerId: insurer.insurerId,
                        locationId: insurer.locationId,
                        branchId: insurer.branchId,
                        contactId: insurer.contactId,
                    })),
                    excludedInsurers: rfpDetailsEntryData.insurerDetails
                        .filter((insurer) => insurer.preferenceTypeLid === excludedStatusId[0].id)
                        .map((insurer) => ({
                        insurerId: insurer.insurerId,
                        locationId: insurer.locationId,
                        branchId: insurer.branchId,
                        contactId: insurer.contactId,
                    })),
                    preferredTPA: rfpDetailsEntryData.tpaDetails
                        .filter((tpa) => tpa.preferenceTypeLid === preferredStatusId[0].id)
                        .map((tpa) => ({
                        tpaId: tpa.tpaId,
                        locationId: tpa.locationId,
                        branchId: tpa.branchId,
                        contactId: tpa.contactId,
                    })),
                    excludedTPA: rfpDetailsEntryData.tpaDetails
                        .filter((tpa) => tpa.preferenceTypeLid === excludedStatusId[0].id)
                        .map((tpa) => ({
                        tpaId: tpa.tpaId,
                        locationId: tpa.locationId,
                        branchId: tpa.branchId,
                        contactId: tpa.contactId,
                    })),
                    dynamicQuote: {
                        multipleBrokerInvolved: rfpDetailsEntryData.multipleBrokersInvolved || null,
                        isMarketAllocationDone: rfpDetailsEntryData.isMarketAllocationDone || null,
                    },
                    clientContactDetails: rfpDetailsEntryData.clientContacts?.length
                        ? {
                            contactId: rfpDetailsEntryData.clientContacts[0].contactId || null,
                            decisionInfluencers: rfpDetailsEntryData.clientContacts[0].clientContactInfluencers?.map((influencer) => influencer.influencerContactId) || [],
                            expectedPremium: rfpDetailsEntryData.clientContacts[0].expectedPremium || null,
                        }
                        : null,
                    creditSharing: rfpDetailsEntryData.creditSharing.map((credit) => ({
                        executiveId: credit.executiveId,
                        percentage: credit.percentage,
                    })),
                    targetQcrDate: {
                        targetQcrDate: rfpDetailsEntryData.targetQcrDate || null,
                    },
                    clientConsiderations: {
                        clientConsiderations: rfpDetailsEntryData.clientConsiderations || null,
                        threatsFromExistingInsurer: rfpDetailsEntryData.threatsFromExistingInsurer || null,
                        threatsFromExistingBroker: rfpDetailsEntryData.threatsFromExistingBroker || null,
                        extraneousFactors: rfpDetailsEntryData.extraneousFactors || null,
                        planForClosingDetail: rfpDetailsEntryData.planForClosingDetail || null,
                    },
                    remarks: {
                        remarks: rfpDetailsEntryData.remarks || null,
                    },
                    documents: rfpDetailsEntryData.documents.length > 0
                        ? rfpDetailsEntryData.documents.map((doc) => ({
                            documentId: doc.documentId,
                            documentTypeLid: doc.documentTypeLid,
                        }))
                        : [
                            {
                                documentId: null,
                                documentTypeLid: null,
                            },
                        ],
                },
            };
            return response;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving RFP data by opportunity activity ID");
        }
    }
    async createPremiumCalculationActivity(activityMap, payload, createdBy) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(payload, constants_1.LOOK_UP_DATA);
            // Step 2: Validate payload structure
            if (!payload.opportunityActivityId ||
                !payload.premiumCalculationDetails ||
                !payload.remarksSection) {
                throw new common_1.BadRequestException("Invalid premium calculation payload structure.");
            }
            // Step 3: Get opportunity activity
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivity(payload.opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity Activity with ID ${payload.opportunityActivityId} not found.`);
            }
            const opportunityData = await this.opportunityRepository.getPolicyDetailsByOpportunityId(activityMap.opportunityId);
            if (!opportunityData) {
                throw new common_1.NotFoundException(`Opportunity Data with ID ${activityMap.opportunityId} not found.`);
            }
            const opportunityId = opportunityActivity.opportunityId;
            const policyTypeId = opportunityData.policyType.id;
            const coverType = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_2.COVER_TYPE.ASSET },
            });
            if (!coverType?.id) {
                throw new common_1.NotFoundException(`Asset Cover type not found.`);
            }
            // Step 4: Get premium calculation covers (similar to getOpportunityRfpCovers)
            const covers = await this.opportunityRepository.getPremiumCalculationCovers(opportunityId, policyTypeId, coverType.id);
            if (!covers.length) {
                throw new common_1.NotFoundException(`No premium calculation covers found for Opportunity ID ${opportunityId}.`);
            }
            // Step 5: Prepare premium calculation details (similar to prepareRfpCoverDetails)
            const premiumCalculationCoverDetails = await this.preparePremiumCalculationDetails(covers, payload.premiumCalculationDetails, opportunityId, createdBy);
            // Step 6: Save premium calculation details (similar to saveRfpCoverDetails)
            const premiumCalculationActivityData = await this.opportunityRepository.savePremiumCalculationDetails(opportunityId, activityMap.activityId, payload.opportunityActivityId, premiumCalculationCoverDetails, payload.remarksSection.remarks, payload.documents, createdBy, payload.statusLid);
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: premiumCalculationActivityData.opportunityActivityId }, {
                statusLid: premiumCalculationActivityData.statusLid,
                updatedBy: createdBy,
            });
            await this.opportunityRepository.updateActivityStatus(premiumCalculationActivityData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.HELD_COVER_NOTE, premiumCalculationActivityData.statusLid);
            return premiumCalculationActivityData;
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaUpdateFailed);
        }
    }
    async createHeldCoverNoteActivity(OpportunityActivityMap, activityMetaData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(activityMetaData, constants_1.LOOK_UP_DATA);
            return await this.dataSource.transaction(async (entityManager) => {
                // Create the held cover note record
                const heldCoverNoteObject = {
                    opportunityId: OpportunityActivityMap.opportunityId,
                    activityId: OpportunityActivityMap.activityId,
                    opportunityActivityId: activityMetaData.opportunityActivityId,
                    statusLid: activityMetaData.statusLid,
                    placementSlipDeviationsLid: activityMetaData.placementSlipDeviationsSection
                        .placementSlipDeviationsLid,
                    deviations: activityMetaData.deviationSection.deviations,
                    deviationsAddressedLid: activityMetaData.deviationsAddressedSection.deviationsAddressedLid,
                    revisedHeldCoverNoteLid: activityMetaData.deviationsAddressedSection.revisedHeldCoverNoteLid,
                    resolutionLid: activityMetaData.deviationsAddressedSection.resolutionLid,
                    acknowledgedBy: activityMetaData.premiumReceiptDetailsSection.acknowledgedBy,
                    receiptNo: activityMetaData.premiumReceiptDetailsSection.receiptNo,
                    receiptDate: activityMetaData.premiumReceiptDetailsSection.receiptDate,
                    allDocumentsReceivedDate: activityMetaData.premiumReceiptDetailsSection
                        .allDocumentsReceivedDate,
                    remarks: activityMetaData.remarksSection.remarks,
                };
                const documents = activityMetaData.documents;
                // Save held cover note
                const heldCoverNoteData = await this.opportunityRepository.createHeldCoverNote(entityManager, heldCoverNoteObject, userId);
                // Save documents
                if (documents && documents.length > 0) {
                    await this.opportunityRepository.saveHeldCoverNoteDocuments(heldCoverNoteData.id, documents, entityManager);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: heldCoverNoteData.opportunityActivityId }, {
                    statusLid: heldCoverNoteData.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(heldCoverNoteData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.POLICY_HARD_COPY, heldCoverNoteData.statusLid, entityManager);
                return heldCoverNoteData;
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaUpdateFailed);
        }
    }
    async getOpportunityCoversMeta(opportunityId, activityId) {
        try {
            const CoverType = await this.lookUpRepository.findOne({
                where: {
                    lookUpKey: constants_2.COVER_TYPE.ASSET,
                },
            });
            if (!CoverType) {
                throw new common_1.NotFoundException(`Asset Cover type not found.`);
            }
            let sectionHeading = "Combined Coverage Details", sectionSubHeading = "Details of all combined coverage options";
            let covers = await this.opportunityRepository.getOpportunityCovers(opportunityId, [CoverType?.id]);
            if (activityId) {
                const activityData = await this.opportunityRepository.getActivityById(activityId);
                if (activityData?.name === constants_2.PREMIUM_CALCULATION) {
                    const premiumCovers = await this.opportunityRepository.getAllPremiumCalculationCovers(opportunityId, CoverType?.id);
                    covers = premiumCovers;
                    sectionHeading = "Premium Calculation Covers";
                    sectionSubHeading = "Premium Calculation Details of asset coverage";
                }
            }
            const formConfig = covers.flatMap((cover) => (cover.coversMeta?.formConfig || []).map((config) => ({
                ...config,
                id: String(cover.id),
                key: String(cover.id),
                name: String(cover.id),
            })));
            const defaultcoverValues = covers.reduce((acc, cover) => ({
                ...acc,
                ...(cover.coversMeta?.defaultValues ?? {}),
            }), {});
            return {
                formConfig,
                isMultiple: false,
                defaultcoverValues,
                sectionHeading: sectionHeading,
                sectionSubHeading: sectionSubHeading,
            };
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.InternalServerErrorException(error instanceof Error
                    ? error.message
                    : "Error retrieving opportunity covers meta");
        }
    }
    // Creates a mandate entry.
    async createMandate(createMandateDto, userId) {
        await this.lookUpValidation.validateDynamicLookupValues(createMandateDto, constants_1.LOOK_UP_DATA);
        const { opportunityId, activityId, plannedDate } = (await this.opportunityRepository.getOpportunityActivityById(createMandateDto.opportunityActivityId)) || {};
        if (!opportunityId || !activityId) {
            throw new common_1.NotFoundException(`Opportunity Activity not found for ID: ${createMandateDto.opportunityActivityId}`);
        }
        try {
            return await this.dataSource.transaction(async (entityManager) => {
                // create mandate details entry
                const savedMandate = await this.opportunityRepository.createMandateDetailsEntry(entityManager, {
                    ...createMandateDto,
                    opportunityId,
                    activityId,
                    planDate: plannedDate,
                    createdBy: userId,
                    updatedBy: userId,
                });
                const mandateDetailsContacts = createMandateDto?.mandateDetailsFromFields?.mandateDetailsContacts;
                // Save contacts
                if (mandateDetailsContacts && mandateDetailsContacts.length > 0) {
                    await this.opportunityRepository.saveMandateContacts(entityManager, savedMandate.id, savedMandate.companyId, mandateDetailsContacts);
                }
                // Save documents
                if (createMandateDto.documents &&
                    createMandateDto.documents.length > 0) {
                    await this.opportunityRepository.saveMandateDocuments(entityManager, savedMandate.id, createMandateDto.documents);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: createMandateDto.opportunityActivityId }, {
                    statusLid: savedMandate.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(createMandateDto.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.RFP_COVER_DETAIL, savedMandate.statusLid, entityManager);
                return {
                    id: savedMandate.id,
                    message: "Mandate details created successfully",
                };
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error ? error.message : "An unknown error occurred");
        }
    }
    async updateMandate(opportunityActivityId, updateMandateDto, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updateMandateDto, constants_1.LOOK_UP_DATA);
            return await this.dataSource.transaction(async (entityManager) => {
                // Update the mandate details
                const updatedDetails = await this.opportunityRepository.updateMandateDetails(entityManager, opportunityActivityId, updateMandateDto, userId);
                if (!updatedDetails) {
                    throw new common_1.BadRequestException("Failed to update mandate details.");
                }
                // Save mandate documents
                if (updateMandateDto?.documents &&
                    updateMandateDto?.documents?.length > 0) {
                    await this.opportunityRepository.saveMandateDocuments(entityManager, updatedDetails.id, updateMandateDto.documents);
                }
                // Save mandate contacts
                if (updateMandateDto?.mandateDetailsFromFields?.mandateDetailsContacts &&
                    updateMandateDto?.mandateDetailsFromFields?.mandateDetailsContacts
                        ?.length > 0) {
                    await this.opportunityRepository.saveMandateContacts(entityManager, updatedDetails.id, updatedDetails.companyId, updateMandateDto?.mandateDetailsFromFields?.mandateDetailsContacts);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: updatedDetails.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.RFP_COVER_DETAIL, updatedDetails.statusLid, entityManager);
                return {
                    id: updatedDetails.id,
                    message: "Mandate details updated successfully",
                };
            });
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error updating mandate details");
        }
    }
    async updateOpportunityRfpDetailsEntry(opportunityActivityId, updateOpportunityRfpDetailsEntryDto, userId) {
        try {
            // Validate dynamic lookup values
            await this.lookUpValidation.validateDynamicLookupValues(updateOpportunityRfpDetailsEntryDto, constants_1.LOOK_UP_DATA);
            const existingEntry = await this.opportunityRepository.getRfpDetailsEntryByOpportunityActivityId(opportunityActivityId);
            if (!existingEntry) {
                throw new common_1.NotFoundException(`OpportunityActivity: ${opportunityActivityId} does not exist.`);
            }
            const preferredStatusId = await this.LookUpService.getLookUpsByKey(constants_1.PREFERENCE_STATUS_PREFERRED);
            const excludedStatusId = await this.LookUpService.getLookUpsByKey(constants_1.PREFERENCE_STATUS_EXCLUDED);
            return await this.dataSource.transaction(async (entityManager) => {
                const { preferredTPA, excludedTPA, preferredInsurers, excludedInsurers, clientContactDetails, creditSharing, documents, descriptionRequirements, dynamicQuote, targetQcrDate, clientConsiderations, remarks, ...rfpDetailsData } = updateOpportunityRfpDetailsEntryDto;
                const mappedRfpDetailsData = {
                    description: descriptionRequirements?.description,
                    requirements: descriptionRequirements?.requirements,
                    targetQcrDate: targetQcrDate?.targetQcrDate,
                    multipleBrokersInvolved: dynamicQuote?.multipleBrokerInvolved,
                    isMarketAllocationDone: dynamicQuote?.isMarketAllocationDone,
                    clientConsiderations: clientConsiderations?.clientConsiderations,
                    threatsFromExistingInsurer: clientConsiderations?.threatsFromExistingInsurer,
                    threatsFromExistingBroker: clientConsiderations?.threatsFromExistingBroker,
                    extraneousFactors: clientConsiderations?.extraneousFactors,
                    planForClosingDetail: clientConsiderations?.planForClosingDetail,
                    remarks: remarks?.remarks,
                    statusLid: updateOpportunityRfpDetailsEntryDto.statusLid,
                    updatedBy: userId,
                };
                // Add preferenceTypeLid for preferredTPA if it exists
                if (preferredTPA?.length > 0) {
                    preferredTPA.forEach((tpa) => {
                        tpa.preferenceTypeLid = preferredStatusId[0].id;
                    });
                }
                // Add preferenceTypeLid for excludedTPA if it exists
                if (excludedTPA?.length > 0) {
                    excludedTPA.forEach((tpa) => {
                        tpa.preferenceTypeLid = excludedStatusId[0].id;
                    });
                }
                // Add preferenceTypeLid for preferredInsurers if it exists
                if (preferredInsurers?.length > 0) {
                    preferredInsurers.forEach((insurer) => {
                        insurer.preferenceTypeLid = preferredStatusId[0].id;
                    });
                }
                // Add preferenceTypeLid for excludedInsurers if it exists
                if (excludedInsurers?.length > 0) {
                    excludedInsurers.forEach((insurer) => {
                        insurer.preferenceTypeLid = excludedStatusId[0].id;
                    });
                }
                // excludedTPA.preferenceTypeLid = excludedStatusId[0].id;
                // Update main RFP Details Entry
                await this.opportunityRepository.updateRfpDetailsEntry(entityManager, existingEntry.id, mappedRfpDetailsData, userId);
                // Handle TPA Details
                if (preferredTPA?.length > 0 || excludedTPA?.length > 0) {
                    await this.opportunityRepository.updateRfpTpaDetails(entityManager, existingEntry.id, preferredTPA, excludedTPA, userId);
                }
                // Handle Insurer Details
                if (preferredInsurers?.length > 0 || excludedInsurers?.length > 0) {
                    await this.opportunityRepository.updateRfpInsurerDetails(entityManager, existingEntry.id, preferredInsurers, excludedInsurers, userId);
                }
                // Handle Client Contact Details
                if (clientContactDetails) {
                    await this.opportunityRepository.updateRfpClientContactDetails(entityManager, existingEntry.id, clientContactDetails, userId);
                }
                // Handle Credit Sharing
                if (creditSharing?.length > 0) {
                    await this.opportunityRepository.updateRfpCreditSharing(entityManager, existingEntry.id, creditSharing, userId);
                }
                // Handle Documents
                if (documents?.length > 0) {
                    await this.opportunityRepository.updateRfpDetailsEntryDocuments(entityManager, existingEntry.id, documents, userId);
                }
                const status = await this.lookUpRepository.findOne({
                    where: { id: updateOpportunityRfpDetailsEntryDto.statusLid },
                });
                if (!status) {
                    throw new common_1.NotFoundException(`Status with ID ${updateOpportunityRfpDetailsEntryDto.statusLid} not found`);
                }
                try {
                    if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED) {
                        // Creating Assignment task
                        const assignedUser = await this.employeeService.getParentUserWithPrivilege(userId, constants_2.ACL_CATEGORY.OPPORTUNITY_ACTIVITY, constants_2.ACL_ACTIONS.UPDATE);
                        if (!assignedUser) {
                            throw new common_1.NotFoundException(`No user found with privilages for assigning activity with ID ${updateOpportunityRfpDetailsEntryDto.opportunityActivityId}`);
                        }
                        const createTask = await this.opportunityRepository.createOpportunityActivityTaskObject(opportunityActivityId, constants_2.DEFAULT_RFP_DETAILS_ENTRY, constants_2.TASK_TYPE.APPROVAL, assignedUser.userId, userId);
                        if (!createTask) {
                            throw new common_1.NotFoundException(`Task creation object for opportunity activity ID ${opportunityActivityId} not found`);
                        }
                        await this.taskService.createTask(createTask, entityManager);
                    }
                }
                catch (error) {
                    console.log(error);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: updateOpportunityRfpDetailsEntryDto?.statusLid,
                    updatedBy: userId,
                });
                return {
                    success: true,
                    message: "RFP Details Entry updated successfully.",
                };
            });
        }
        catch (error) {
            console.error("Error updating RFP Details Entry:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update RFP Details Entry.");
        }
    }
    // Retrieves mandate details by opportunity activity ID
    async getMandateDetailsByOpportunityActivityId(opportunityActivityId) {
        try {
            const { opportunityId, activityId } = (await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId)) || {};
            if (!opportunityId || !activityId) {
                throw new common_1.NotFoundException(`Opportunity Activity not found for ID: ${opportunityActivityId}`);
            }
            // Query the repository
            const mandateDetails = await this.opportunityRepository.getMandateDetailsByOpportunityAndActivity(opportunityId, activityId);
            return mandateDetails;
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to retrieve mandate details");
        }
    }
    // Retrieves existing mandate details by opportunity activity ID.
    async getExistingMandateDetails(opportunityActivityId) {
        try {
            return await this.opportunityRepository.getExistingMandateDetails(opportunityActivityId);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException) {
                throw error;
            }
            throw new common_1.BadRequestException("Error retrieving mandate details ", error.message);
        }
    }
    async createPolicyConfirmationActivity(OpportunityActivityMap, activityMetaData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(activityMetaData, constants_1.LOOK_UP_DATA);
            return await this.dataSource.transaction(async (entityManager) => {
                // Create the policy confirmation record
                const policyConfirmationObject = {
                    opportunityId: OpportunityActivityMap.opportunityId,
                    activityId: OpportunityActivityMap.activityId,
                    statusLid: activityMetaData.statusLid,
                    opportunityActivityId: activityMetaData.opportunityActivityId,
                    policyDataWrongLid: activityMetaData.policyDataWrongSection?.policyDataWrongLid,
                    deviationResolvedLid: activityMetaData.policyDataWrongSection?.deviationResolvedLid,
                    comments: activityMetaData.policyDataWrongSection?.comments,
                    deviations: activityMetaData.deviationSection?.deviations,
                    policyDataRectifiedLid: activityMetaData.policyDataRectifiedSection?.policyDataRectifiedLid,
                    resolutionLid: activityMetaData.policyDataRectifiedSection?.resolutionLid,
                    remarks: activityMetaData.policyDataRectifiedSection?.remarks,
                };
                const documents = activityMetaData.documents;
                // Save policy confirmation
                const policyConfirmationData = await this.opportunityRepository.createPolicyConfirmation(entityManager, policyConfirmationObject, userId);
                // Save documents
                if (documents && documents.length > 0) {
                    await this.opportunityRepository.savePolicyConfirmationDocuments(policyConfirmationData.id, documents, entityManager);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: policyConfirmationData.opportunityActivityId }, {
                    statusLid: policyConfirmationData.statusLid,
                    updatedBy: userId,
                });
                return { id: policyConfirmationData.id, ...activityMetaData };
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaUpdateFailed);
        }
    }
    async createPolicyHardCopyActivity(OpportunityActivityMap, activityMetaData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(activityMetaData, constants_1.LOOK_UP_DATA);
            const policyHardCopyData = await this.dataSource.transaction(async (entityManager) => {
                // Create the policy hard copy record
                const policyHardCopyObject = {
                    opportunityId: OpportunityActivityMap.opportunityId,
                    activityId: OpportunityActivityMap.activityId,
                    statusLid: activityMetaData.statusLid,
                    opportunityActivityId: activityMetaData.opportunityActivityId,
                    insurerPolicyNo: activityMetaData.insurerPolicyHardCopyDetails.insurerPolicyNo,
                    hardCopyReceivedOn: activityMetaData.insurerPolicyHardCopyDetails.hardCopyReceivedOn,
                    deviationsLid: activityMetaData.deviationSection.deviationsLid,
                    premium: activityMetaData.deviationSection.premium,
                    brokeragePercentage: activityMetaData.deviationSection.brokeragePercentage,
                    deviationCoveragesLid: activityMetaData.deviationSection.deviationCoveragesLid,
                    coverages: activityMetaData.deviationSection.coverages,
                    exclusions: activityMetaData.deviationSection.exclusions,
                    deductibles: activityMetaData.deviationSection.deductibles,
                    deviationsAddressedLid: activityMetaData.deviationsAddressedSection
                        .deviationsAddressedLid,
                    policyHardCopyReceivedLid: activityMetaData.deviationsAddressedSection
                        .policyHardCopyReceivedLid,
                    resolutionLid: activityMetaData.deviationsAddressedSection.resolutionLid,
                    remarks: activityMetaData.deviationsAddressedSection.remarks,
                };
                const documents = activityMetaData.documents;
                // Save policy hard copy
                const policyHardCopyData = await this.opportunityRepository.createPolicyHardCopy(entityManager, policyHardCopyObject, userId);
                // Save documents
                if (documents && documents.length > 0) {
                    await this.opportunityRepository.savePolicyHardCopyDocuments(policyHardCopyData.id, documents, entityManager);
                }
                return policyHardCopyData;
            });
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: policyHardCopyData.opportunityActivityId }, {
                statusLid: policyHardCopyData.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(policyHardCopyData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.POLICY_DOCKET, policyHardCopyData.statusLid);
            return { id: policyHardCopyData.id, ...activityMetaData };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaUpdateFailed);
        }
    }
    async createQuote(opportunityActivityId, dto, userId) {
        try {
            // Validate the DTO
            const savedQuote = await this.dataSource.transaction(async (manager) => {
                // Step 1: Check if opportunity exists
                const opportunity = await this.opportunityRepository.findOpportunityById(dto.opportunityId, manager);
                if (!opportunity) {
                    throw new common_1.NotFoundException(`Opportunity with ID ${dto.opportunityId} not found.`);
                }
                // Step 2: Create and save the quote
                const quote = this.opportunityRepository.createQuoteEntity(opportunityActivityId, dto, userId);
                const savedQuote = await this.opportunityRepository.saveQuote(quote, manager);
                // Step 3: Save documents if any
                if (dto.documents && dto.documents.length > 0) {
                    const documentMaps = this.opportunityRepository.createDocumentMappings(savedQuote.id, dto.documents);
                    await this.opportunityRepository.saveDocumentMappings(documentMaps, manager);
                }
                if (dto.covers && typeof dto.covers === "object") {
                    const coversArray = Object.entries(dto.covers).map(([id, response]) => ({
                        id: Number(id),
                        response,
                        quoteId: savedQuote.id,
                    }));
                    await this.addQuoteCoverDetails(manager, opportunityActivityId, coversArray, userId);
                }
                if (dto.taxDetails && Array.isArray(dto.taxDetails)) {
                    await this.addQuoteTaxDetails(manager, savedQuote.id, dto.taxDetails, userId);
                }
                if (dto.remarksSection ||
                    dto.mainDocuments ||
                    typeof dto.quoteStatusLid !== "undefined") {
                    const existing = await this.opportunityRepository.findOpportunityQuoteById(savedQuote.id, manager);
                    if (existing) {
                        await this.opportunityRepository.updateOpportunityQuote(manager, savedQuote.id, {
                            remarks: dto.remarksSection?.remarks,
                            statusLid: dto.quoteStatusLid,
                            brokingSlipId: savedQuote.brokingSlipId,
                        });
                        await this.opportunityRepository.deleteOpportunityQuoteDocumentMappings(savedQuote.id, manager);
                    }
                    else {
                        await this.opportunityRepository.createOpportunityQuote(manager, savedQuote.id, {
                            remarks: dto.remarksSection?.remarks,
                            statusLid: dto.quoteStatusLid,
                            brokingSlipId: savedQuote.brokingSlipId,
                        });
                    }
                    if (dto.mainDocuments && dto.mainDocuments.length > 0) {
                        const maps = this.opportunityRepository.createOpportunityQuoteDocumentMappings(savedQuote.id, dto.mainDocuments);
                        await this.opportunityRepository.saveOpportunityQuoteDocumentMappings(manager, maps);
                    }
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: dto.statusId,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.QUOTE_COMPARISON_REPORT, dto?.statusId);
                return savedQuote;
            });
            if (!savedQuote) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityQuoteNotFound);
            }
            if (!savedQuote.brokingSlipId) {
                throw new common_1.NotFoundException(`Broking Slip ID for Quote with ID ${savedQuote.id} not found.`);
            }
            const allQuotesData = await this.getQuotesByBrokingSlip(savedQuote.brokingSlipId);
            const currentQuoteDetails = allQuotesData?.quotes?.find((individualQuoteData) => individualQuoteData.id === savedQuote.id);
            return currentQuoteDetails;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to create quote.");
        }
    }
    async updateQuote(quoteId, dto, userId) {
        try {
            const updatedQuote = await this.dataSource.transaction(async (manager) => {
                // Step 1: Check if the quote exists
                const existingQuote = await this.opportunityRepository.findQuoteById(quoteId, manager);
                if (!existingQuote) {
                    throw new common_1.NotFoundException(messages_1.errorMessages.opportunityQuoteNotFound);
                }
                // Step 2: Prepare the updated quote
                const { taxDetails, quoteDetails, netPremiumDetails, ...rest } = dto;
                const updatedQuote = {
                    ...existingQuote,
                    ...rest,
                    insurerId: quoteDetails?.insurerId,
                    quoteReceivedOn: quoteDetails?.quoteReceivedOn,
                    basicPremium: quoteDetails?.basicPremium,
                    terrorismCover: quoteDetails?.terrorismCover,
                    netPremium: netPremiumDetails?.netPremium,
                    brokeragePercent: netPremiumDetails?.brokeragePercent,
                    insurerRemarks: netPremiumDetails?.insurerRemarks,
                    updatedBy: userId,
                    updatedAt: new Date(),
                };
                // Step 3: Save the updated quote
                await this.opportunityRepository.saveQuote(updatedQuote, manager);
                // Step 4: Handle document mappings if any
                if (dto.documents && Array.isArray(dto.documents)) {
                    // Delete existing document mappings
                    await this.opportunityRepository.deleteDocumentMappings(quoteId, manager);
                    // Create new document mappings
                    const documentMaps = dto.documents.map((doc) => ({
                        opportunityQuoteEntryId: quoteId,
                        documentId: doc.documentId,
                    }));
                    // Save the new document mappings
                    await this.opportunityRepository.saveDocumentMappings(documentMaps, manager);
                }
                if (taxDetails && Array.isArray(taxDetails)) {
                    await this.opportunityRepository.deleteQuoteTaxDetails(quoteId, manager);
                    const records = this.opportunityRepository.prepareQuoteTaxDetails(taxDetails, quoteId, userId);
                    await this.opportunityRepository.saveQuoteTaxDetails(manager, records);
                }
                if (dto.covers && typeof dto.covers === "object") {
                    await this.opportunityRepository.deleteQuoteCoverDetails(quoteId, manager);
                    const coversArray = Object.entries(dto.covers).map(([id, response]) => ({
                        id: Number(id),
                        response,
                        quoteId,
                    }));
                    await this.addQuoteCoverDetails(manager, existingQuote.opportunityActivityId, coversArray, userId);
                }
                if (dto.remarksSection ||
                    dto.mainDocuments ||
                    typeof dto.quoteStatusLid !== "undefined") {
                    const existing = await this.opportunityRepository.findOpportunityQuoteById(quoteId, manager);
                    if (existing) {
                        await this.opportunityRepository.upsertOpportunityQuote(manager, quoteId, {
                            remarks: dto.remarksSection?.remarks,
                            statusLid: dto.quoteStatusLid,
                            opportunityActivityId: existingQuote.opportunityActivityId,
                        });
                        await this.opportunityRepository.upsertOpportunityQuoteDocumentMapping(quoteId, dto.mainDocuments, manager);
                    }
                    else {
                        await this.opportunityRepository.createOpportunityQuote(manager, quoteId, {
                            remarks: dto.remarksSection?.remarks,
                            statusLid: dto.quoteStatusLid,
                            opportunityActivityId: dto.opportunityActivityId,
                        });
                    }
                    if (dto.mainDocuments && dto.mainDocuments.length > 0) {
                        const maps = this.opportunityRepository.createOpportunityQuoteDocumentMappings(existingQuote.opportunityActivityId, dto.mainDocuments);
                        await this.opportunityRepository.saveOpportunityQuoteDocumentMappings(manager, maps);
                    }
                }
                return existingQuote;
            });
            if (!updatedQuote) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityQuoteNotFound);
            }
            if (!updatedQuote.brokingSlipId) {
                throw new common_1.NotFoundException(`Broking Slip ID for Quote with ID ${updatedQuote.id} not found.`);
            }
            const allQuotesData = await this.getQuotesByBrokingSlip(updatedQuote.brokingSlipId);
            const currentQuoteDetails = allQuotesData?.quotes?.find((individualQuoteData) => individualQuoteData.id === updatedQuote.id);
            return currentQuoteDetails;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to update quote.");
        }
    }
    async getQuoteByBrokingSlipAndActivity(brokingSlipId, opportunityActivityId) {
        try {
            const quote = await this.opportunityRepository.findQuotesByBrokingSlipAndActivity(brokingSlipId, opportunityActivityId);
            if (!quote) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityQuoteNotFound);
            }
            return quote;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async getQuotesByBrokingSlip(brokingSlipId) {
        try {
            const brokingSlipData = await this.opportunityRepository.getBrokingSlipDetailsById(brokingSlipId);
            if (!brokingSlipData) {
                throw new common_1.NotFoundException(`Broking Slip with ID ${brokingSlipId} not found.`);
            }
            const quotes = await this.opportunityRepository.findQuotesByBrokingSlip(brokingSlipId);
            // console.log("Quotes retrieved for broking slip:", quotes);
            if (!quotes || quotes.length === 0) {
                return {
                    quotes: [],
                    createdAt: new Date(brokingSlipData.createdAt),
                    sumInsured: Number(brokingSlipData.sumInsured),
                    policyFrom: new Date(brokingSlipData.policyFrom),
                    policyTo: new Date(brokingSlipData.policyTo),
                };
            }
            else {
                const transformedQuotes = await this.transformQuotes(quotes);
                return {
                    quotes: transformedQuotes,
                    createdAt: new Date(brokingSlipData.createdAt),
                    sumInsured: Number(brokingSlipData.sumInsured),
                    policyFrom: new Date(brokingSlipData.policyFrom),
                    policyTo: new Date(brokingSlipData.policyTo),
                };
            }
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async createPolicyDocketActivity(OpportunityActivityMap, activityMetaData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(activityMetaData, constants_1.LOOK_UP_DATA);
            await this.validateIssuanceDateWithinOpportunityPeriod(OpportunityActivityMap.opportunityId, activityMetaData.placementSlipDetailsSection.issuanceDate);
            const policyDocketData = await this.dataSource.transaction(async (entityManager) => {
                // Create the policy docket record
                const policyDocketObject = {
                    opportunityId: OpportunityActivityMap.opportunityId,
                    activityId: OpportunityActivityMap.activityId,
                    statusLid: activityMetaData.statusLid,
                    opportunityActivityId: activityMetaData.opportunityActivityId,
                    issuanceDate: activityMetaData.placementSlipDetailsSection.issuanceDate,
                    heldCoverNote: activityMetaData.serviceLevelAgreementSection.heldCoverNote,
                    policyDocument: activityMetaData.serviceLevelAgreementSection.policyDocument,
                    policyDocket: activityMetaData.serviceLevelAgreementSection.policyDocket,
                    endorsement: activityMetaData.serviceLevelAgreementSection.endorsement,
                    healthClaims: activityMetaData.serviceLevelAgreementSection.healthClaims,
                    nonHealthClaims: activityMetaData.serviceLevelAgreementSection.nonHealthClaims,
                    mir: activityMetaData.serviceLevelAgreementSection.mir,
                    monthlyMeeting: activityMetaData.serviceLevelAgreementSection.monthlyMeeting,
                    quarterlyMeeting: activityMetaData.serviceLevelAgreementSection.quarterlyMeeting,
                    renewalNotice: activityMetaData.serviceLevelAgreementSection.renewalNotice,
                    dataCollection: activityMetaData.serviceLevelAgreementSection.dataCollection,
                    remarks: activityMetaData.serviceLevelAgreementSection.remarks,
                };
                const documents = activityMetaData.documents;
                // Save policy docket
                const policyDocketData = await this.opportunityRepository.createPolicyDocket(entityManager, policyDocketObject, userId);
                // Save documents
                if (documents && documents.length > 0) {
                    await this.opportunityRepository.savePolicyDocketDocuments(policyDocketData.id, documents, entityManager);
                }
                return policyDocketData;
            });
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: policyDocketData.opportunityActivityId }, {
                statusLid: policyDocketData.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(policyDocketData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.HAND_OVER_MEET, policyDocketData.statusLid);
            return { id: policyDocketData.id, ...activityMetaData };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaUpdateFailed);
        }
    }
    async getPolicyDocketActivity(opportunityActivityId) {
        try {
            const policyDocket = await this.opportunityRepository.getPolicyDocketByOpportunityActivityId(opportunityActivityId);
            if (!policyDocket) {
                throw new common_1.NotFoundException(`Policy docket not found for opportunity activity ID ${opportunityActivityId}`);
            }
            let documents = policyDocket?.documents ?? [];
            if (documents.length > 0) {
                documents = documents.map(({ policyDocketId, ...rest }) => rest);
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: policyDocket.id,
                opportunityActivityId: policyDocket?.opportunityActivityId ?? null,
                statusLid: policyDocket?.statusLid ?? null,
                dataActivity: {
                    placementSlipDetailsSection: {
                        issuanceDate: policyDocket?.issuanceDate ?? null,
                    },
                    serviceLevelAgreementSection: {
                        heldCoverNote: policyDocket?.heldCoverNote ?? null,
                        policyDocument: policyDocket?.policyDocument ?? null,
                        policyDocket: policyDocket?.policyDocket ?? null,
                        endorsement: policyDocket?.endorsement ?? null,
                        healthClaims: policyDocket?.healthClaims ?? null,
                        nonHealthClaims: policyDocket?.nonHealthClaims ?? null,
                        mir: policyDocket?.mir ?? null,
                        monthlyMeeting: policyDocket?.monthlyMeeting ?? null,
                        quarterlyMeeting: policyDocket?.quarterlyMeeting ?? null,
                        renewalNotice: policyDocket?.renewalNotice ?? null,
                        dataCollection: policyDocket?.dataCollection ?? null,
                        remarks: policyDocket?.remarks ?? null,
                    },
                    documents: documents,
                },
            };
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving policy docket by opportunity activity ID");
        }
    }
    async updatePolicyDocketByIdActivity(opportunityActivityId, updatePolicyDocketDto, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updatePolicyDocketDto, constants_1.LOOK_UP_DATA);
            const policyDocketDetails = await this.opportunityRepository.getPolicyDocketByOpportunityActivityId(opportunityActivityId);
            if (!policyDocketDetails || !policyDocketDetails.id) {
                throw new common_1.NotFoundException(`Policy Docket details not found for activity ID ${opportunityActivityId}.`);
            }
            const updatedPolicyDocketData = await this.dataSource.transaction(async (entityManager) => {
                const { documents, ...fieldsToUpdate } = updatePolicyDocketDto;
                const updateData = {
                    statusLid: fieldsToUpdate.statusLid,
                    issuanceDate: fieldsToUpdate.placementSlipDetailsSection?.issuanceDate,
                    heldCoverNote: fieldsToUpdate.serviceLevelAgreementSection?.heldCoverNote,
                    policyDocument: fieldsToUpdate.serviceLevelAgreementSection?.policyDocument,
                    policyDocket: fieldsToUpdate.serviceLevelAgreementSection?.policyDocket,
                    endorsement: fieldsToUpdate.serviceLevelAgreementSection?.endorsement,
                    healthClaims: fieldsToUpdate.serviceLevelAgreementSection?.healthClaims,
                    nonHealthClaims: fieldsToUpdate.serviceLevelAgreementSection?.nonHealthClaims,
                    mir: fieldsToUpdate.serviceLevelAgreementSection?.mir,
                    monthlyMeeting: fieldsToUpdate.serviceLevelAgreementSection?.monthlyMeeting,
                    quarterlyMeeting: fieldsToUpdate.serviceLevelAgreementSection?.quarterlyMeeting,
                    renewalNotice: fieldsToUpdate.serviceLevelAgreementSection?.renewalNotice,
                    dataCollection: fieldsToUpdate.serviceLevelAgreementSection?.dataCollection,
                    remarks: fieldsToUpdate.serviceLevelAgreementSection?.remarks,
                };
                // Update the policy docket
                const updatedPolicyDocket = await this.opportunityRepository.updatePolicyDocket(entityManager, policyDocketDetails.id, updateData, userId);
                // Save documents if provided
                if (updatePolicyDocketDto.documents) {
                    const existingDocumentIds = await this.opportunityRepository.getEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_DOCKET_DOCUMENT_MAP, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, { policyDocketId: policyDocketDetails.id });
                    if (documents && documents.length > 0) {
                        // Process each document
                        for (const document of documents) {
                            if (document.id) {
                                const index = existingDocumentIds.indexOf(document.id);
                                if (index !== -1) {
                                    existingDocumentIds.splice(index, 1);
                                }
                                await this.opportunityRepository.updateDocument(entityManager, document.id, document.documentId, document.documentTypeLid, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_DOCKET_DOCUMENT_MAP);
                            }
                            else {
                                await this.opportunityRepository.savePolicyDocketDocuments(policyDocketDetails.id, [document], entityManager);
                            }
                        }
                        // Delete remaining documents that were not updated
                        if (existingDocumentIds.length > 0) {
                            await this.opportunityRepository.deleteFileUploadByIds(constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.FILE_UPLOAD, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_DOCKET_DOCUMENT_MAP, constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.DOCUMENT_ID, { id: (0, typeorm_2.In)(existingDocumentIds) }, constants_1.MAPPED_DATA_DELETION.SOFT_DELETE);
                            await this.opportunityRepository.deleteEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_DOCKET_DOCUMENT_MAP, existingDocumentIds, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
                        }
                    }
                }
                return {
                    ...updatePolicyDocketDto,
                    opportunityActivityId: opportunityActivityId,
                };
            });
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: updatedPolicyDocketData.opportunityActivityId }, {
                statusLid: updatedPolicyDocketData.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(updatedPolicyDocketData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.HAND_OVER_MEET, updatedPolicyDocketData.statusLid);
            return updatedPolicyDocketData;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error updating policy docket");
        }
    }
    async getOpportunityActivitesDataById(opportunityActivityId) {
        try {
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            console.log("opportunityActivityMapData", opportunityActivityMapData);
            if (!opportunityActivityMapData) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${opportunityActivityId}`);
            }
            else {
                const opportunityTable = opportunityActivityMapData.opportunityTable;
                if (opportunityTable === null) {
                    throw new common_1.NotFoundException("Opportunity activity Table not found");
                }
                let result;
                switch (opportunityTable) {
                    case "opportunity_data_validation":
                        result = await this.getDataValidationByOpportunityActivityId(opportunityActivityId);
                        break;
                    case "opportunity_kdm_meeting":
                        result = await this.getKdmMeeting(opportunityActivityId);
                        break;
                    case "opportunity_mandate_details_entry":
                        result = await this.getMandateDetailsByOpportunityActivityId(opportunityActivityId);
                        break;
                    case "opportunity_rfp_cover_detail":
                        result = await this.getRfpDataByOpportunityId(opportunityActivityId);
                        break;
                    case "opportunity_quote_entry":
                        result = await this.getQuoteByOpportunityActivityId(opportunityActivityId);
                        break;
                    case "opportunity_quote_comparison_report":
                        result = await this.getQuoteComparisonReportActivity(opportunityActivityId);
                        break;
                    case "opportunity_placement_slip_generation":
                        result = await this.getPlacementSlipActivity(opportunityActivityId);
                        break;
                    case "opportunity_premium_calculation":
                        result = await this.getPremiumCalculationActivity(opportunityActivityId);
                        break;
                    case "opportunity_rfp_details_entry":
                        result = await this.getRfpDetailsByOpportunityActivityId(opportunityActivityId);
                        break;
                    case "opportunity_final_negotiation":
                        result = await this.getFinalNegotiationActivity(opportunityActivityId);
                        break;
                    case "opportunity_held_cover_note":
                        result = await this.getHeldCoverNoteActivity(opportunityActivityId);
                        break;
                    case "opportunity_policy_confirmation":
                        result = await this.getPolicyConfirmationActivity(opportunityActivityId);
                        break;
                    case "opportunity_policy_hard_copy":
                        result = await this.getPolicyHardCopyActivity(opportunityActivityId);
                        break;
                    case "opportunity_policy_docket":
                        result = await this.getPolicyDocketActivity(opportunityActivityId);
                        break;
                    case "opportunity_hand_over_meet":
                        result = await this.getHandOverMeetById(opportunityActivityId);
                        break;
                    case "opportunity_lost":
                        result = await this.getOpportunityLostActivity(opportunityActivityId);
                        break;
                    default:
                        throw new common_1.BadRequestException(`Unsupported opportunity table: ${opportunityTable}`);
                }
                if (result?.dataActivity?.documents?.length > 0) {
                    try {
                        const uniqueDocuments = new Map();
                        for (const doc of result.dataActivity.documents) {
                            const fileName = await this.getFileNamesByDocumentIds([
                                doc.documentId,
                            ])
                                .then((fileNameMap) => fileNameMap.get(doc.documentId) || null)
                                .catch(() => null);
                            if (!fileName) {
                                uniqueDocuments.set(doc.documentId, {
                                    documentId: null,
                                    documentTypeLid: null,
                                    fileName: null,
                                    documentType: null,
                                });
                            }
                            else if (!uniqueDocuments.has(doc.documentId)) {
                                const lookupData = await this.lookUpRepository.findOne({
                                    where: { id: doc.documentTypeLid },
                                });
                                uniqueDocuments.set(doc.documentId, {
                                    ...doc,
                                    fileName,
                                    documentType: lookupData?.lookUpValue || null,
                                });
                            }
                        }
                        result.dataActivity.documents = Array.from(uniqueDocuments.values());
                    }
                    catch (error) {
                        console.error("Error fetching file names or document types:", error);
                        result.dataActivity.documents = result.dataActivity.documents.map(() => ({
                            documentId: null,
                            documentTypeLid: null,
                            fileName: null,
                            documentType: null,
                        }));
                    }
                }
                return result;
            }
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivitiesRetrieveFailed);
        }
    }
    async getFileNamesByDocumentIds(documentIds) {
        if (!documentIds || documentIds.length === 0) {
            return new Map();
        }
        const fileUploadRecords = await this.dataSource
            .getRepository(entities_1.FileUpload)
            .find({
            where: { id: (0, typeorm_2.In)(documentIds) },
        });
        const extractFileName = (filePath) => {
            const parts = filePath.split("/");
            return parts[parts.length - 1];
        };
        const fileNameMap = new Map(fileUploadRecords.map((file) => [file.id, extractFileName(file.fileKey)]));
        return fileNameMap;
    }
    async getHeldCoverNoteActivity(opportunityActivityId) {
        try {
            const heldCoverNote = await this.opportunityRepository.getHeldCoverNoteByOpportunityActivityId(opportunityActivityId);
            if (!heldCoverNote) {
                throw new common_1.NotFoundException(`Held Cover Note not found for Opportunity Activity Id: ${opportunityActivityId}`);
            }
            const activity = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            const placementSlipCovers = await this.opportunityRepository.getPlacementSlipCoverDetailsByOpportunityId(activity.opportunityId);
            const coverDetails = {};
            placementSlipCovers?.forEach((c) => {
                if (c.coverTemplateId !== undefined && c.coverResponse !== undefined) {
                    coverDetails[c.coverTemplateId] = c.coverResponse;
                }
            });
            let documents = heldCoverNote?.documents ?? [];
            if (documents.length > 0) {
                documents = documents.map(({ heldCoverNoteId, ...rest }) => rest);
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: heldCoverNote.id,
                opportunityActivityId: heldCoverNote?.opportunityActivityId ?? null,
                statusLid: heldCoverNote?.statusLid ?? null,
                dataActivity: {
                    placementSlipDeviationsSection: {
                        placementSlipDeviationsLid: heldCoverNote?.placementSlipDeviationsLid ?? null,
                    },
                    deviationSection: {
                        deviations: heldCoverNote?.deviations ?? null,
                    },
                    deviationsAddressedSection: {
                        deviationsAddressedLid: heldCoverNote?.deviationsAddressedLid ?? null,
                        resolutionLid: heldCoverNote?.resolutionLid ?? null,
                        revisedHeldCoverNoteLid: heldCoverNote?.revisedHeldCoverNoteLid ?? null,
                    },
                    premiumReceiptDetailsSection: {
                        acknowledgedBy: heldCoverNote?.acknowledgedBy ?? null,
                        receiptNo: heldCoverNote?.receiptNo ?? null,
                        receiptDate: heldCoverNote?.receiptDate ?? null,
                        allDocumentsReceivedDate: heldCoverNote?.allDocumentsReceivedDate ?? null,
                    },
                    remarksSection: {
                        remarks: heldCoverNote?.remarks ?? null,
                    },
                    coverDetails,
                    documents: documents,
                },
            };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityHeldCoverNoteRetrieveFailed);
        }
    }
    async getPolicyConfirmationActivity(opportunityActivityId) {
        try {
            const policyConfirmation = await this.opportunityRepository.getPolicyConfirmationByOpportunityActivityId(opportunityActivityId);
            if (!policyConfirmation) {
                throw new common_1.NotFoundException(`Policy Confirmation not found for Opportunity Activity Id: ${opportunityActivityId}`);
            }
            let documents = policyConfirmation?.documents ?? [];
            if (documents.length > 0) {
                documents = documents.map(({ policyConfirmationId, ...rest }) => rest);
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: policyConfirmation.id,
                opportunityActivityId: policyConfirmation?.opportunityActivityId ?? null,
                statusLid: policyConfirmation?.statusLid ?? null,
                dataActivity: {
                    policyDataWrongSection: {
                        policyDataWrongLid: policyConfirmation?.policyDataWrongLid ?? null,
                        deviationResolvedLid: policyConfirmation?.deviationResolvedLid ?? null,
                        comments: policyConfirmation?.comments ?? null,
                    },
                    deviationSection: {
                        deviations: policyConfirmation?.deviations ?? null,
                    },
                    policyDataRectifiedSection: {
                        policyDataRectifiedLid: policyConfirmation?.policyDataRectifiedLid ?? null,
                        resolutionLid: policyConfirmation?.resolutionLid ?? null,
                        remarks: policyConfirmation?.remarks ?? null,
                    },
                    documents: documents,
                },
            };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityPolicyConfirmationRetrieveFailed);
        }
    }
    async getPolicyHardCopyActivity(opportunityActivityId) {
        try {
            const policyHardCopy = await this.opportunityRepository.getPolicyHardCopyByOpportunityActivityId(opportunityActivityId);
            if (!policyHardCopy) {
                throw new common_1.NotFoundException(`Policy Hard Copy not found for Opportunity Activity Id: ${opportunityActivityId}`);
            }
            let documents = policyHardCopy?.documents ?? [];
            if (documents.length > 0) {
                documents = documents.map(({ policyHardCopyId, ...rest }) => rest);
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: policyHardCopy.id,
                opportunityActivityId: policyHardCopy?.opportunityActivityId ?? null,
                statusLid: policyHardCopy?.statusLid ?? null,
                dataActivity: {
                    insurerPolicyHardCopyDetails: {
                        insurerPolicyNo: policyHardCopy?.insurerPolicyNo ?? null,
                        hardCopyReceivedOn: policyHardCopy?.hardCopyReceivedOn ?? null,
                    },
                    deviationSection: {
                        deviationsLid: policyHardCopy?.deviationsLid ?? null,
                        premium: policyHardCopy?.premium ?? null,
                        brokeragePercentage: policyHardCopy?.brokeragePercentage ?? null,
                        brokerageAmount: null,
                        deviationCoveragesLid: policyHardCopy?.deviationCoveragesLid ?? null,
                        coverages: policyHardCopy?.coverages ?? null,
                        exclusions: policyHardCopy?.exclusions ?? null,
                        deductibles: policyHardCopy?.deductibles ?? null,
                    },
                    deviationsAddressedSection: {
                        deviationsAddressedLid: policyHardCopy?.deviationsAddressedLid ?? null,
                        policyHardCopyReceivedLid: policyHardCopy?.policyHardCopyReceivedLid ?? null,
                        resolutionLid: policyHardCopy?.resolutionLid ?? null,
                        remarks: policyHardCopy?.remarks ?? null,
                    },
                    documents: documents,
                },
            };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityPolicyHardCopyRetrieveFailed);
        }
    }
    async getPremiumCalculationActivity(opportunityActivityId) {
        try {
            const premiumCalculation = await this.opportunityRepository.getPremiumCalculationByOpportunityActivityId(opportunityActivityId);
            if (!premiumCalculation) {
                throw new common_1.NotFoundException(`Premium Calculation not found for Opportunity Activity Id: ${opportunityActivityId}`);
            }
            const coverDetails = await this.opportunityRepository.getPremiumCalculationCoverDetailsByActivityId(premiumCalculation.opportunityId);
            const documents = await this.opportunityRepository.getPremiumCalculationDocumentsByActivityId(opportunityActivityId);
            const premiumCalculationDetails = {};
            if (coverDetails && Array.isArray(coverDetails)) {
                for (const cover of coverDetails) {
                    premiumCalculationDetails[cover.coverMapId] = cover.coverResponse;
                }
            }
            const remarksSection = {
                remarks: premiumCalculation.remarks || null,
            };
            let docs = [];
            if (documents && Array.isArray(documents)) {
                docs = documents.map((doc) => ({
                    id: doc.id,
                    documentTypeLid: doc.documentTypeLid,
                    documentId: doc.documentId,
                }));
            }
            if (docs.length === 0) {
                docs = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: premiumCalculation.id,
                opportunityActivityId: premiumCalculation.opportunityActivityId,
                statusLid: premiumCalculation.statusLid,
                dataActivity: {
                    premiumCalculationDetails,
                    remarksSection,
                    documents: docs,
                },
            };
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.premiumCalculationRetrieveFailed);
        }
    }
    async getQuoteByOpportunityActivityId(opportunityActivityId) {
        try {
            const quote = await this.opportunityRepository.getQuoteByOpportunityActivityId(opportunityActivityId);
            if (!quote) {
                throw new common_1.NotFoundException(`Quote not found for Opportunity Activity Id: ${opportunityActivityId}`);
            }
            let documents = quote?.documents ?? [];
            if (documents.length > 0) {
                documents = documents.map(({ opportunityActivityId, ...rest }) => rest);
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: quote.id,
                opportunityActivityId: quote.opportunityActivityId,
                statusLid: quote.statusLid,
                dataActivity: {
                    remarksSection: {
                        remarks: quote.remarks,
                    },
                    mainDocuments: documents,
                },
            };
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving quote by opportunity activity ID");
        }
    }
    async getBrokingSlipVersionsByOpportunityId(opportunityId) {
        try {
            const brokingSlipVersions = await this.opportunityRepository.getBrokingSlipVersionsByOpportunityId(opportunityId);
            if (!brokingSlipVersions || brokingSlipVersions.length === 0) {
                throw new common_1.NotFoundException(`Broking slip versions not found for opportunity ID ${opportunityId}`);
            }
            return brokingSlipVersions;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving broking slip versions by opportunity Id");
        }
    }
    async getBrokingSlipVersionDetailsByOpportunityActivityId(opportunityActivityId) {
        try {
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivity(opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity Activity with ID ${opportunityActivityId} not found.`);
            }
            const brokingSlip = await this.opportunityRepository.getBrokingSlipDetailsByOpportunityId(opportunityActivity.opportunityId);
            if (!brokingSlip) {
                throw new common_1.NotFoundException(`Broking slip not found for opportunity Activity ID ${opportunityActivityId}`);
            }
            return {
                ...brokingSlip,
                statusLid: opportunityActivity.statusLid,
                opportunityActivityId: opportunityActivityId,
            };
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving broking slip by opportunity Id");
        }
    }
    async getBrokingSlipVersionDetailsByVersionId(opportunityId, versionId) {
        try {
            const brokingSlip = await this.opportunityRepository.getBrokingSlipByVersionId(versionId, opportunityId);
            if (!brokingSlip) {
                throw new common_1.NotFoundException(`Broking slip not found for opportunity ID ${opportunityId}`);
            }
            return brokingSlip;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving broking slip by opportunity ID");
        }
    }
    async generateBrokingSlipVersion(brokingSlipData, createdBy, opportunityId) {
        try {
            const response = await this.opportunityRepository.generateBrokingSlipVersion(brokingSlipData.brokingSlipVersionDetails, createdBy, opportunityId);
            if (!response) {
                throw new common_1.NotFoundException(`Broking slip not created for opportunity activity ID ${brokingSlipData.opportunityActivityId}`);
            }
            else {
                let result = await this.getBrokingSlipVersionDetailsByVersionId(opportunityId, response);
                if (!result) {
                    throw new common_1.NotFoundException(`Broking slip not created for opportunity activity ID ${brokingSlipData.opportunityActivityId}`);
                }
                let BrokingSlipVersionData = {
                    formData: result?.formData,
                    versionId: response,
                    versionName: result?.versionName,
                };
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: brokingSlipData.opportunityActivityId }, {
                    statusLid: brokingSlipData.statusLid,
                    updatedBy: createdBy,
                });
                await this.opportunityRepository.updateActivityStatus(brokingSlipData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.QUOTE_ENTRY, brokingSlipData.statusLid);
                return BrokingSlipVersionData;
            }
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error creating broking slip versions");
        }
    }
    async deleteBrokingSlipVersion(opportunityId, versionId) {
        try {
            await this.dataSource.transaction(async (entityManager) => {
                // Step 1: find the  details of the related broking slip version and delete them
                await this.opportunityRepository.deleteBrokingSlipVersionDetails(entityManager, opportunityId, versionId);
                // step 2: find the details of the related covers mapped to the version and delete them
                await this.opportunityRepository.deleteBrokingSlipVersionMappedCoversDetails(entityManager, versionId);
            });
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to update broking slip version.");
        }
    }
    async checkOpportunityActivityStatus(opportunityActivityId) {
        try {
            return await this.opportunityRepository.getOpportunityActivityStatus(opportunityActivityId);
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to get the status of opportunity activity Id.");
        }
    }
    async updateBrokingSlipVersions(opportunityActivityId, versionId, brokingSlipVersionDetails, statusLid) {
        try {
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivityMapData) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${opportunityActivityId}`);
            }
            // TODO: Uncomment for checking the status of the opportunity activity
            // Check for the submitted activity status based on the opportunity activity Id
            // let brokingSlipActivityDataSubmitted = await this.checkOpportunityActivityStatus(opportunityActivityId);
            // if(brokingSlipActivityDataSubmitted) {
            //   throw new NotFoundException(
            //     `Opportunity activity with ID ${opportunityId} is already submitted.`
            //   );
            // }
            await this.dataSource.transaction(async (entityManager) => {
                // Step 1: find the  details of the related broking slip version and update them
                await this.opportunityRepository.updateBrokingSlipVersionDetails(entityManager, {
                    brokeragePercentage: parseFloat(brokingSlipVersionDetails.formData.versionDetails
                        .brokeragePercentage),
                    sumInsured: brokingSlipVersionDetails.formData.versionDetails.sumInsured,
                    brokingSlipName: brokingSlipVersionDetails.versionName,
                    brokingSlipVersion: versionId,
                    businessActivity: brokingSlipVersionDetails.formData.versionDetails
                        .businessActivity,
                    clauses: "",
                    policyFrom: new Date(brokingSlipVersionDetails.formData.versionDetails.policyFrom),
                    policyTo: new Date(brokingSlipVersionDetails.formData.versionDetails.policyTo),
                    id: versionId,
                    insurerRemarks: "",
                    remarks: "",
                    renewalDate: new Date(brokingSlipVersionDetails.formData.versionDetails.renewalDate),
                    riskMitigationFeatures: "",
                    quoteReceiptTimeline: new Date(brokingSlipVersionDetails.formData.versionDetails.quoteReceiptTimeline),
                    opportunityId: opportunityActivityMapData.opportunityId,
                });
                // step 2: find the details of the related covers mapped to the version and update them
                await this.opportunityRepository.updateBrokingSlipVersionMappedCoversDetails(entityManager, brokingSlipVersionDetails.formData.coversConfig, versionId);
            });
            let result = await this.getBrokingSlipVersionDetailsByVersionId(opportunityActivityMapData.opportunityId, versionId);
            if (!result) {
                throw new common_1.NotFoundException(`Broking slip not created for opportunity ID ${opportunityActivityMapData.opportunityId}`);
            }
            let BrokingSlipVersionData = {
                formData: result?.formData,
                versionId: versionId,
                versionName: result?.versionName,
            };
            return BrokingSlipVersionData;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to update broking slip version.");
        }
    }
    async updateBrokingSlipData(opportunityActivityId, brokingSlipDetails, statusLid) {
        try {
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivityMapData) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${opportunityActivityId}`);
            }
            const { preferredTPADetails, preferredInsurerDetails, others, documents, } = brokingSlipDetails;
            // TODO: Uncomment for checking the status of the opportunity activity
            // Check for the submitted activity status based on the opportunity activity Id
            // let brokingSlipActivityDataSubmitted = await this.checkOpportunityActivityStatus(opportunityActivityId);
            // if(brokingSlipActivityDataSubmitted) {
            //   throw new NotFoundException(
            //     `Opportunity activity with ID ${opportunityId} is already submitted.`
            //   );
            // }
            await this.dataSource.transaction(async (entityManager) => {
                await this.opportunityRepository.updateBrokingSlipDetails(entityManager, {
                    insurerRemarks: others.insurerRemarks,
                    remarks: others.remarks,
                    riskMitigationFeatures: others.riskMitigationFeatures,
                    clauses: others.clauses,
                    opportunityId: opportunityActivityMapData.opportunityId,
                });
                await this.opportunityRepository.updateBrokingSlipMappedPreferredInsurerDetails(entityManager, preferredInsurerDetails, opportunityActivityMapData.opportunityId);
                await this.opportunityRepository.updateBrokingSlipMappedPreferredTpaDetails(entityManager, preferredTPADetails, opportunityActivityMapData.opportunityId);
                await this.opportunityRepository.updateBrokingSlipMappedDocumentDetails(entityManager, documents, opportunityActivityMapData.opportunityId, opportunityActivityId);
            });
            await this.opportunityRepository.updateOpportunityActivityStatus(opportunityActivityId, statusLid);
            let result = await this.opportunityRepository.getBrokingSlipDetailsByOpportunityId(opportunityActivityMapData.opportunityId);
            if (!result) {
                throw new common_1.NotFoundException(`Broking slip not created for opportunity ID ${opportunityActivityMapData.opportunityId}`);
            }
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, { statusLid: statusLid });
            await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.QUOTE_ENTRY, statusLid);
            return {
                ...result,
                statusLid: statusLid,
                opportunityActivityId: opportunityActivityId,
            };
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to update broking slip version.");
        }
    }
    async updateHeldCoverNoteById(opportunityActivityId, updateHeldCoverNoteData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updateHeldCoverNoteData, constants_1.LOOK_UP_DATA);
            const heldCoverNoteDetails = await this.opportunityRepository.getHeldCoverNoteByOpportunityActivityId(opportunityActivityId);
            if (!heldCoverNoteDetails || !heldCoverNoteDetails.id) {
                throw new common_1.NotFoundException(`Held Cover not found for opportunity activity ID ${opportunityActivityId}.`);
            }
            const heldCoverNoteDataUpdated = await this.dataSource.transaction(async (entityManager) => {
                // Update the held cover note
                const documents = updateHeldCoverNoteData.documents ?? [];
                const fieldsToUpdate = {};
                fieldsToUpdate.placementSlipDeviationsLid =
                    updateHeldCoverNoteData.placementSlipDeviationsSection.placementSlipDeviationsLid;
                fieldsToUpdate.deviations =
                    updateHeldCoverNoteData.deviationSection.deviations;
                fieldsToUpdate.deviationsAddressedLid =
                    updateHeldCoverNoteData.deviationsAddressedSection.deviationsAddressedLid;
                fieldsToUpdate.resolutionLid =
                    updateHeldCoverNoteData.deviationsAddressedSection.resolutionLid;
                fieldsToUpdate.revisedHeldCoverNoteLid =
                    updateHeldCoverNoteData.deviationsAddressedSection.revisedHeldCoverNoteLid;
                fieldsToUpdate.acknowledgedBy =
                    updateHeldCoverNoteData.premiumReceiptDetailsSection.acknowledgedBy;
                fieldsToUpdate.receiptDate =
                    updateHeldCoverNoteData.premiumReceiptDetailsSection.receiptDate;
                fieldsToUpdate.receiptNo =
                    updateHeldCoverNoteData.premiumReceiptDetailsSection.receiptNo;
                fieldsToUpdate.allDocumentsReceivedDate =
                    updateHeldCoverNoteData.premiumReceiptDetailsSection.allDocumentsReceivedDate;
                fieldsToUpdate.remarks =
                    updateHeldCoverNoteData.remarksSection.remarks;
                const updatedheldCoverNoteData = await this.opportunityRepository.updateHeldCoverNoteActivity(entityManager, heldCoverNoteDetails.id, fieldsToUpdate, userId);
                // Save documents if provided
                if (updateHeldCoverNoteData.documents) {
                    const existingDocumentIds = await this.opportunityRepository.getEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.HELD_COVER_NOTE_DOCUMENT_MAP, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, { heldCoverNoteId: heldCoverNoteDetails.id });
                    if (documents.length > 0) {
                        // Process each document
                        for (const document of documents) {
                            if (document.id) {
                                const index = existingDocumentIds.indexOf(document.id);
                                if (index !== -1) {
                                    existingDocumentIds.splice(index, 1);
                                }
                                await this.opportunityRepository.updateDocument(entityManager, document.id, document.documentId, document.documentTypeLid, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.HELD_COVER_NOTE_DOCUMENT_MAP);
                            }
                            else {
                                await this.opportunityRepository.saveHeldCoverNoteDocuments(heldCoverNoteDetails.id, [document], entityManager);
                            }
                        }
                    }
                    // Delete remaining documents that were not updated
                    if (existingDocumentIds.length > 0) {
                        await this.opportunityRepository.deleteFileUploadByIds(constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.FILE_UPLOAD, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.HELD_COVER_NOTE_DOCUMENT_MAP, constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.DOCUMENT_ID, { id: (0, typeorm_2.In)(existingDocumentIds) }, constants_1.MAPPED_DATA_DELETION.SOFT_DELETE);
                        await this.opportunityRepository.deleteEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.HELD_COVER_NOTE_DOCUMENT_MAP, existingDocumentIds, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
                    }
                }
                return updatedheldCoverNoteData;
            });
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: heldCoverNoteDataUpdated.opportunityActivityId }, {
                statusLid: heldCoverNoteDataUpdated.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(heldCoverNoteDataUpdated.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.POLICY_HARD_COPY, heldCoverNoteDataUpdated.statusLid);
            return heldCoverNoteDataUpdated;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.heldCoverNoteUpdateFailed);
        }
    }
    async updatePolicyConfirmationById(opportunityActivityId, updatePolicyConfirmationData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updatePolicyConfirmationData, constants_1.LOOK_UP_DATA);
            const policyConfirmationDetails = await this.opportunityRepository.getPolicyConfirmationByOpportunityActivityId(opportunityActivityId);
            if (!policyConfirmationDetails || !policyConfirmationDetails.id) {
                throw new common_1.NotFoundException(`Policy confirmation details not found for activity ID ${opportunityActivityId}.`);
            }
            const PolicyConfirmationUpdatedData = await this.dataSource.transaction(async (entityManager) => {
                // Update the policy confirmation
                const { documents, ...fieldsToUpdate } = updatePolicyConfirmationData;
                const updateData = {};
                updateData.statusLid = fieldsToUpdate.statusLid;
                updateData.policyDataWrongLid =
                    fieldsToUpdate.policyDataWrongSection.policyDataWrongLid;
                updateData.deviationResolvedLid =
                    fieldsToUpdate?.policyDataWrongSection?.deviationResolvedLid ??
                        null;
                updateData.comments =
                    fieldsToUpdate?.policyDataWrongSection?.comments ?? null;
                updateData.deviations = fieldsToUpdate.deviationSection.deviations;
                updateData.policyDataRectifiedLid =
                    fieldsToUpdate.policyDataRectifiedSection.policyDataRectifiedLid;
                updateData.resolutionLid =
                    fieldsToUpdate.policyDataRectifiedSection.resolutionLid;
                updateData.remarks =
                    fieldsToUpdate.policyDataRectifiedSection.remarks;
                const updatedPolicyConfirmationData = await this.opportunityRepository.updatePolicyConfirmationActivity(entityManager, policyConfirmationDetails.id, updateData, userId);
                // Save documents if provided
                if (updatePolicyConfirmationData.documents) {
                    const existingDocumentIds = await this.opportunityRepository.getEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_CONFIRMATION_DOCUMENT_MAP, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, { policyConfirmationId: policyConfirmationDetails.id });
                    if (documents && documents.length > 0) {
                        // Process each document
                        for (const document of documents) {
                            if (document.id) {
                                const index = existingDocumentIds.indexOf(document.id);
                                if (index !== -1) {
                                    existingDocumentIds.splice(index, 1);
                                }
                                await this.opportunityRepository.updateDocument(entityManager, document.id, document.documentId, document.documentTypeLid, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_CONFIRMATION_DOCUMENT_MAP);
                            }
                            else {
                                await this.opportunityRepository.savePolicyConfirmationDocuments(policyConfirmationDetails.id, [document], entityManager);
                            }
                        }
                    }
                    // Delete remaining documents that were not updated
                    if (existingDocumentIds.length > 0) {
                        await this.opportunityRepository.deleteFileUploadByIds(constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.FILE_UPLOAD, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_CONFIRMATION_DOCUMENT_MAP, constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.DOCUMENT_ID, { id: (0, typeorm_2.In)(existingDocumentIds) }, constants_1.MAPPED_DATA_DELETION.SOFT_DELETE);
                        await this.opportunityRepository.deleteEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_CONFIRMATION_DOCUMENT_MAP, existingDocumentIds, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
                    }
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: updatedPolicyConfirmationData.opportunityActivityId }, {
                    statusLid: updatedPolicyConfirmationData?.statusLid,
                    updatedBy: userId,
                });
                return updatedPolicyConfirmationData;
            });
            return PolicyConfirmationUpdatedData;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.policyConfirmationUpdateFailed);
        }
    }
    async updatePolicyHardCopyById(opportunityActivityId, updatePolicyHardCopyData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updatePolicyHardCopyData, constants_1.LOOK_UP_DATA);
            const policyHardCopyDetails = await this.opportunityRepository.getPolicyHardCopyByOpportunityActivityId(opportunityActivityId);
            if (!policyHardCopyDetails || !policyHardCopyDetails.opportunityId) {
                throw new common_1.NotFoundException(`Policy Hard Copy details not found for activity ID ${opportunityActivityId}.`);
            }
            const updatedPolicyHardCopy = await this.dataSource.transaction(async (entityManager) => {
                const { documents, ...fieldsToUpdate } = updatePolicyHardCopyData;
                const updateData = {
                    statusLid: fieldsToUpdate.statusLid,
                    insurerPolicyNo: fieldsToUpdate.insurerPolicyHardCopyDetails?.insurerPolicyNo,
                    hardCopyReceivedOn: fieldsToUpdate.insurerPolicyHardCopyDetails?.hardCopyReceivedOn,
                    deviationsLid: fieldsToUpdate.deviationSection?.deviationsLid,
                    premium: fieldsToUpdate.deviationSection?.premium,
                    brokeragePercentage: fieldsToUpdate.deviationSection?.brokeragePercentage,
                    deviationCoveragesLid: fieldsToUpdate.deviationSection?.deviationCoveragesLid,
                    coverages: fieldsToUpdate.deviationSection?.coverages,
                    exclusions: fieldsToUpdate.deviationSection?.exclusions,
                    deductibles: fieldsToUpdate.deviationSection?.deductibles,
                    deviationsAddressedLid: fieldsToUpdate.deviationsAddressedSection?.deviationsAddressedLid,
                    policyHardCopyReceivedLid: fieldsToUpdate.deviationsAddressedSection
                        ?.policyHardCopyReceivedLid,
                    resolutionLid: fieldsToUpdate.deviationsAddressedSection?.resolutionLid,
                    remarks: fieldsToUpdate.deviationsAddressedSection?.remarks,
                };
                // Update the policy hard copy
                const updatedPolicyHardCopyData = await this.opportunityRepository.updatePolicyHardCopyActivity(entityManager, policyHardCopyDetails.id, updateData, userId);
                // Save documents if provided
                if (updatePolicyHardCopyData.documents) {
                    const existingDocumentIds = await this.opportunityRepository.getEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_HARD_COPY_DOCUMENT_MAP, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, { policyHardCopyId: policyHardCopyDetails.id });
                    if (documents && documents.length > 0) {
                        // Process each document
                        for (const document of documents) {
                            if (document.id) {
                                const index = existingDocumentIds.indexOf(document.id);
                                if (index !== -1) {
                                    existingDocumentIds.splice(index, 1);
                                }
                                await this.opportunityRepository.updateDocument(entityManager, document.id, document.documentId, document.documentTypeLid, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_HARD_COPY_DOCUMENT_MAP);
                            }
                            else {
                                await this.opportunityRepository.savePolicyHardCopyDocuments(policyHardCopyDetails.id, [document], entityManager);
                            }
                        }
                    }
                    // Delete remaining documents that were not updated
                    if (existingDocumentIds.length > 0) {
                        await this.opportunityRepository.deleteFileUploadByIds(constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.FILE_UPLOAD, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_HARD_COPY_DOCUMENT_MAP, constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.DOCUMENT_ID, { id: (0, typeorm_2.In)(existingDocumentIds) }, constants_1.MAPPED_DATA_DELETION.SOFT_DELETE);
                        await this.opportunityRepository.deleteEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.POLICY_HARD_COPY_DOCUMENT_MAP, existingDocumentIds, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
                    }
                }
                return updatedPolicyHardCopyData;
            });
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: updatedPolicyHardCopy.opportunityActivityId }, {
                statusLid: updatedPolicyHardCopy.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(updatedPolicyHardCopy.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.POLICY_DOCKET, updatedPolicyHardCopy.statusLid);
            return updatedPolicyHardCopy;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.policyHardCopyUpdateFailed);
        }
    }
    async createHandOverMeet(createHandOverMeetDto, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(createHandOverMeetDto, constants_1.LOOK_UP_DATA);
            const { opportunityActivityId: activityId, statusLid, ...meetingData } = createHandOverMeetDto;
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivityById(activityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity activity with ID ${activityId} not found.`);
            }
            const opportunity = await this.opportunityRepo.findOne({
                where: { opportunityId: opportunityActivity.opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityActivity.opportunityId} not found.`);
            }
            const existingMeetingId = createHandOverMeetDto.handOverMeetFields.selectMeeting;
            return await this.dataSource.transaction(async (entityManager) => {
                let meeting;
                const companyParticipantsData = meetingData.participants
                    .companyContactPerson
                    ? {
                        companyId: opportunity.companyId,
                        companyContactPerson: meetingData.participants.companyContactPerson,
                    }
                    : undefined;
                const employeeParticipantsData = meetingData.participants.employees
                    ? {
                        employees: meetingData.participants.employees,
                    }
                    : undefined;
                const status = await this.lookUpRepository.findOne({
                    where: { id: statusLid },
                });
                if (!status) {
                    throw new common_1.NotFoundException(`Status with ID ${statusLid} not found`);
                }
                let handOverMeetingStatusLid;
                if (status.lookUpKey) {
                    if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                        status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                        const meetingStatus = await this.lookUpRepository.findOne({
                            where: { lookUpKey: constants_1.DEFAULT_MEETING_STATUS_COMPLETED },
                        });
                        if (!meetingStatus) {
                            throw new common_1.NotFoundException(`Meeting status with key ${constants_1.DEFAULT_MEETING_STATUS_COMPLETED} not found.`);
                        }
                        handOverMeetingStatusLid = meetingStatus.id;
                    }
                }
                await this.verifyMeetingType(meetingData.handOverMeetFields.meetingTypeLid, constants_1.MEETING_TYPE_KEY.HANDOVER, constants_1.MEETING_NAME.HANDOVER);
                if (existingMeetingId) {
                    const existingMeeting = await this.meetingRepo.findOne({
                        where: { id: existingMeetingId },
                    });
                    if (!existingMeeting) {
                        throw new common_1.NotFoundException(`Meeting with ID ${existingMeetingId} not found.`);
                    }
                    const meetingStatus = await this.LookUpService.getLookUpsByKey(constants_1.DEFAULT_MEETING_STATUS);
                    if (existingMeeting.meetingStatusLid === meetingStatus[0].id) {
                        meeting = await this.meetingService.updateMeeting(existingMeetingId, {
                            opportunityId: opportunityActivity.opportunityId,
                            activityId: activityId,
                            companyId: opportunity.companyId,
                            meetingTypeLid: meetingData.handOverMeetFields.meetingTypeLid,
                            meetingDate: meetingData.handOverMeetFields.meetingDate,
                            startTime: meetingData.handOverMeetFields.availableFrom,
                            endTime: meetingData.handOverMeetFields.availableTo,
                            meetingSubject: constants_2.DEFAULT_HAND_OVER_MEET,
                            meetingAgenda: constants_2.DEFAULT_HAND_OVER_MEET,
                            locationTypeLid: meetingData.handOverMeetFields.locationTypeLid,
                            updatedBy: userId,
                            companyParticipants: companyParticipantsData,
                            employeeParticipants: employeeParticipantsData,
                            documents: meetingData?.documents ?? undefined,
                            meetingStatusLid: handOverMeetingStatusLid ?? existingMeeting.meetingStatusLid,
                        }, entityManager);
                    }
                }
                else {
                    // Create the meeting
                    meeting = await this.meetingService.createMeeting({
                        opportunityId: opportunityActivity.opportunityId,
                        activityId: activityId,
                        companyId: opportunity.companyId,
                        meetingSubject: constants_2.DEFAULT_HAND_OVER_MEET,
                        meetingAgenda: constants_2.DEFAULT_HAND_OVER_MEET,
                        meetingTypeLid: meetingData.handOverMeetFields.meetingTypeLid,
                        meetingDate: meetingData.handOverMeetFields.meetingDate,
                        startTime: meetingData.handOverMeetFields.availableFrom,
                        endTime: meetingData.handOverMeetFields.availableTo,
                        locationTypeLid: meetingData.handOverMeetFields.locationTypeLid,
                        createdBy: userId,
                        updatedBy: userId,
                        employeeParticipants: employeeParticipantsData,
                        companyParticipants: companyParticipantsData,
                        documents: meetingData.documents,
                        meetingStatusLid: handOverMeetingStatusLid
                            ? handOverMeetingStatusLid
                            : null,
                    }, entityManager);
                }
                // Create the hand over meeting
                const handOverMeet = await this.opportunityRepository.createHandOveMeet(entityManager, {
                    meetingId: meeting.id,
                    opportunityId: opportunityActivity.opportunityId,
                    activityId: opportunityActivity.activityId,
                    opportunityActivityId: activityId,
                    handOverMeetingTypeLid: meetingData.handOverMeetFields.handOverMeetingTypeLid,
                    selectMeeting: null,
                    remarks: meetingData?.remarksMomSection?.remarks,
                    mom: meetingData?.remarksMomSection?.mom,
                    statusLid,
                    createdBy: userId,
                    updatedBy: userId,
                });
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: activityId }, {
                    statusLid: handOverMeet.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(activityId, constants_1.OPPORTUNITY_ACTIVITY.LOST, handOverMeet.statusLid, entityManager);
                return {
                    id: handOverMeet.id,
                    message: "Hand over meeting created successfully.",
                };
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to create Hand Over meeting");
        }
    }
    async createOpportunityRfpDetailsEntry(OpportunityActivityMap, createOpportunityRfpDetailsEntryDto, userId) {
        try {
            // Check if the activity already exists in the RFP Details Entry table
            const existingActivity = await this.opportunityRepository.checkActivityExists(createOpportunityRfpDetailsEntryDto.opportunityActivityId);
            const preferredStatusId = await this.LookUpService.getLookUpsByKey(constants_1.PREFERENCE_STATUS_PREFERRED);
            const excludedStatusId = await this.LookUpService.getLookUpsByKey(constants_1.PREFERENCE_STATUS_EXCLUDED);
            if (existingActivity) {
                throw new common_1.BadRequestException(`OpportunityActivity: ${createOpportunityRfpDetailsEntryDto.opportunityActivityId} already exists.`);
            }
            // Validate the OpportunityActivityMap
            return await this.dataSource.transaction(async (entityManager) => {
                // Validate dynamic lookup values
                await this.lookUpValidation.validateDynamicLookupValues(createOpportunityRfpDetailsEntryDto, constants_1.LOOK_UP_DATA);
                const { preferredTPA, excludedTPA, preferredInsurers, excludedInsurers, clientContactDetails, creditSharing, documents, descriptionRequirements, dynamicQuote, targetQcrDate, clientConsiderations, remarks, ...rfpDetailsData } = createOpportunityRfpDetailsEntryDto;
                const mappedRfpDetailsData = {
                    opportunityId: OpportunityActivityMap.opportunityId,
                    activityId: OpportunityActivityMap.activityId,
                    opportunityActivityId: createOpportunityRfpDetailsEntryDto.opportunityActivityId,
                    description: descriptionRequirements?.description || null,
                    requirements: descriptionRequirements?.requirements || null,
                    targetQcrDate: targetQcrDate?.targetQcrDate || null,
                    multipleBrokersInvolved: dynamicQuote?.multipleBrokerInvolved || null,
                    isMarketAllocationDone: dynamicQuote?.isMarketAllocationDone || null,
                    clientConsiderations: clientConsiderations?.clientConsiderations || null,
                    threatsFromExistingInsurer: clientConsiderations?.threatsFromExistingInsurer || null,
                    threatsFromExistingBroker: clientConsiderations?.threatsFromExistingBroker || null,
                    extraneousFactors: clientConsiderations?.extraneousFactors || null,
                    planForClosingDetail: clientConsiderations?.planForClosingDetail || null,
                    remarks: remarks?.remarks || null,
                    statusLid: createOpportunityRfpDetailsEntryDto.statusLid || null,
                    createdBy: userId,
                    updatedBy: userId,
                };
                // Create main RFP Details Entry
                const rfpDetailsEntry = await this.opportunityRepository.createOpportunityRfpDetailsEntry(mappedRfpDetailsData, userId, entityManager);
                // Handle TPA Details
                if (preferredTPA?.length > 0) {
                    for (const tpa of preferredTPA) {
                        await this.opportunityRepository.createRfpTpaDetails(rfpDetailsEntry.id, { ...tpa, preferenceTypeLid: preferredStatusId[0].id }, // Preferred TPA
                        userId, entityManager);
                    }
                }
                if (excludedTPA?.length > 0) {
                    for (const tpa of excludedTPA) {
                        await this.opportunityRepository.createRfpTpaDetails(rfpDetailsEntry.id, { ...tpa, preferenceTypeLid: excludedStatusId[0].id }, // Excluded TPA
                        userId, entityManager);
                    }
                }
                // Handle Insurer Details
                if (preferredInsurers?.length > 0) {
                    for (const insurer of preferredInsurers) {
                        await this.opportunityRepository.createRfpInsurerDetails(rfpDetailsEntry.id, { ...insurer, preferenceTypeLid: preferredStatusId[0].id }, // Preferred Insurer
                        userId, entityManager);
                    }
                }
                if (excludedInsurers?.length > 0) {
                    for (const insurer of excludedInsurers) {
                        await this.opportunityRepository.createRfpInsurerDetails(rfpDetailsEntry.id, { ...insurer, preferenceTypeLid: excludedStatusId[0].id }, // Excluded Insurer
                        userId, entityManager);
                    }
                }
                // Handle Client Contact Details
                if (clientContactDetails) {
                    const clientContact = await this.opportunityRepository.createRfpClientContactDetails(rfpDetailsEntry.id, clientContactDetails, userId, entityManager);
                    // Handle Influencers
                    if (clientContactDetails.decisionInfluencers?.length > 0) {
                        for (const influencerId of clientContactDetails.decisionInfluencers) {
                            await this.opportunityRepository.createRfpClientContactInfluencers(clientContact.id, influencerId, userId, entityManager);
                        }
                    }
                }
                // Handle Credit Sharing
                if (creditSharing?.length > 0) {
                    for (const credit of creditSharing) {
                        await this.opportunityRepository.createRfpCreditSharing(rfpDetailsEntry.id, credit, userId, entityManager);
                    }
                }
                // Handle Documents
                if (documents?.length > 0) {
                    for (const document of documents) {
                        await this.opportunityRepository.createRfpDetailsEntryDocumentMap(rfpDetailsEntry.id, document, userId, entityManager);
                    }
                }
                const status = await this.lookUpRepository.findOne({
                    where: { id: createOpportunityRfpDetailsEntryDto.statusLid },
                });
                if (!status) {
                    throw new common_1.NotFoundException(`Status with ID ${createOpportunityRfpDetailsEntryDto.statusLid} not found`);
                }
                try {
                    if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED) {
                        // Creating Assignment task
                        const assignedUser = await this.employeeService.getParentUserWithPrivilege(userId, constants_2.ACL_CATEGORY.OPPORTUNITY_ACTIVITY, constants_2.ACL_ACTIONS.UPDATE);
                        if (!assignedUser) {
                            throw new common_1.NotFoundException(`No user found with privilages for assigning activity with ID ${createOpportunityRfpDetailsEntryDto.opportunityActivityId}`);
                        }
                        const createTask = await this.opportunityRepository.createOpportunityActivityTaskObject(createOpportunityRfpDetailsEntryDto.opportunityActivityId, constants_2.DEFAULT_RFP_DETAILS_ENTRY, constants_2.TASK_TYPE.APPROVAL, assignedUser.userId, userId);
                        if (!createTask) {
                            throw new common_1.NotFoundException(`Task creation object for opportunity activity ID ${createOpportunityRfpDetailsEntryDto.opportunityActivityId} not found`);
                        }
                        await this.taskService.createTask(createTask, entityManager);
                    }
                }
                catch (error) {
                    console.log(error);
                }
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: createOpportunityRfpDetailsEntryDto.opportunityActivityId }, {
                    statusLid: createOpportunityRfpDetailsEntryDto.statusLid,
                    updatedBy: userId,
                });
                return rfpDetailsEntry;
            });
        }
        catch (error) {
            console.error("Error creating RFP Details Entry:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to create RFP Details Entry.");
        }
    }
    async getQuotesBasedOnOpportunityActivityId(opportunityActivityId, page, limit) {
        try {
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity activity with ID ${opportunityActivityId} not found.`);
            }
            const quotes = await this.opportunityRepository.getQuotesBasedOnOpportunityActivityId(opportunityActivity.opportunityId, page, limit);
            if (!quotes || quotes?.length === 0) {
                throw new common_1.NotFoundException(`No quotes found for Opportunity Activity ID ${opportunityActivityId}.`);
            }
            return quotes;
        }
        catch (error) {
            console.error("Error fetching quotes:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to fetch quotes for the given Opportunity Activity ID.");
        }
    }
    async getQuoteById(quoteId) {
        try {
            const quote = await this.opportunityRepository.getQuoteById(quoteId);
            if (!quote) {
                throw new common_1.NotFoundException(`Quote with ID ${quoteId} not found.`);
            }
            return quote;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to fetch quote by ID.");
        }
    }
    async createFinalNegotiationActivity(finalNegotiationDetails, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(finalNegotiationDetails, constants_1.LOOK_UP_DATA);
            const { meetingDetails, policyDetails, selectFinalisedQuote, netPremiumDetails, quoteTaxDetails, insurerAndBrokeragePercentage, variationIssuesFromQCR, insurerServiceLevelAgreement, documents, otherCommentsFromInsurer, remarks, meetingSummary, tpaParticipants, insurerParticipants, participants, covers, quoteDocuments, opportunityActivityId, statusLid, } = finalNegotiationDetails;
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity activity with ID ${opportunityActivityId} not found.`);
            }
            const opportunity = await this.opportunityRepo.findOne({
                where: { opportunityId: opportunityActivity.opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityActivity.opportunityId} not found.`);
            }
            const existingMeetingId = meetingDetails.selectMeeting;
            const negData = {
                opportunityActivityId,
                statusLid,
                ...policyDetails,
                ...selectFinalisedQuote,
                ...netPremiumDetails,
                otherInsurerComments: otherCommentsFromInsurer?.remarks,
                ...remarks,
                ...meetingSummary,
            };
            return await this.dataSource.transaction(async (manager) => {
                let finalNegMeet;
                const companyParticipantsData = participants?.companyContactPerson
                    ? {
                        companyId: opportunity.companyId,
                        companyContactPerson: participants.companyContactPerson,
                    }
                    : undefined;
                const employeeParticipantsData = participants?.employees
                    ? {
                        employees: participants.employees,
                    }
                    : undefined;
                const status = await this.lookUpRepository.findOne({
                    where: { id: statusLid },
                });
                if (!status) {
                    throw new common_1.NotFoundException(`Status with ID ${statusLid} not found`);
                }
                let finalNegMeetStatusLid;
                if (status.lookUpKey) {
                    if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                        status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                        const meetingStatus = await this.lookUpRepository.findOne({
                            where: { lookUpKey: constants_1.DEFAULT_MEETING_STATUS_COMPLETED },
                        });
                        if (!meetingStatus) {
                            throw new common_1.NotFoundException(`Meeting status with key ${constants_1.DEFAULT_MEETING_STATUS_COMPLETED} not found.`);
                        }
                        finalNegMeetStatusLid = meetingStatus.id;
                    }
                }
                await this.verifyMeetingType(meetingDetails.meetingTypeLid, constants_1.MEETING_TYPE_KEY.FINAL_NEGOTIATION, constants_1.MEETING_NAME.FINAL_NEGOTIATION);
                if (existingMeetingId) {
                    const existingMeeting = await this.meetingRepo.findOne({
                        where: { id: existingMeetingId },
                    });
                    if (!existingMeeting) {
                        throw new common_1.NotFoundException(`Meeting with ID ${existingMeetingId} not found.`);
                    }
                    const meetingStatus = await this.LookUpService.getLookUpsByKey(constants_1.DEFAULT_MEETING_STATUS);
                    if (existingMeeting.meetingStatusLid === meetingStatus[0].id) {
                        finalNegMeet = await this.meetingService.updateMeeting(existingMeetingId, {
                            opportunityId: opportunityActivity.opportunityId,
                            activityId: opportunityActivityId,
                            companyId: opportunity.companyId,
                            meetingTypeLid: meetingDetails.meetingTypeLid,
                            meetingDate: meetingDetails.meetingDate,
                            startTime: meetingDetails.availableFrom,
                            endTime: meetingDetails.availableTo,
                            meetingSubject: constants_2.DEFAULT_FINAL_NEGOTIATION_MEETING,
                            meetingAgenda: constants_2.DEFAULT_FINAL_NEGOTIATION_MEETING,
                            locationTypeLid: meetingDetails.locationTypeLid,
                            updatedBy: userId,
                            tpaParticipants: tpaParticipants,
                            insurerParticipants: insurerParticipants,
                            companyParticipants: companyParticipantsData,
                            employeeParticipants: employeeParticipantsData,
                            documents: documents,
                            meetingStatusLid: finalNegMeetStatusLid ?? existingMeeting.meetingStatusLid,
                        }, manager);
                    }
                }
                else {
                    // Create the meeting
                    finalNegMeet = await this.meetingService.createMeeting({
                        opportunityId: opportunityActivity.opportunityId,
                        activityId: opportunityActivityId,
                        companyId: opportunity.companyId,
                        meetingSubject: constants_2.DEFAULT_FINAL_NEGOTIATION_MEETING,
                        meetingAgenda: constants_2.DEFAULT_FINAL_NEGOTIATION_MEETING,
                        meetingTypeLid: meetingDetails.meetingTypeLid,
                        meetingDate: meetingDetails.meetingDate,
                        startTime: meetingDetails.availableFrom,
                        endTime: meetingDetails.availableTo,
                        locationTypeLid: meetingDetails.locationTypeLid,
                        createdBy: userId,
                        updatedBy: userId,
                        tpaParticipants: tpaParticipants,
                        insurerParticipants: insurerParticipants,
                        companyParticipants: companyParticipantsData,
                        employeeParticipants: employeeParticipantsData,
                        documents: documents,
                        meetingStatusLid: finalNegMeetStatusLid
                            ? finalNegMeetStatusLid
                            : null,
                    }, manager);
                }
                const finalNeg = await this.opportunityRepository.createFinalNegotiationActivity(manager, {
                    ...negData,
                    opportunityId: opportunityActivity.opportunityId,
                    activityId: opportunityActivity.activityId,
                    meetingId: finalNegMeet.id,
                    isFinalNegotiationTypeLid: meetingDetails.isFinalNegotiationTypeLid,
                    selectMeeting: meetingDetails.selectMeeting,
                    createdBy: userId,
                    updatedBy: userId,
                });
                await this.saveFinalNegotiationActivityDetails(manager, finalNeg, insurerAndBrokeragePercentage, variationIssuesFromQCR, insurerServiceLevelAgreement, quoteTaxDetails, covers, quoteDocuments);
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.PLACEMENT_SLIP, statusLid, manager);
                return {
                    id: finalNeg.id,
                    message: "Final Negotiation Activity created successfully.",
                };
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to create final negotiation activity.");
        }
    }
    async updateFinalNegotiationActivity(opportunityActivityId, finalNegotiationDetails, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(finalNegotiationDetails, constants_1.LOOK_UP_DATA);
            const { meetingDetails, policyDetails, selectFinalisedQuote, netPremiumDetails, quoteTaxDetails, insurerAndBrokeragePercentage, variationIssuesFromQCR, insurerServiceLevelAgreement, documents, otherCommentsFromInsurer, remarks, meetingSummary, tpaParticipants, insurerParticipants, participants, covers, quoteDocuments, opportunityActivityId: optyActyId, statusLid, } = finalNegotiationDetails;
            const negData = {
                statusLid,
                ...policyDetails,
                ...selectFinalisedQuote,
                ...netPremiumDetails,
                otherInsurerComments: otherCommentsFromInsurer?.remarks,
                ...remarks,
                ...meetingSummary,
                updatedBy: userId,
            };
            const finalNegMeeting = await this.opportunityFinalNegotiationRepo.findOne({
                where: { opportunityActivityId },
            });
            if (!finalNegMeeting) {
                throw new common_1.NotFoundException(`Final Negotiation Meeting with opportunity activity id ${opportunityActivityId} not found.`);
            }
            const finalNegMeetingStatus = await this.lookUpRepository.findOne({
                where: { id: finalNegMeeting.statusLid },
            });
            if (!finalNegMeetingStatus) {
                throw new common_1.NotFoundException(`Meeting status with ID: ${finalNegMeeting.statusLid} not found.`);
            }
            return await this.dataSource.transaction(async (manager) => {
                if (finalNegMeetingStatus.lookUpKey ===
                    constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                    finalNegMeetingStatus.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                    throw new common_1.BadRequestException(`Final Negotiation Meeting with opportunity activity ID: ${opportunityActivityId} cannot be updated as it is completed.`);
                }
                const meeting = await this.meetingRepo.findOne({
                    where: { id: finalNegMeeting.meetingId },
                });
                if (!meeting) {
                    throw new common_1.NotFoundException(`Meeting with ID ${finalNegMeeting.meetingId} not found.`);
                }
                const meetingStatus = await this.LookUpService.getLookUpsByKey(constants_1.DEFAULT_MEETING_STATUS);
                if (meeting.meetingStatusLid === meetingStatus[0].id) {
                    const companyParticipantsData = participants?.companyContactPerson
                        ? {
                            companyId: meeting.companyId,
                            companyContactPerson: participants.companyContactPerson,
                        }
                        : undefined;
                    const employeeParticipantsData = participants?.employees
                        ? {
                            employees: participants.employees,
                        }
                        : undefined;
                    if (meetingDetails?.meetingTypeLid) {
                        await this.verifyMeetingType(meetingDetails.meetingTypeLid, constants_1.MEETING_TYPE_KEY.FINAL_NEGOTIATION, constants_1.MEETING_NAME.FINAL_NEGOTIATION);
                    }
                    // Update the meeting details
                    await this.meetingService.updateMeeting(finalNegMeeting.meetingId, {
                        meetingTypeLid: meetingDetails?.meetingTypeLid ?? meeting.meetingTypeLid,
                        meetingDate: meetingDetails?.meetingDate ?? meeting.meetingDate,
                        startTime: meetingDetails?.availableFrom ?? meeting.startTime,
                        endTime: meetingDetails?.availableTo ?? meeting.endTime,
                        locationTypeLid: meetingDetails?.locationTypeLid ?? meeting.locationTypeLid,
                        updatedBy: userId,
                        tpaParticipants: tpaParticipants ?? undefined,
                        insurerParticipants: insurerParticipants ?? undefined,
                        companyParticipants: companyParticipantsData,
                        employeeParticipants: employeeParticipantsData,
                        documents: documents ?? undefined,
                    }, manager);
                }
                // Update the main final negotiation activity record
                await this.opportunityRepository.updateFinalNegotiationActivity(manager, opportunityActivityId, negData);
                await this.saveFinalNegotiationActivityDetails(manager, finalNegMeeting, insurerAndBrokeragePercentage, variationIssuesFromQCR, insurerServiceLevelAgreement, quoteTaxDetails, covers, quoteDocuments);
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.PLACEMENT_SLIP, statusLid, manager);
                return {
                    id: finalNegMeeting.id,
                    message: "Final negotiation activity updated successfully",
                };
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update final negotiation activity.");
        }
    }
    async saveFinalNegotiationActivityDetails(manager, finalNegotiation, insurerAndBrokeragePercentage, variationIssuesFromQCR, insurerServiceLevelAgreement, quoteTaxDetails, covers, quoteDocuments) {
        try {
            if (insurerAndBrokeragePercentage &&
                insurerAndBrokeragePercentage.length > 0) {
                await this.opportunityRepository.saveFinalNegotiationSharingDetails(manager, finalNegotiation.id, insurerAndBrokeragePercentage);
            }
            if (variationIssuesFromQCR && variationIssuesFromQCR.length > 0) {
                await this.opportunityRepository.saveFinalNegotiationVariations(manager, finalNegotiation.id, variationIssuesFromQCR);
            }
            if (insurerServiceLevelAgreement &&
                insurerServiceLevelAgreement.length > 0) {
                await this.opportunityRepository.saveFinalNegotiationSla(manager, finalNegotiation.id, insurerServiceLevelAgreement);
            }
            if (quoteTaxDetails && quoteTaxDetails.length > 0) {
                await this.opportunityRepository.saveFinalNegotiationQuoteTax(manager, finalNegotiation.id, quoteTaxDetails);
            }
            if (covers && Object.keys(covers).length > 0) {
                await this.opportunityRepository.saveFinalNegotiationCovers(manager, finalNegotiation.id, finalNegotiation.finalizedQuoteId, finalNegotiation.opportunityId, covers);
            }
            // if (quoteDocuments && quoteDocuments.length > 0) {
            //   await this.opportunityRepository.saveFinalNegotiationQuoteDocuments(
            //     manager,
            //     finalNegotiation.id,
            //     quoteDocuments
            //   );
            // }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException) {
                throw error;
            }
        }
    }
    async getFinalNegotiationActivity(opportunityActivityId) {
        try {
            return await this.opportunityRepository.getFinalNegotiationActivity(opportunityActivityId);
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving meeting details");
        }
    }
    // Verifies if the meeting type is of a specific type
    async verifyMeetingType(meetingTypeLid, expectedTypeKey, meetingName) {
        const meetingType = await this.lookUpRepository.findOne({
            where: { id: meetingTypeLid },
        });
        if (!meetingType) {
            throw new common_1.NotFoundException(`Meeting type with ID ${meetingTypeLid} not found.`);
        }
        if (meetingType.lookUpKey !== expectedTypeKey) {
            throw new common_1.BadRequestException(`Meeting type with ID ${meetingTypeLid} is not a ${meetingName}`);
        }
    }
    async createOpportunityLostActivity(opportunityLostData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(opportunityLostData, constants_1.LOOK_UP_DATA);
            const { opportunityActivityId, statusLid, ...lostData } = opportunityLostData;
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity activity with ID ${activityId} not found.`);
            }
            const opportunity = await this.opportunityRepo.findOne({
                where: { opportunityId: opportunityActivity.opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityActivity.opportunityId} not found.`);
            }
            return await this.dataSource.transaction(async (entityManager) => {
                const opportunityLost = await this.opportunityRepository.createOpportunityLostActivity(entityManager, {
                    opportunityId: opportunityActivity.opportunityId,
                    activityId: opportunityActivity.activityId,
                    opportunityActivityId: opportunityActivityId,
                    reasonForLossLid: lostData.opportunityLost.reasonForLossLid,
                    remarks: lostData.opportunityLost.remarks,
                    statusLid: statusLid,
                    createdBy: userId,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateOpportunityStatus(entityManager, opportunityActivity.opportunityId, constants_2.OPPORTUNITY_STATUS_LOST);
                const url = `${environment_1.ENV.CLIENT_SERVER_URL}opportunities/${opportunity.opportunityId}`;
                await this.sendNotification(constants_2.NOTIFICATION_EVENT_TYPES.OPPORTUNITY_LOST, url, userId, true, true);
                // return result;
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: opportunityLost.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.POLICY_CONFIRMATION, opportunityLost.statusLid, entityManager);
                return {
                    id: opportunityLost.id,
                    message: "Opportunity lost activity created successfully.",
                };
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to create final negotiation activity.");
        }
    }
    async updateOpportunityLostActivity(opportunityActivityId, updateOpportunityLostData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updateOpportunityLostData, constants_1.LOOK_UP_DATA);
            const opportunityLostActivityData = await this.getOpportunityLostActivity(opportunityActivityId);
            if (!opportunityLostActivityData) {
                throw new common_1.NotFoundException(`Opportunity Lost details not found for opportunity activity ID ${opportunityActivityId}.`);
            }
            return await this.dataSource.transaction(async (entityManager) => {
                const opportunityLost = await this.opportunityRepository.updateOpportunityLostActivity(entityManager, opportunityActivityId, {
                    reasonForLossLid: updateOpportunityLostData?.opportunityLost?.reasonForLossLid ??
                        undefined,
                    remarks: updateOpportunityLostData?.opportunityLost?.remarks ??
                        undefined,
                    statusLid: updateOpportunityLostData.statusLid,
                    updatedBy: userId,
                });
                // update the OpportunityActivityMap with the new status
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: opportunityLost?.statusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.POLICY_CONFIRMATION, opportunityLost?.statusLid, entityManager);
                return {
                    id: opportunityLost?.id,
                    message: "Opportunity lost activity updated successfully.",
                };
            });
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Failed to update opportunity lost activity.");
        }
    }
    async getOpportunityLostActivity(opportunityActivityId) {
        try {
            const { opportunityId, activityId } = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityId || !activityId) {
                throw new common_1.NotFoundException(`Opportunity or activity not found for opportunityId: ${opportunityId} and activityId: ${activityId}`);
            }
            const opportunityLost = await this.opportunityRepository.getOpportunityLostActivity(opportunityId, activityId);
            if (!opportunityLost) {
                throw new common_1.NotFoundException(`Opportunity Lost Activity not found for Opportunity ID: ${opportunityId} and Activity ID: ${activityId}`);
            }
            return opportunityLost;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving meeting details");
        }
    }
    async processRfpCoverDetails(payload, createdBy) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(payload, constants_1.LOOK_UP_DATA);
            // Validate payload
            if (!payload.opportunityActivityId ||
                !payload.coversConfig ||
                !payload.remarksSection) {
                throw new common_1.BadRequestException("Invalid payload structure.");
            }
            // Call repository methods for database operations
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivity(payload.opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity Activity with ID ${payload.opportunityActivityId} not found.`);
            }
            const opportunityId = opportunityActivity.opportunityId;
            const covers = await this.opportunityRepository.getOpportunityRfpCovers(opportunityId);
            if (!covers.length) {
                throw new common_1.NotFoundException(`No covers found for Opportunity ID ${opportunityId}.`);
            }
            // Prepare RFP cover details
            const rfpCoverDetails = this.prepareRfpCoverDetails(covers, payload.coversConfig, opportunityId, createdBy);
            // Save RFP cover details and related data
            await this.opportunityRepository.saveRfpCoverDetails(opportunityId, payload.opportunityActivityId, rfpCoverDetails, payload.remarksSection.remarks, payload.documents, createdBy, payload.statusLid);
            // check if it is an activity that needs approval
            const status = await this.lookUpRepository.findOne({
                where: { id: payload.statusLid },
            });
            if (!status) {
                throw new common_1.NotFoundException(`Status with ID ${payload.statusLid} not found`);
            }
            try {
                const assignedUser = await this.employeeService.getParentUserWithPrivilege(createdBy, constants_2.ACL_CATEGORY.OPPORTUNITY_ACTIVITY, constants_2.ACL_ACTIONS.UPDATE);
                if (!assignedUser) {
                    throw new common_1.NotFoundException(`No user found with privilages for assigning activity with ID ${payload.opportunityActivityId}`);
                }
                if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED) {
                    const needsApproval = await this.opportunityRepository.isOpportunityActivityNeedsApproval(payload.opportunityActivityId);
                    if (needsApproval) {
                        const createTask = await this.opportunityRepository.createOpportunityActivityTaskObject(payload.opportunityActivityId, constants_2.DEFAULT_RFP_DATA_COLLECTION, constants_2.TASK_TYPE.APPROVAL, assignedUser.userId, createdBy);
                        if (!createTask) {
                            throw new common_1.NotFoundException(`Task creation object for opportunity activity ID ${payload.opportunityActivityId} not found`);
                        }
                        await this.taskService.createTask(createTask);
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: payload.opportunityActivityId }, {
                statusLid: payload.statusLid,
                updatedBy: createdBy,
            });
            await this.opportunityRepository.updateActivityStatus(payload.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.RFP_DETAILS_ENTRY, payload.statusLid);
        }
        catch (error) {
            console.error("Error in processRfpCoverDetails:", error);
            throw error;
        }
    }
    async updateRfpCoverDetails(payload, updatedBy) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(payload, constants_1.LOOK_UP_DATA);
            if (!payload.opportunityActivityId ||
                !payload.coversConfig ||
                !payload.remarksSection) {
                throw new common_1.BadRequestException("Invalid payload structure.");
            }
            const opportunityActivity = await this.opportunityRepository.getOpportunityActivity(payload.opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity Activity with ID ${payload.opportunityActivityId} not found.`);
            }
            const opportunityId = opportunityActivity.opportunityId;
            const covers = await this.opportunityRepository.getOpportunityRfpCovers(opportunityId);
            if (!covers.length) {
                throw new common_1.NotFoundException(`No covers found for Opportunity ID ${opportunityId}.`);
            }
            const rfpCoverDetails = this.prepareRfpCoverDetails(covers, payload.coversConfig, opportunityId, updatedBy);
            await this.opportunityRepository.updateRfpCoverDetails(opportunityId, payload.opportunityActivityId, rfpCoverDetails, payload.remarksSection.remarks, payload.documents, updatedBy, payload.statusLid);
            await this.opportunityActivityMapRepository.update({ id: payload.opportunityActivityId }, {
                statusLid: payload.statusLid,
                updatedBy,
            });
            await this.opportunityRepository.updateActivityStatus(payload.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.RFP_DETAILS_ENTRY, payload.statusLid);
        }
        catch (error) {
            console.error("Error in updateRfpCoverDetails:", error);
            throw error;
        }
    }
    prepareRfpCoverDetails(covers, coversConfig, opportunityId, createdBy) {
        return covers
            .filter((cover) => coversConfig[cover.id]) // Filter out covers without answers
            .map((cover) => {
            const coverResponseObj = coversConfig[cover.id];
            const coverResponse = typeof coverResponseObj === "object"
                ? Object.values(coverResponseObj).join(", ") // Extract and join values if it's an object
                : coverResponseObj; // Use as is if it's already a string
            return {
                opportunityId,
                coverMapId: cover.id,
                policyTypeId: cover.policyTypeId,
                coverName: cover.coverName,
                coverResponse,
                createdBy,
                updatedBy: createdBy,
            };
        });
    }
    async addQuoteCoverDetails(manager, opportunityActivityId, covers, createdBy) {
        try {
            // Step 1: Get opportunity ID from the repository
            const opportunityActivity = await this.opportunityRepository.getOpportunityQuoteActivityById(manager, opportunityActivityId);
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity Activity with ID ${opportunityActivityId} not found.`);
            }
            const opportunityId = opportunityActivity.opportunityId;
            // Step 2: Get all covers from the repository
            const coverMaps = await this.opportunityRepository.getOpportunityQuoteCovers(manager, opportunityId);
            // Check if covers exist
            if (!coverMaps.length) {
                throw new common_1.NotFoundException(`No covers found for Opportunity ID ${opportunityId}.`);
            }
            // Step 3: Prepare Quote Cover Details for insertion
            const quoteCoverDetails = this.opportunityRepository.prepareQuoteCoverDetails(covers, coverMaps, opportunityId, createdBy);
            // Step 4: Save Quote Cover Details using the repository
            await this.opportunityRepository.saveQuoteCoverDetails(manager, quoteCoverDetails);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException) {
                throw error; // Re-throw known exceptions
            }
            throw new common_1.BadRequestException(`Failed to insert Quote Cover Details: ${error.message}`);
        }
    }
    async addQuoteTaxDetails(manager, quoteEntryId, taxDetails, createdBy) {
        try {
            const records = this.opportunityRepository.prepareQuoteTaxDetails(taxDetails, quoteEntryId, createdBy);
            await this.opportunityRepository.saveQuoteTaxDetails(manager, records);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException) {
                throw error;
            }
            throw new common_1.BadRequestException(`Failed to insert Quote Tax Details: ${error.message}`);
        }
    }
    async getOpportunitiesByCompanyId(companyId, page, limit) {
        try {
            const { data: companyOpportunities, count } = await this.opportunityRepository.getOpportunityByCompanyId(companyId, page, limit);
            if (!companyOpportunities || companyOpportunities.length === 0) {
                throw new common_1.NotFoundException(`No opportunities found for company ID: ${companyId}`);
            }
            const transformedOpportunities = companyOpportunities.map((opportunity) => {
                const { opportunityId, companyId, contactId, soExpireDate, estimatedBrokerage, policyType, sumInsured, } = opportunity;
                const policyTypeData = {
                    id: policyType?.id,
                    value: policyType?.lookUpValue,
                };
                // Format the sumInsured with locale-specific number formatting
                const formattedSumInsured = new Intl.NumberFormat("en-IN").format(sumInsured);
                const opportunityIdentifier = `${policyTypeData.value} (${formattedSumInsured})`;
                return {
                    opportunityId,
                    companyId,
                    contactId,
                    estimatedBrokerage,
                    policyType: policyTypeData,
                    sumInsured,
                    soExpireDate,
                    opportunityIdentifier,
                };
            });
            return {
                data: transformedOpportunities,
                totalCount: count,
            };
        }
        catch (error) {
            throw new Error(`Failed to fetch opportunities for company ID: ${companyId}. ${error.message}`);
        }
    }
    async getAllQcrBrokingSlipVersionsData(opportunityActivityId) {
        try {
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivityMapData) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${opportunityActivityId}`);
            }
            const allActivityData = await this.opportunityRepository.getOpportunityActivitiesByOpportunityId(opportunityActivityMapData.opportunityId);
            const owner = await this.getPlacementSlipGenerationByOwner(allActivityData);
            const brokingSlipVersionDetails = await this.opportunityRepository.getBrokingSlipAndQuoteDetailsData(opportunityActivityMapData);
            if (!brokingSlipVersionDetails) {
                throw new common_1.NotFoundException(`Broking Slip Version Details not found for opportunity activity ID ${opportunityActivityId}`);
            }
            let transformed = [];
            if (brokingSlipVersionDetails.length > 0) {
                transformed = brokingSlipVersionDetails.map((version) => {
                    const { id, opportunityId, brokingSlipVersion, brokingSlipName, quoteEntry = [], } = version || {};
                    return {
                        id,
                        opportunityId,
                        brokingSlipVersion,
                        brokingSlipName,
                        owner,
                        opportunityType: constants_1.SALES_OPPORTUNITY,
                        quoteEntry: Array.isArray(quoteEntry)
                            ? quoteEntry.map((quote, idx) => {
                                return {
                                    id: quote?.id,
                                    opportunityId: quote?.opportunityId,
                                    opportunityActivityId: quote?.opportunityActivityId,
                                    brokingSlipId: quote?.brokingSlipId,
                                    insurerId: quote?.insurerId,
                                    statusId: quote?.statusId,
                                    key: `quote_${idx + 1}`,
                                    label: quote?.insurer?.insurerName || "-",
                                    insurer: {
                                        id: quote?.insurer?.id,
                                        insurerName: quote?.insurer?.insurerName ?? "-",
                                        displayName: quote?.insurer?.displayName ?? "-",
                                    },
                                };
                            })
                            : [],
                    };
                });
            }
            return transformed;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.brokingSlipVersionDetailsRetrieveFailed);
        }
    }
    async createPlacementSlip(dto, userId) {
        await this.lookUpValidation.validateDynamicLookupValues(dto, constants_1.LOOK_UP_DATA);
        const PlacementSlipData = await this.dataSource.transaction(async (entityManager) => {
            const { policyDetails, feeDetails, installmentDates, otherDeatils, remarks, tpaDetails, insurerDetails, insurerAndBrokeragePercentage, cdAccountDetails, coverDetails, statusLid, documents, ...rest } = dto;
            const payload = {
                ...rest,
                ...policyDetails,
                ...feeDetails,
                ...otherDeatils,
                statusLid: statusLid,
                remarks: remarks?.remarks,
                tpaMaps: tpaDetails,
                insurerMaps: insurerDetails,
                sharingDetails: insurerAndBrokeragePercentage,
                cdDetails: [cdAccountDetails],
                coverDetails: coverDetails,
                installmentDetails: installmentDates,
                documents: documents,
            };
            const placementSlip = this.opportunityRepository.createPlacementSlip(payload, userId, entityManager);
            // check if it is an activity that needs approval
            const status = await this.lookUpRepository.findOne({
                where: { id: statusLid },
            });
            if (!status) {
                throw new common_1.NotFoundException(`Status with ID ${statusLid} not found`);
            }
            try {
                const assignedUser = await this.employeeService.getParentUserWithPrivilege(userId, constants_2.ACL_CATEGORY.OPPORTUNITY_ACTIVITY, constants_2.ACL_ACTIONS.UPDATE);
                if (!assignedUser) {
                    throw new common_1.NotFoundException(`No user found with privilages for assigning activity with ID ${dto.opportunityActivityId}`);
                }
                if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED) {
                    const needsApproval = await this.opportunityRepository.isOpportunityActivityNeedsApproval(payload.opportunityActivityId);
                    if (needsApproval) {
                        const createTask = await this.opportunityRepository.createOpportunityActivityTaskObject(payload.opportunityActivityId, constants_2.DEFAULT_PLACEMENT_SLIP_GENERATION, constants_2.TASK_TYPE.APPROVAL, assignedUser.userId, userId);
                        if (!createTask) {
                            throw new common_1.NotFoundException(`Task creation object for opportunity activity ID ${payload.opportunityActivityId} not found`);
                        }
                        await this.taskService.createTask(createTask, entityManager);
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: payload.opportunityActivityId }, {
                statusLid: payload.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(payload.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.PREMIUM_CALCULATION, payload.statusLid, entityManager);
            return placementSlip;
        });
        return PlacementSlipData;
    }
    async updatePlacementSlip(id, dto) {
        const { policyDetails, otherDeatils, remarks, tpaDetails, insurerDetails, insurerAndBrokeragePercentage, cdAccountDetails, coverDetails, statusLid, ...rest } = dto;
        const payload = {
            ...rest,
            ...policyDetails,
            ...otherDeatils,
            statusLid: statusLid,
            remarks: remarks?.remarks,
            tpaMaps: tpaDetails,
            insurerMaps: insurerDetails,
            sharingDetails: insurerAndBrokeragePercentage,
            cdDetails: cdAccountDetails,
            coverDetails,
        };
        const placementSlip = await this.opportunityRepository.updatePlacementSlip(id, payload);
        // check if it is an activity that needs approval
        const status = await this.lookUpRepository.findOne({
            where: { id: statusLid },
        });
        if (!status) {
            throw new common_1.NotFoundException(`Status with ID ${statusLid} not found`);
        }
        try {
            const assignedUser = await this.employeeService.getParentUserWithPrivilege(placementSlip.updatedBy, constants_2.ACL_CATEGORY.OPPORTUNITY_ACTIVITY, constants_2.ACL_ACTIONS.UPDATE);
            if (!assignedUser) {
                throw new common_1.NotFoundException(`No user found with privilages for assigning activity with ID ${placementSlip.opportunityActivityId}`);
            }
            if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED) {
                const needsApproval = await this.opportunityRepository.isOpportunityActivityNeedsApproval(placementSlip.opportunityActivityId);
                if (needsApproval) {
                    const createTask = await this.opportunityRepository.createOpportunityActivityTaskObject(placementSlip.opportunityActivityId, constants_2.DEFAULT_PLACEMENT_SLIP_GENERATION, constants_2.TASK_TYPE.APPROVAL, placementSlip.updatedBy);
                    if (!createTask) {
                        throw new common_1.NotFoundException(`Task creation object for opportunity activity ID ${placementSlip.opportunityActivityId} not found`);
                    }
                    await this.taskService.createTask(createTask);
                }
            }
        }
        catch (error) {
            console.log(error);
        }
        // update the OpportunityActivityMap with the new status
        await this.opportunityActivityMapRepository.update({ id: placementSlip.opportunityActivityId }, {
            statusLid: placementSlip.statusLid,
            updatedBy: placementSlip.updatedBy,
        });
        await this.opportunityRepository.updateActivityStatus(placementSlip.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.PREMIUM_CALCULATION, placementSlip.statusLid);
        return placementSlip;
    }
    async getPlacementSlipActivity(opportunityActivityId) {
        const placement = await this.opportunityRepository.getPlacementSlipData(opportunityActivityId);
        let documents = [];
        if (placement?.documents?.length > 0) {
            documents = placement?.documents?.map(({ placementSlipId, ...rest }) => rest);
        }
        else {
            documents = [
                {
                    documentId: null,
                    documentTypeLid: null,
                },
            ];
        }
        // Transform coverDetails array to key-value pair: { [coverTemplateId]: coverResponse }
        let coverDetailsObj = {};
        if (Array.isArray(placement?.coverDetails)) {
            coverDetailsObj = placement?.coverDetails?.reduce((acc, curr) => {
                if (curr?.coverTemplateId !== undefined &&
                    curr?.coverResponse !== undefined) {
                    acc[curr.coverTemplateId] = curr.coverResponse;
                }
                return acc;
            }, {});
        }
        return {
            id: placement?.id,
            opportunityActivityId: placement?.opportunityActivityId,
            statusLid: placement?.statusLid,
            dataActivity: {
                policyDetails: {
                    policyFromDate: placement?.policyFromDate ?? null,
                    policyToDate: placement?.policyToDate ?? null,
                    sumInsured: placement?.sumInsured !== undefined &&
                        placement?.sumInsured !== null
                        ? Number(placement.sumInsured)
                        : null,
                    basicPremium: placement?.basicPremium !== undefined &&
                        placement?.basicPremium !== null
                        ? Number(placement.basicPremium)
                        : null,
                    isPremiumInstallmentBased: placement?.isPremiumInstallmentBased ?? null,
                },
                installmentDates: Array.isArray(placement?.installmentDates)
                    ? placement.installmentDates.map((item) => ({
                        firstInstallmentDate: item.firstInstallmentDate,
                        secondInstallmentDate: item.secondInstallmentDate,
                        id: item.id,
                    }))
                    : [],
                feeDetails: {
                    fee: placement?.fee !== undefined && placement?.fee !== null
                        ? Number(placement.fee)
                        : null,
                    isFeeInInstallment: placement?.isFeeInInstallment ?? null,
                    terrorismCommissionPercentage: placement?.terrorismCommissionPercentage !== undefined &&
                        placement?.terrorismCommissionPercentage !== null
                        ? Number(placement.terrorismCommissionPercentage)
                        : null,
                    serviceTaxPercentage: placement?.serviceTaxPercentage !== undefined &&
                        placement?.serviceTaxPercentage !== null
                        ? Number(placement.serviceTaxPercentage)
                        : null,
                    serviceTaxAmount: placement?.serviceTaxAmount !== undefined &&
                        placement?.serviceTaxAmount !== null
                        ? Number(placement.serviceTaxAmount)
                        : null,
                    other: placement?.other ?? null,
                    totalPremium: placement?.totalPremium !== undefined &&
                        placement?.totalPremium !== null
                        ? Number(placement.totalPremium)
                        : null,
                    placementSlipDate: placement?.placementSlipDate ?? null,
                },
                otherDeatils: {
                    leadInsurerId: placement?.leadInsurerId ?? null,
                    isLeadInsurerPayCommission: placement?.isLeadInsurerPayCommission ?? null,
                    maxAgeOfDependents: placement?.maxAgeOfDependents ?? null,
                    brokeragePercentage: placement?.brokeragePercentage !== undefined &&
                        placement?.brokeragePercentage !== null
                        ? Number(placement.brokeragePercentage)
                        : null,
                    policyPlacedTypeLid: placement?.policyPlacedTypeLid ?? null,
                },
                remarks: { remarks: placement?.remarks ?? null },
                tpaDetails: placement?.tpaMaps ?? [],
                insurerDetails: placement?.insurerMaps ?? [],
                insurerAndBrokeragePercentage: Array.isArray(placement?.sharingDetails)
                    ? placement.sharingDetails.map((item) => ({
                        id: item.id,
                        insurerId: item.insurerId,
                        sharePercentage: item.sharePercentage !== undefined &&
                            item.sharePercentage !== null
                            ? Number(item.sharePercentage)
                            : null,
                        brokeragePercentage: item.brokeragePercentage !== undefined &&
                            item.brokeragePercentage !== null
                            ? Number(item.brokeragePercentage)
                            : null,
                        brokerageAmount: item.brokerageAmount !== undefined &&
                            item.brokerageAmount !== null
                            ? Number(item.brokerageAmount)
                            : null,
                    }))
                    : [],
                cdAccountDetails: placement?.cdDetails?.length > 0 && placement.cdDetails[0]
                    ? {
                        id: placement.cdDetails[0].id,
                        paymentTypeLid: placement.cdDetails[0].paymentTypeLid,
                        cdAccountTypeLid: placement.cdDetails[0].cdAccountTypeLid,
                        accountName: placement.cdDetails[0].accountName,
                        openBalance: placement.cdDetails[0].openBalance !== undefined &&
                            placement.cdDetails[0].openBalance !== null
                            ? Number(placement.cdDetails[0].openBalance)
                            : null,
                        selectCdAccount: placement.cdDetails[0].selectCdAccount !== undefined &&
                            placement.cdDetails[0].selectCdAccount !== null
                            ? Number(placement.cdDetails[0].selectCdAccount)
                            : null,
                        transactionTypeLid: placement.cdDetails[0].transactionTypeLid,
                        chequeDate: placement.cdDetails[0].chequeDate,
                        chequeAmount: placement.cdDetails[0].chequeAmount !== undefined &&
                            placement.cdDetails[0].chequeAmount !== null
                            ? Number(placement.cdDetails[0].chequeAmount)
                            : null,
                        chequeNumber: placement.cdDetails[0].chequeNumber,
                        bankName: placement.cdDetails[0].bankName,
                    }
                    : {},
                coverDetails: coverDetailsObj,
                documents: documents,
            },
        };
    }
    async getCoverDataPrefill(opportunityActivityId) {
        const activity = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
        let covers = [];
        if (activity.activityKey == constants_1.ACTIVITY_KEY.PLACEMENT_SLIP_GENERATION_ACTIVITY) {
            covers = await this.opportunityRepository.getCoverPrefillData(opportunityActivityId, activity.opportunityId);
        }
        if (activity.activityKey == constants_1.ACTIVITY_KEY.HELD_COVER_NOTE_ACTIVITY ||
            activity.activityKey == constants_1.ACTIVITY_KEY.POLICY_HARD_COPY_ACTIVITY) {
            covers =
                await this.opportunityRepository.getPlacementSlipCoverDetailsByOpportunityId(activity.opportunityId);
        }
        const coverDetails = {};
        covers?.forEach((c) => {
            const id = c.coverTemplateId ?? c.coverMapId;
            const resp = c.coverResponse ?? c.insurerCoverResponse;
            if (id !== undefined && resp !== undefined) {
                coverDetails[id] = resp;
            }
        });
        return { covers: coverDetails };
    }
    async softDeletePlacementSlip(id) {
        return this.opportunityRepository.softDeletePlacementSlip(id);
    }
    async softDeleteQuoteEntry(id) {
        return this.opportunityRepository.softDeleteQuoteEntry(id);
    }
    async preparePremiumCalculationDetails(covers, premiumCalculationDetailsConfig, opportunityId, createdBy) {
        return covers
            .filter((cover) => premiumCalculationDetailsConfig[cover.id])
            .map((cover) => {
            const fieldResponse = premiumCalculationDetailsConfig[cover.id];
            return {
                opportunityId,
                coverMapId: cover.id,
                policyTypeLid: cover.policyTypeId,
                coverName: cover.coverName,
                coverResponse: fieldResponse,
                createdBy,
                updatedBy: createdBy,
            };
        });
    }
    async createQuotComparisonReportActivity(OpportunityActivityMap, activityMetaData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(activityMetaData, constants_1.LOOK_UP_DATA);
            const quoteComparisonReportObject = await this.dataSource.transaction(async (entityManager) => {
                // Create the quote comparison report activity
                const payloadObject = {
                    opportunityId: OpportunityActivityMap.opportunityId,
                    activityId: OpportunityActivityMap.activityId,
                    statusLid: activityMetaData.statusLid,
                    opportunityActivityId: activityMetaData.opportunityActivityId,
                    insuranceMarket: activityMetaData.placementDynamicsSetion.insuranceMarket,
                    clientSpecific: activityMetaData.placementDynamicsSetion.clientSpecific,
                    issuesFaced: activityMetaData.placementDynamicsSetion.issuesFaced,
                    industryBenchmarkingComments: activityMetaData.placementDynamicsSetion
                        .industryBenchmarkingComments,
                    analysisRecommendation: activityMetaData.placementDynamicsSetion.analysisRecommendation,
                    overallComments: activityMetaData.placementDynamicsSetion.overallComments,
                    remarks: activityMetaData.placementDynamicsSetion.remarks,
                };
                const documents = activityMetaData.documents;
                // Save policy hard copy
                const quoteComparisonReportData = await this.opportunityRepository.createQuoteComparisonReport(entityManager, payloadObject, userId);
                // Save documents
                if (documents && documents.length > 0) {
                    await this.opportunityRepository.saveQuoteComparisonReportDocuments(quoteComparisonReportData.id, documents, entityManager);
                }
                return quoteComparisonReportData;
            });
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: activityMetaData.opportunityActivityId }, {
                statusLid: activityMetaData.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(activityMetaData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.FINAL_NEGOTIATION, activityMetaData.statusLid);
            return { id: quoteComparisonReportObject.id, ...activityMetaData };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityActivityMetaUpdateFailed);
        }
    }
    async getQuoteComparisonReportActivity(opportunityActivityId) {
        try {
            const quoteComparisonReport = await this.opportunityRepository.getQuoteComparisonReportByOpportunityActivityId(opportunityActivityId);
            if (!quoteComparisonReport) {
                throw new common_1.NotFoundException(`Quote Comparison Report not found for Opportunity Activity Id: ${opportunityActivityId}`);
            }
            let documents = quoteComparisonReport?.documents ?? [];
            if (documents.length > 0) {
                documents = documents.map(({ quoteComparisonReportId, ...rest }) => rest);
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: quoteComparisonReport.id,
                opportunityActivityId: quoteComparisonReport?.opportunityActivityId ?? null,
                statusLid: quoteComparisonReport?.statusLid ?? null,
                dataActivity: {
                    placementDynamicsSetion: {
                        insuranceMarket: quoteComparisonReport?.insuranceMarket ?? null,
                        clientSpecific: quoteComparisonReport?.clientSpecific ?? null,
                        issuesFaced: quoteComparisonReport?.issuesFaced ?? null,
                        industryBenchmarkingComments: quoteComparisonReport?.industryBenchmarkingComments ?? null,
                        analysisRecommendation: quoteComparisonReport?.analysisRecommendation ?? null,
                        overallComments: quoteComparisonReport?.overallComments ?? null,
                        remarks: quoteComparisonReport?.remarks ?? null,
                    },
                    documents: documents,
                },
            };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteComparisonReportRetrieveFailed);
        }
    }
    async updateQuoteComparisonReportById(opportunityActivityId, updateQuoteComparisonReportData, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updateQuoteComparisonReportData, constants_1.LOOK_UP_DATA);
            const quoteComparisonReportDetails = await this.getQuoteComparisonReportActivity(opportunityActivityId);
            if (!quoteComparisonReportDetails || !quoteComparisonReportDetails.id) {
                throw new common_1.NotFoundException(`Quote Comparison Report details not found for activity ID ${opportunityActivityId}.`);
            }
            const QuouteComparisonReportUpdatedData = await this.dataSource.transaction(async (entityManager) => {
                // Update the quote comparison report activity
                const { documents, ...fieldsToUpdate } = updateQuoteComparisonReportData;
                const updateData = {};
                updateData.statusLid = fieldsToUpdate.statusLid;
                updateData.insuranceMarket =
                    fieldsToUpdate.placementDynamicsSetion.insuranceMarket;
                updateData.clientSpecific =
                    fieldsToUpdate.placementDynamicsSetion.clientSpecific;
                updateData.issuesFaced =
                    fieldsToUpdate.placementDynamicsSetion.issuesFaced;
                updateData.industryBenchmarkingComments =
                    fieldsToUpdate.placementDynamicsSetion.industryBenchmarkingComments;
                updateData.analysisRecommendation =
                    fieldsToUpdate.placementDynamicsSetion.analysisRecommendation;
                updateData.overallComments =
                    fieldsToUpdate.placementDynamicsSetion.overallComments;
                updateData.remarks = fieldsToUpdate.placementDynamicsSetion.remarks;
                const updatedQuoteComparisonReportData = await this.opportunityRepository.updateQuoteComparisonReportActivity(entityManager, quoteComparisonReportDetails.id, updateData, userId);
                // Save documents if provided
                if (updateQuoteComparisonReportData.documents) {
                    const existingDocumentIds = await this.opportunityRepository.getEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.QUOTE_COMPARISON_DOCUMENT_MAP, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, { quoteComparisonReportId: quoteComparisonReportDetails.id });
                    if (documents && documents.length > 0) {
                        // Process each document
                        for (const document of documents) {
                            if (document.id) {
                                const index = existingDocumentIds.indexOf(document.id);
                                if (index !== -1) {
                                    existingDocumentIds.splice(index, 1);
                                }
                                await this.opportunityRepository.updateDocument(entityManager, document.id, document.documentId, document.documentTypeLid, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.QUOTE_COMPARISON_DOCUMENT_MAP);
                            }
                            else {
                                await this.opportunityRepository.saveQuoteComparisonReportDocuments(quoteComparisonReportDetails.id, [document], entityManager);
                            }
                        }
                    }
                    // Delete remaining documents that were not updated
                    if (existingDocumentIds.length > 0) {
                        await this.opportunityRepository.deleteFileUploadByIds(constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.FILE_UPLOAD, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.QUOTE_COMPARISON_DOCUMENT_MAP, constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.DOCUMENT_ID, { id: (0, typeorm_2.In)(existingDocumentIds) }, constants_1.MAPPED_DATA_DELETION.SOFT_DELETE);
                        await this.opportunityRepository.deleteEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.QUOTE_COMPARISON_DOCUMENT_MAP, existingDocumentIds, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
                    }
                }
                return updatedQuoteComparisonReportData;
            });
            // update the OpportunityActivityMap with the new status
            await this.opportunityActivityMapRepository.update({ id: updateQuoteComparisonReportData.opportunityActivityId }, {
                statusLid: updateQuoteComparisonReportData.statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(updateQuoteComparisonReportData.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.FINAL_NEGOTIATION, updateQuoteComparisonReportData.statusLid);
            return QuouteComparisonReportUpdatedData;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.policyConfirmationUpdateFailed);
        }
    }
    async getOpportunityContacts(opportunityId) {
        try {
            // Validate the opportunity ID
            const opportunity = await this.opportunityRepository.fetchOpportunityById(opportunityId);
            if (!opportunity) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotFound);
            }
            const opportunityContacts = await this.opportunityRepository.fetchOpportunityContacts(opportunity.companyId);
            if (!opportunityContacts || opportunityContacts.length === 0) {
                return [];
            }
            // Transform the data to return only necessary fields
            const transformedContacts = opportunityContacts.map((contactMapping) => ({
                id: contactMapping.contact?.id,
                firstName: contactMapping.contact?.firstName,
                lastName: contactMapping.contact?.lastName,
                displayName: contactMapping.contact?.displayName,
            }));
            return transformedContacts;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchOpportunityContacts || error.message));
        }
    }
    async validateIssuanceDateWithinOpportunityPeriod(opportunityId, issuanceDate) {
        const opportunity = await this.opportunityRepo.findOne({
            where: { opportunityId },
            select: ["createdAt", "soExpireDate"],
        });
        if (!opportunity) {
            throw new common_1.BadRequestException(`Opportunity with ID ${opportunityId} not found.`);
        }
        const createdAt = new Date(opportunity.createdAt);
        const soExpireDate = new Date(opportunity.soExpireDate);
        const issuance = new Date(issuanceDate);
        if (isNaN(issuance.getTime())) {
            throw new common_1.BadRequestException(messages_1.errorMessages.issuanceDateFormatError);
        }
        if (issuance <= createdAt) {
            throw new common_1.BadRequestException(messages_1.errorMessages.issuanceDateBeforeOppportunityCreationDate);
        }
        if (issuance >= soExpireDate) {
            throw new common_1.BadRequestException(messages_1.errorMessages.issuanceDateAfterOppportunityExpiryDate);
        }
    }
    async getQuoteEntryDetails(opportunityActivityId) {
        try {
            const q = await this.opportunityRepository.findQuoteEntryDetailsByOpportunityActivityId(opportunityActivityId);
            if (!q) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityQuoteNotFound);
            }
            return {
                opportunityId: q.opportunityId,
                opportunityActivityId: q.opportunityActivityId,
                mainDocuments: q.quoteDocuments?.map((d) => ({
                    documentId: d.documentId,
                    documentTypeLid: d.documentTypeLid,
                })) ?? [],
                remarksSection: { remarks: q.opportunityQuote?.remarks ?? null },
                quoteStatusLid: q.opportunityQuote?.statusLid ?? null,
            };
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async updatePremiumCalculationActivity(opportunityActivityId, updatePremiumCalculationDto, userId) {
        // Validate required fields
        const premiumCalculationActivityDetails = await this.opportunityRepository.getPremiumCalculationByOpportunityActivityId(opportunityActivityId);
        if (!premiumCalculationActivityDetails ||
            !premiumCalculationActivityDetails.id) {
            throw new common_1.NotFoundException(`Premium Calculation details not found for activity ID ${opportunityActivityId}.`);
        }
        if (!updatePremiumCalculationDto)
            throw new common_1.BadRequestException("UpdatePremiumCalculationDto is required.");
        const { premiumCalculationDetails, remarksSection, documents, statusLid } = updatePremiumCalculationDto;
        if (!premiumCalculationDetails ||
            typeof premiumCalculationDetails !== "object") {
            throw new common_1.BadRequestException("premiumCalculationDetails is required.");
        }
        return this.dataSource.transaction(async (entityManager) => {
            // 1. Fetch and update main PremiumCalculation entity using entityService
            const premiumCalculation = await this.opportunityRepository.getActivityData(constants_1.TABLE_NAMES.OPPORTUNITY_PREMIUM_CALCULATION, premiumCalculationActivityDetails.id);
            if (!premiumCalculation)
                throw new common_1.NotFoundException("Premium calculation activity not found.");
            if (remarksSection?.remarks)
                premiumCalculation.remarks = remarksSection.remarks;
            premiumCalculation.statusLid = statusLid;
            premiumCalculation.updatedBy = userId;
            await this.opportunityRepository.savePremiumCalculation(entityManager, premiumCalculation);
            // 2. Update OpportunityPremiumCoverDetail
            const coverMapIds = Object.keys(premiumCalculationDetails).map(Number);
            let coverDetails = await entityManager.find(entities_1.OpportunityPremiumCoverDetail, {
                where: {
                    opportunityId: premiumCalculation.opportunityId,
                    coverMapId: (0, typeorm_2.In)(coverMapIds),
                },
            });
            const existingCoverMapIds = coverDetails.map((c) => c.coverMapId);
            const missingCoverMapIds = coverMapIds.filter((coverMapId) => !existingCoverMapIds.includes(coverMapId));
            // Add missing cover details using getOpportunityQuoteCoverByIds
            if (missingCoverMapIds.length > 0) {
                const missingCoverMaps = await this.opportunityRepository.getOpportunityQuoteCoverByIds(entityManager, missingCoverMapIds);
                if (missingCoverMaps.length !== missingCoverMapIds.length) {
                    throw new common_1.NotFoundException("Some coverMapIds not found.");
                }
                const newCoverDetails = missingCoverMaps.map((coverMap) => {
                    const coverResponse = premiumCalculationDetails[coverMap.id];
                    return entityManager.create(entities_1.OpportunityPremiumCoverDetail, {
                        opportunityId: premiumCalculation.opportunityId,
                        coverMapId: coverMap.id,
                        policyTypeLid: coverMap.policyTypeId,
                        coverName: coverMap.coverName,
                        coverResponse,
                        createdBy: userId,
                        updatedBy: userId,
                    });
                });
                await this.opportunityRepository.savePremiumCoverDetails(entityManager, coverDetails);
                coverDetails = [...coverDetails, ...newCoverDetails];
            }
            // Update coverResponse for all coverMapIds
            for (const coverDetail of coverDetails) {
                if (premiumCalculationDetails[coverDetail.coverMapId] !== undefined) {
                    coverDetail.coverResponse =
                        premiumCalculationDetails[coverDetail.coverMapId];
                    coverDetail.updatedBy = userId;
                }
            }
            await this.opportunityRepository.savePremiumCoverDetails(entityManager, coverDetails);
            // 3. Update OpportunityPremiumCalculationDocumentMap (documents)
            if (Array.isArray(documents)) {
                // Get existing document IDs using getEntityTableMapIds
                const existingDocumentIds = await this.opportunityRepository.getEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.PREMIUM_CALCULATION_DOCUMENT_MAP, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, { opportunityActivityId: premiumCalculation.opportunityActivityId });
                if (documents.length > 0) {
                    for (const document of documents) {
                        if (document.id) {
                            const index = existingDocumentIds.indexOf(document.id);
                            if (index !== -1)
                                existingDocumentIds.splice(index, 1);
                            // Use updateDocument for updating
                            await this.opportunityRepository.updateDocument(entityManager, document.id, document.documentId, document.documentTypeLid, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.PREMIUM_CALCULATION_DOCUMENT_MAP);
                        }
                        else {
                            const documentRecord = {
                                documentId: document.documentId,
                                documentTypeLid: document.documentTypeLid,
                                opportunityActivityId: premiumCalculation.opportunityActivityId,
                            };
                            await this.opportunityRepository.savePremiumCalculationDocuments(entityManager, [documentRecord]);
                        }
                    }
                }
                // Delete remaining documents that were not updated
                if (existingDocumentIds.length > 0) {
                    await this.opportunityRepository.deleteFileUploadByIds(constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.FILE_UPLOAD, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.PREMIUM_CALCULATION_DOCUMENT_MAP, constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.DOCUMENT_ID, { id: (0, typeorm_2.In)(existingDocumentIds) }, constants_1.MAPPED_DATA_DELETION.SOFT_DELETE);
                    await this.opportunityRepository.deleteEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.PREMIUM_CALCULATION_DOCUMENT_MAP, existingDocumentIds, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
                }
            }
            // Build coverDetails response as { [coverMapId]: coverResponse }
            const coverDetailsResponse = {};
            for (const coverMapId of Object.keys(premiumCalculationDetails)) {
                coverDetailsResponse[Number(coverMapId)] =
                    premiumCalculationDetails[coverMapId];
            }
            await this.opportunityActivityMapRepository.update({ id: premiumCalculation.opportunityActivityId }, {
                statusLid: statusLid,
                updatedBy: userId,
            });
            await this.opportunityRepository.updateActivityStatus(premiumCalculation.opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.HELD_COVER_NOTE, statusLid, entityManager);
            return {
                id: premiumCalculation.id,
                opportunityActivityId: premiumCalculation.opportunityActivityId,
                statusLid: premiumCalculation.statusLid,
                remarks: premiumCalculation.remarks,
                coverDetails: coverDetailsResponse,
                documents: documents || [],
            };
        });
    }
    async generateQuoteComparisonReport(dto) {
        try {
            // Validate required fields
            if (!dto ||
                !dto.opportunityActivityId ||
                !dto.brokingSlipVersion ||
                !dto.quoteEntry ||
                !Array.isArray(dto.quoteEntry) ||
                dto.quoteEntry.length === 0) {
                throw new common_1.BadRequestException("Required fields are missing in the request.");
            }
            // Step 1: Fetch opportunity activity map data
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(dto.opportunityActivityId);
            if (!opportunityActivityMapData ||
                !opportunityActivityMapData.opportunityId) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${dto.opportunityActivityId}`);
            }
            const opportunityId = opportunityActivityMapData.opportunityId;
            // Step 2: Fetch broking slip version details for the given version id
            const brokingSlipCoverDetails = await this.opportunityRepository.fetchBrokingSlipCoverDetails(dto.brokingSlipVersion, opportunityId);
            // Step 3: Fetch quote entry details for the given quoteEntry ids
            const quoteEntryDetails = await this.opportunityRepository.fetchQuoteCoverDetails(dto.brokingSlipVersion, dto.quoteEntry);
            // Step 4: Fetch opportunity RFP Cover detail
            const opportunityRfpCoverDetails = await this.opportunityRepository.getRfpCoverDetailsByOpportunityId(opportunityId);
            // Step 5: Collect all unique coverMapIds from brokingSlipCoverDetails and quoteEntryDetails.coverDetails
            const coverIdSet = new Set();
            // Collect from brokingSlipCoverDetails if brokingSlipCovers is true
            if (dto.brokingSlipCovers &&
                Array.isArray(brokingSlipCoverDetails) &&
                brokingSlipCoverDetails?.length > 0) {
                for (const cover of brokingSlipCoverDetails) {
                    if (cover.coverMapId) {
                        coverIdSet.add(cover.coverMapId);
                    }
                }
            }
            // Collect from each quote's coverDetails
            if (Array.isArray(quoteEntryDetails)) {
                for (const quote of quoteEntryDetails) {
                    if (Array.isArray(quote.coverDetails)) {
                        for (const cover of quote.coverDetails) {
                            if (cover.coverMapId) {
                                coverIdSet.add(cover.coverMapId);
                            }
                        }
                    }
                }
            }
            // Collect from opportunityRfpCoverDetails if rfpDetailsCovers is true
            if (dto.rfpDetailsCovers &&
                Array.isArray(opportunityRfpCoverDetails) &&
                opportunityRfpCoverDetails.length > 0) {
                for (const cover of opportunityRfpCoverDetails) {
                    if (cover.coverMapId) {
                        coverIdSet.add(cover.coverMapId);
                    }
                }
            }
            // Convert Set to Array
            const uniqueCoverIds = Array.from(coverIdSet);
            const CoverDetails = await this.opportunityRepository.getOpportunityCoverDetailsById(uniqueCoverIds);
            if (!CoverDetails || CoverDetails.length === 0) {
                throw new common_1.NotFoundException(`No covers found for the provided cover IDs: ${uniqueCoverIds.join(", ")}`);
            }
            // Return the combined data
            const data = {
                // opportunityActivityMapData,
                brokingSlipCoverDetails,
                quoteEntryDetails,
                CoverDetails,
                opportunityRfpCoverDetails,
                brokingSlipCovers: dto.brokingSlipCovers,
                rfpDetailsCovers: dto.rfpDetailsCovers,
            };
            // return data;
            return this.transformQuoteComparisonReport(data);
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteComparisonReportGenerationFailed);
        }
    }
    async getPolicyById(policyId) {
        try {
            const policy = await this.opportunityRepository.getPolicyById(policyId);
            if (!policy) {
                throw new common_1.NotFoundException(`Policy not found for ID: ${policyId}`);
            }
            console.log("Fetched Policy:", policy);
            return policy;
        }
        catch (error) {
            console.error("Error in getPolicyById:", error);
            throw new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to fetch policy.");
        }
    }
    async transformQuoteComparisonReport(data) {
        const { quoteEntryDetails, CoverDetails, opportunityRfpCoverDetails = [], brokingSlipCoverDetails = [], rfpDetailsCovers = false, brokingSlipCovers = false, } = data;
        // Helper to build row objects for each field
        const buildRow = (key, values) => {
            const row = { key };
            values.forEach((val, idx) => {
                row[`quote_${idx + 1}`] = val;
            });
            return row;
        };
        // Extract insurer names for mapping
        const insurerNames = quoteEntryDetails.map((q) => q.insurer?.insurerName || "-");
        // Prepare all premium fields
        const premiumFields = [
            { key: "Net Premium", field: "netPremium" },
            { key: "Premium", field: "basicPremium" },
            { key: "Variance", field: "variance" },
            { key: "Last Year", field: "lastYearPremium" },
            { key: "Total Amount", field: "totalAmount" },
            { key: "Terrorism Cover", field: "terrorismCover" },
            { key: "Brokerage Percent", field: "brokeragePercent" },
            { key: "Quote Received On", field: "quoteReceivedOn" },
            { key: "Insurer Remarks", field: "insurerRemarks" },
        ];
        // Build premiumComparisonSection
        const premiumHeaders = buildRow("Parameters", insurerNames);
        const premiumData = premiumFields.map(({ key, field }) => {
            const values = quoteEntryDetails.map((q) => {
                const value = q[field];
                if (value === undefined || value === null || value === "")
                    return "-";
                // Convert to number if numeric field
                if ([
                    "netPremium",
                    "basicPremium",
                    "variance",
                    "lastYearPremium",
                    "totalAmount",
                    "terrorismCover",
                    "brokeragePercent",
                ].includes(field)) {
                    return isNaN(Number(value)) ? "-" : Number(value);
                }
                return value;
            });
            return buildRow(key, values);
        });
        // --- COVER SECTION LOGIC ---
        // Prepare cover headers
        const coverHeaders = { key: "Cover Details" };
        insurerNames.forEach((name, idx) => {
            coverHeaders[`quote_${idx + 1}`] = name;
        });
        let coverHeaderIndex = insurerNames.length + 1;
        if (rfpDetailsCovers) {
            coverHeaders[`quote_${coverHeaderIndex}`] = "RFP";
            coverHeaderIndex++;
        }
        if (brokingSlipCovers) {
            coverHeaders[`quote_${coverHeaderIndex}`] = "Broking slip";
        }
        // Build cover data rows
        const coverData = CoverDetails.map((cover) => {
            const values = [];
            // 1. Add quoteEntryDetails cover responses
            for (const q of quoteEntryDetails) {
                const found = q.coverDetails?.find((cd) => cd.coverMapId === cover.id);
                values.push(found?.insurerCoverResponse ?? "-");
            }
            // 2. Add RFP cover response if enabled
            if (rfpDetailsCovers) {
                const rfpCover = opportunityRfpCoverDetails.find((rfp) => rfp.coverMapId === cover.id);
                values.push(rfpCover?.coverResponse ?? "-");
            }
            // 3. Add Broking Slip cover response if enabled
            if (brokingSlipCovers) {
                const slipCover = brokingSlipCoverDetails.find((slip) => slip.coverMapId === cover.id);
                values.push(slipCover?.coverResponse ?? "-");
            }
            return buildRow(cover.coverName, values);
        });
        return {
            premiumComparisonSection: {
                headers: premiumHeaders,
                data: premiumData,
            },
            coverDetailSection: {
                headers: coverHeaders,
                data: coverData,
            },
        };
    }
    async transformQuotes(quotes) {
        const quotesArray = Array.isArray(quotes) ? quotes : [quotes];
        return quotesArray.map((quote) => ({
            id: Number(quote?.id),
            opportunityId: Number(quote?.opportunityId),
            opportunityActivityId: Number(quote?.opportunityActivityId),
            brokingSlipId: Number(quote?.brokingSlipId),
            insurerName: quote.insurer?.insurerName ?? null,
            formData: {
                quoteDetails: {
                    insurerId: Number(quote?.insurerId),
                    quoteReceivedOn: new Date(quote?.quoteReceivedOn),
                    basicPremium: Number(quote?.basicPremium),
                    terrorismCover: Number(quote?.terrorismCover),
                },
                taxDetails: quote.taxDetails?.map((tax) => ({
                    tax: Number(tax?.taxLid),
                    taxValue: Number(tax?.taxValue),
                })) ?? [],
                netPremiumDetails: {
                    netPremium: Number(quote?.netPremium),
                    brokeragePercent: Number(quote?.brokeragePercent),
                    insurerRemarks: quote?.insurerRemarks,
                },
                documents: quote.documentMappings?.map((document) => ({
                    documentId: Number(document?.documentId),
                })) ?? [],
                covers: quote.coverDetails?.reduce((acc, cover) => {
                    acc[cover?.coverMapId] = cover?.insurerCoverResponse;
                    return acc;
                }, {}) ?? {},
            },
        }));
    }
    async updateOpportunityQuoteByActivityId(opportunityActivityId, payload, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(payload, constants_1.LOOK_UP_DATA);
            const { mainDocuments, remarksSection, quoteStatusLid } = payload;
            const result = await this.dataSource.transaction(async (entityManager) => {
                // Check if OpportunityQuote exists for this activity
                let opportunityQuote = await this.opportunityRepository.getQuoteDetailsByOpportunityActivityId(entityManager, opportunityActivityId);
                if (opportunityQuote) {
                    // Update existing
                    opportunityQuote.statusLid = quoteStatusLid;
                    opportunityQuote.remarks = remarksSection?.remarks ?? null;
                    await this.opportunityRepository.updateOpportunityQuote(entityManager, opportunityQuote.id, {
                        remarks: opportunityQuote.remarks,
                        statusLid: opportunityQuote.statusLid,
                        opportunityActivityId: opportunityActivityId,
                    });
                }
                else {
                    // Create new
                    opportunityQuote =
                        await this.opportunityRepository.createOpportunityQuoteData({
                            remarks: remarksSection?.remarks ?? null,
                            statusLid: quoteStatusLid,
                        }, opportunityActivityId);
                }
                // Handle mainDocuments logic
                if (Array.isArray(mainDocuments)) {
                    // Get existing document IDs
                    const existingDocumentIds = await this.opportunityRepository.getEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.OPPORTUNITY_QUOTE_DOCUMENT_MAP, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, { opportunityActivityId: opportunityActivityId });
                    if (mainDocuments.length > 0) {
                        for (const document of mainDocuments) {
                            if (document.id) {
                                const index = existingDocumentIds.indexOf(document.id);
                                if (index !== -1)
                                    existingDocumentIds.splice(index, 1);
                                await this.opportunityRepository.updateDocument(entityManager, document.id, document.documentId, document.documentTypeLid, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.OPPORTUNITY_QUOTE_DOCUMENT_MAP);
                            }
                            else {
                                await this.opportunityRepository.saveOpportunityQuoteDocumentMappings(entityManager, [
                                    {
                                        opportunityActivityId: opportunityActivityId,
                                        documentId: document.documentId,
                                        documentTypeLid: document.documentTypeLid,
                                    },
                                ]);
                            }
                        }
                    }
                    // Delete remaining documents that were not updated
                    if (existingDocumentIds.length > 0) {
                        await this.opportunityRepository.deleteFileUploadByIds(constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.FILE_UPLOAD, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.OPPORTUNITY_QUOTE_DOCUMENT_MAP, constants_2.FILE_UPLOAD_TABLE_DELETE_FIELDS.DOCUMENT_ID, { id: (0, typeorm_2.In)(existingDocumentIds) }, constants_1.MAPPED_DATA_DELETION.SOFT_DELETE);
                        await this.opportunityRepository.deleteEntityTableMapIds(constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.OPPORTUNITY_QUOTE_DOCUMENT_MAP, existingDocumentIds, constants_2.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS.ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
                    }
                }
                await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                    statusLid: quoteStatusLid,
                    updatedBy: userId,
                });
                await this.opportunityRepository.updateActivityStatus(opportunityActivityId, constants_1.OPPORTUNITY_ACTIVITY.QUOTE_COMPARISON_REPORT, quoteStatusLid, entityManager);
                const QuoteDetails = await this.getQuoteByOpportunityActivityId(opportunityActivityId);
                return {
                    id: QuoteDetails.id,
                    opportunityActivityId: QuoteDetails.opportunityActivityId,
                    quoteStatusLid: QuoteDetails.statusLid,
                    remarksSection: {
                        remarks: QuoteDetails.dataActivity.remarksSection.remarks,
                    },
                    mainDocuments: mainDocuments,
                };
            });
            return result;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.quoteUpdateFailed);
        }
    }
    async getOpportunityIdByOpportunityActivityId(opportunityActivityId) {
        try {
            return await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving opportunity activity");
        }
    }
    async getPolicyConfirmationCdAccountDetails(opportunityActivityId) {
        try {
            const opportunityActivityMapData = await this.opportunityRepository.getOpportunityActivityById(opportunityActivityId);
            if (!opportunityActivityMapData) {
                throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${opportunityActivityId}`);
            }
            const allActivityData = await this.opportunityRepository.getOpportunityActivitiesByOpportunityId(opportunityActivityMapData.opportunityId);
            const placementSlipActivityId = await this.getPlacementSlipGenerationActivityId(allActivityData);
            if (!placementSlipActivityId) {
                return {
                    cdData: [],
                };
            }
            else {
                const placement = await this.opportunityRepository.getPlacementSlipData(placementSlipActivityId);
                if (!placement) {
                    throw new common_1.NotFoundException("CD account details not found");
                }
                let data = { cdData: [] };
                if (Array.isArray(placement.cdDetails) &&
                    placement.cdDetails.length > 0) {
                    const cdDetail = placement.cdDetails[0];
                    const fields = [
                        { key: "Cheque Amount", value: cdDetail.chequeAmount },
                        { key: "Cheque Date", value: cdDetail.chequeDate },
                        { key: "Cheque Number", value: cdDetail.chequeNumber },
                        { key: "Bank Name", value: cdDetail.bankName },
                    ];
                    data.cdData = fields
                        .filter((field) => field.value !== null &&
                        field.value !== undefined &&
                        field.value !== "")
                        .map((field) => ({
                        key: field.key,
                        value: String(field.value),
                    }));
                }
                return data;
            }
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving opportunity activity");
        }
    }
    async getPlacementSlipGenerationActivityId(allActivityData) {
        if (allActivityData &&
            allActivityData.data &&
            Array.isArray(allActivityData.data.ISG)) {
            for (const stage of allActivityData.data.ISG) {
                if (stage && Array.isArray(stage.activities)) {
                    for (const activity of stage.activities) {
                        if (activity.activityKey ===
                            constants_1.ACTIVITY_KEY.PLACEMENT_SLIP_GENERATION_ACTIVITY) {
                            return activity.opportunityActivityId;
                        }
                    }
                }
            }
        }
        return null;
    }
    async getPlacementSlipGenerationByOwner(allActivityData) {
        if (allActivityData &&
            allActivityData.data &&
            Array.isArray(allActivityData.data.ISG)) {
            for (const stage of allActivityData.data.ISG) {
                if (stage && Array.isArray(stage.activities)) {
                    for (const activity of stage.activities) {
                        if (activity.activityKey ===
                            constants_1.ACTIVITY_KEY.PLACEMENT_SLIP_GENERATION_ACTIVITY) {
                            return stage.owner;
                        }
                    }
                }
            }
        }
        return null;
    }
    async opportunityActivityApproval(opportunityActivityId, userId) {
        try {
            // Validate the opportunity activity ID
            const opportunityActivity = await this.opportunityRepository.opportunityActivityApproval(opportunityActivityId, userId);
            if (opportunityActivity !== null) {
                if (opportunityActivity.opportunityTable ===
                    constants_1.TABLE_NAMES.OPPORTUNITY_RFP_DETAILS_ENTRY) {
                    await this.dataSource.transaction(async (entityManager) => {
                        const assignedUser = await this.employeeService.getAllUsersWithPrivilege(constants_2.ACL_CATEGORY.OPPORTUNITY_ACTIVITY, constants_2.ACL_ACTIONS.UPDATE, constants_1.DEFAULT_EMPLOYEE_PAGE, constants_1.DEFAULT_EMPLOYEE_PAGE_LIMIT);
                        if (!assignedUser) {
                            throw new common_1.NotFoundException(`No userS found with privilages for assigning activity with ID ${opportunityActivity.id}`);
                        }
                        const status = await this.lookUpRepository.findOne({
                            where: { id: opportunityActivity.statusLid },
                        });
                        if (!status) {
                            throw new common_1.NotFoundException(`Status with ID ${opportunityActivity.statusLid} not found`);
                        }
                        if (status.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                            const createTask = await this.opportunityRepository.createOpportunityActivityTaskObject(opportunityActivityId, constants_2.DEFAULT_RFP_DETAILS_ENTRY, constants_2.TASK_TYPE.ASSIGNED, assignedUser[0].userid, userId);
                            if (!createTask) {
                                throw new common_1.NotFoundException(`Assignment Task creation object for opportunity activity ID ${opportunityActivityId} not found`);
                            }
                            await this.taskService.createTask(createTask, entityManager);
                        }
                    });
                }
            }
            return opportunityActivity;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "Error retrieving opportunity activity");
        }
    }
    async getAllPolicies() {
        try {
            const policies = await this.opportunityRepository.getAllPolicies();
            if (!policies || policies.length === 0) {
                throw new common_1.NotFoundException("No policies found.");
            }
            return policies;
        }
        catch (error) {
            console.error("Error in getAllPolicies:", error);
            throw new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to fetch policies.");
        }
    }
    async sendNotification(eventType, url, notifyUserId, sendInAppNotification, sendEmailNotification) {
        try {
            const userEmail = await this.opportunityRepository.getEntityTableMapIds(constants_1.TABLE_NAMES.USER, constants_1.USER_EMAIL, { userId: notifyUserId });
            if (!userEmail || userEmail.length === 0) {
                throw new common_1.NotFoundException(`Email details for the user with ID ${notifyUserId} not found`);
            }
            const eventDetails = await this.notificationUtils.getNotificationDetailsByEvent(eventType);
            const parameters = { [`${eventDetails[0].parameterKey}`]: url };
            if (sendInAppNotification) {
                await axios_1.default.post(`${environment_1.ENV.URL_NOTIFICATION_SERVICE}/notifications`, {
                    eventType: eventType,
                    emailId: userEmail,
                    channel: constants_2.NOTIFICATION_IN_APP,
                    parameters: parameters,
                    userId: [notifyUserId],
                });
            }
            if (sendEmailNotification) {
                await axios_1.default.post(`${environment_1.ENV.URL_NOTIFICATION_SERVICE}/notifications`, {
                    eventType: eventType,
                    emailId: userEmail,
                    channel: constants_2.NOTIFICATION_EMAIL,
                    parameters: parameters,
                    userId: [notifyUserId],
                });
            }
        }
        catch (error) {
            console.log(error);
        }
    }
};
exports.OpportunityService = OpportunityService;
exports.OpportunityService = OpportunityService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(8, (0, typeorm_1.InjectRepository)(entities_1.LookUp)),
    tslib_1.__param(9, (0, typeorm_1.InjectRepository)(entities_1.OpportunityActivityMap)),
    tslib_1.__param(10, (0, typeorm_1.InjectRepository)(entities_1.Opportunity)),
    tslib_1.__param(11, (0, typeorm_1.InjectRepository)(entities_1.Meeting)),
    tslib_1.__param(12, (0, typeorm_1.InjectRepository)(entities_1.OpportunityFinalNegotiation)),
    tslib_1.__param(13, (0, typeorm_1.InjectRepository)(entities_1.DataValidation)),
    tslib_1.__param(14, (0, typeorm_1.InjectRepository)(entities_1.KdmMeeting)),
    tslib_1.__param(15, (0, typeorm_1.InjectRepository)(entities_1.OpportunityHandOverMeet)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.DataSource !== "undefined" && typeorm_2.DataSource) === "function" ? _a : Object, typeof (_b = typeof opportunity_repository_1.OpportunityRepository !== "undefined" && opportunity_repository_1.OpportunityRepository) === "function" ? _b : Object, typeof (_c = typeof look_up_service_1.LookUpService !== "undefined" && look_up_service_1.LookUpService) === "function" ? _c : Object, typeof (_d = typeof lookup_validation_1.LookUpValidationService !== "undefined" && lookup_validation_1.LookUpValidationService) === "function" ? _d : Object, typeof (_e = typeof task_service_1.TaskService !== "undefined" && task_service_1.TaskService) === "function" ? _e : Object, typeof (_f = typeof employee_service_1.EmployeeService !== "undefined" && employee_service_1.EmployeeService) === "function" ? _f : Object, typeof (_g = typeof meeting_service_1.MeetingService !== "undefined" && meeting_service_1.MeetingService) === "function" ? _g : Object, typeof (_h = typeof notification_utils_1.NotificationUtils !== "undefined" && notification_utils_1.NotificationUtils) === "function" ? _h : Object, typeof (_j = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _j : Object, typeof (_k = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _k : Object, typeof (_l = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _l : Object, typeof (_m = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _m : Object, typeof (_o = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _o : Object, typeof (_p = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _p : Object, typeof (_q = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _q : Object, typeof (_r = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _r : Object])
], OpportunityService);
